(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["neroo-pdp-details-v1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('neroo-manual-video')) {
    customElements.define('neroo-manual-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const cover = this.querySelector('.neroo-pacc__video-cover');
        if (!cover) return;
        this.initialized = true;
        let source, videoId;
        try {
          const raw = this.dataset.videoUrl.trim();
          source = new URL(/^[\w-]{11}$/.test(raw) ? 'https://www.youtube.com/watch?v=' + raw : raw.startsWith('//') ? 'https:' + raw : /^https?:\/\//i.test(raw) ? raw : 'https://' + raw);
          const host = source.hostname.toLowerCase();
          if (!['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com', 'youtu.be', 'www.youtu.be'].includes(host)) return;
          const parts = source.pathname.split('/').filter(Boolean);
          videoId = host.endsWith('youtu.be') ? parts[0] : source.searchParams.get('v') || (['embed', 'shorts', 'live'].includes(parts[0]) ? parts[1] : '');
          if (!/^[\w-]{11}$/.test(videoId)) return;
        } catch (_) { return; }

        const image = document.createElement('img');
        image.src = 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
        image.alt = '';
        image.width = 480;
        image.height = 360;
        image.loading = 'lazy';
        image.addEventListener('error', () => image.remove(), { once: true });
        cover.prepend(image);
        cover.setAttribute('role', 'button');
        cover.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); cover.click(); }
        });
        cover.addEventListener('click', event => {
          if (event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const embed = new URL('https://www.youtube.com/embed/' + videoId);
          embed.search = source.search;
          embed.searchParams.delete('v');
          // Keep timestamps in existing share links when opening the embedded player.
          const timestamp = source.searchParams.get('t') || source.hash.match(/(?:^#|[&])t=([^&]+)/)?.[1];
          if (timestamp && !embed.searchParams.has('start')) {
            const time = timestamp.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/);
            if (time) embed.searchParams.set('start', String(Number(time[1] || 0) * 3600 + Number(time[2] || 0) * 60 + Number(time[3] || 0)));
          }
          embed.searchParams.delete('t');
          embed.searchParams.set('autoplay', '1');
          embed.searchParams.set('playsinline', '1');
          const frame = document.createElement('iframe');
          frame.src = embed.href;
          frame.title = this.dataset.videoTitle || 'Handleidingvideo';
          frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          this.replaceChildren(frame);
          frame.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neroo-verkoopblok"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ICOON = {
    plus: '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M8 3v10M3 8h10"/></svg>',
    min: '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M3 8h10"/></svg>',
    kruis: '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="m4 4 8 8M12 4l-8 8"/></svg>',
    slot: '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M4.5 7V5a3.5 3.5 0 0 1 7 0v2M3.5 7h9v6.5h-9z"/></svg>',
    pijl: '<svg class="neroo-vb__groep-pijl" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m3 6 5 5 5-5"/></svg>',
    verder: '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M3 8h10M9 4l4 4-4 4"/></svg>',
    info: '<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M8 7.2v4"/><circle cx="8" cy="4.9" r="1" fill="currentColor"/></svg>',
    label: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 2H2v10l9.29 9.29a1 1 0 0 0 1.42 0l8.58-8.58a1 1 0 0 0 0-1.42L12 2Z"/><circle cx="7" cy="7" r="1.5"/></svg>',
    vink: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="m8.5 12 2.5 2.5 4.5-5"/></svg>'
  };

  // Iconen voor de sets (badges). Welk icoon een set krijgt kies je in
  // Setify; de namen zijn gelijk aan die in de app. Een naam die hier niet
  // staat geeft geen icoon.
  var SET_ICONEN = {
    appartement: '<rect x="5" y="3" width="14" height="18" rx="1.5"/><path d="M9 7h2M13 7h2M9 10.5h2M13 10.5h2M9 14h2M13 14h2"/><path d="M10.5 21v-3.5h3V21"/>',
    tussenwoning: '<path d="M2 12l3.5-3.5L9 12l3-3.5 3 3.5 3.5-3.5L22 12"/><path d="M3.5 10.8V20h17v-9.2"/><path d="M9 12v8M15 12v8"/>',
    vrijstaand: '<path d="M3.5 11.5 12 4.5l8.5 7"/><path d="M5.5 10v9.5h13V10"/><path d="M10 19.5v-5h4v5"/><path d="M16.5 8.2V5.5h-2"/><path d="M2 19.5h20"/>',
    huis: '<path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 9.8V20h13V9.8"/><path d="M10 20v-5.5h4V20"/>',
    // De drie schilden komen uit Lucide (shield, shield-half, shield-check).
    // ISC License, Copyright (c) Lucide Icons and Contributors.
    schild: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>',
    schild_half: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="M12 22V2"/>',
    schild_vink: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>',
    slot: '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/><path d="M12 14.5v2"/>',
    ster: '<path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6-5.4-2.8L6.6 19.7l1-6L3.2 9.4l6.1-.9L12 3Z"/>',
    kroon: '<path d="m4 16-1.5-9 5.5 4 4-6 4 6 5.5-4L20 16H4Z"/><path d="M4.5 19.5h15"/>',
    camper: '<path d="M2.5 16.5V8a2 2 0 0 1 2-2H14v10.5"/><path d="M14 9h3.6l3.4 4v3.5h-1.6"/><path d="M9.4 16.5h5.2M2.5 16.5h2.1"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M5.5 9.5h4.5"/>',
    winkel: '<path d="M4.5 10.5V20h15v-9.5"/><path d="M3 8.5 4.8 4h14.4L21 8.5a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0Z"/><path d="M10 20v-5h4v5"/>'
  };

  function setIcoon(naam) {
    if (!naam || !Object.prototype.hasOwnProperty.call(SET_ICONEN, naam)) return '';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      SET_ICONEN[naam] + '</svg>';
  }

  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function nummer(id) {
    var m = String(id == null ? '' : id).match(/(\d+)$/);
    return m ? m[1] : '';
  }

  function el(tag, klasse, html) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function veilig(tekst) {
    return String(tekst == null ? '' : tekst)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function vul(tekst, waarden) {
    var uit = String(tekst || '');
    Object.keys(waarden).forEach(function (naam) {
      uit = uit.split('{' + naam + '}').join(waarden[naam]);
    });
    return uit;
  }

  /** Maakt een instellingen-object met gid's als sleutel bruikbaar op nummer. */
  function opNummer(bron) {
    var uit = {};
    Object.keys(bron || {}).forEach(function (sleutel) { uit[nummer(sleutel)] = bron[sleutel]; });
    return uit;
  }

  /** De kant-en-klare sets van een verkoopblok (nummers), alleen met productgegevens. */
  function kantVan(data) {
    return ((data.config || {}).readySets || [])
      .map(function (set) { return nummer(set && set.product); })
      .filter(function (id) {
        var product = (data.producten || {})[id];
        return product && (product.varianten || []).length;
      });
  }

  function heeftGewoneSets(data) {
    return ((data.config || {}).presets || []).some(function (p) { return p && p.key; });
  }

  /** Laagste prijs van de kant-en-klare sets van een paneel ("vanaf"), in centen. */
  function vanafPrijs(data) {
    var leverbaar = 0, alle = 0;
    kantVan(data).forEach(function (id) {
      (data.producten[id].varianten || []).forEach(function (v) {
        if (!alle || v.prijs < alle) alle = v.prijs;
        if (v.leverbaar && (!leverbaar || v.prijs < leverbaar)) leverbaar = v.prijs;
      });
    });
    return leverbaar || alle;
  }

  /** Alleen links binnen de winkel of naar https; de rest valt weg. */
  function veiligeUrl(url) {
    var schoon = String(url || '').trim();
    if (/^\/(?!\/)/.test(schoon) || /^https:\/\//i.test(schoon)) return schoon;
    if (/^\/\//.test(schoon)) return 'https:' + schoon;
    return '';
  }

  function handleUit(url) {
    var m = String(url || '').match(/\/products\/([a-z0-9][a-z0-9-]*)/i);
    return m ? m[1].toLowerCase() : '';
  }

  /** Kleinere variant van een Shopify-foto. */
  function klein(url) {
    var bron = veiligeUrl(url);
    if (!bron || !/cdn\.shopify\.com|\/cdn\/shop\//.test(bron) || /[?&]width=/.test(bron)) return bron;
    return bron + (bron.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  // Producten die niet in de pagina staan (bijv. de ShieldSense Mini die bij
  // de keuze MINI in een set hoort), één keer per bezoek opgehaald.
  var productCache = {};
  function haalProduct(taalPad, handle) {
    if (!productCache[handle]) {
      productCache[handle] = { klaar: false, product: null, wachtend: [] };
      var item = productCache[handle];
      fetch(taalPad + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && p.variants) {
            item.product = {
              handle: p.handle,
              titel: p.title,
              url: p.url || '/products/' + p.handle,
              beeld: klein(p.featured_image || ''),
              varianten: p.variants.map(function (v) {
                var foto = v.featured_image && (v.featured_image.src || v.featured_image);
                return { titel: v.title || '', opties: v.options || [], beeld: foto ? klein(foto) : null };
              })
            };
          }
        })
        .catch(function () {})
        .then(function () {
          item.klaar = true;
          item.wachtend.forEach(function (fn) { try { fn(); } catch (e) {} });
          item.wachtend = [];
        });
    }
    return productCache[handle];
  }

  function start(sectie) {
    if (sectie.getAttribute('data-vb-klaar')) return;
    var kaart = sectie.querySelector('[data-vb-kaart]');
    var bron = sectie.querySelector('[data-vb-data]');
    if (!kaart || !bron) return;

    var data;
    try { data = JSON.parse(bron.textContent); } catch (e) { return; }
    sectie.setAttribute('data-vb-klaar', '1');

    // Panelen: elk volgend paneel is een eigen verkoopblok met dezelfde
    // algemene gegevens (service, teksten, instellingen) als het eerste.
    var panelen = [data];
    Array.prototype.forEach.call(sectie.querySelectorAll('[data-vb-paneeldata]'), function (el) {
      try { panelen.push(Object.assign({}, data, JSON.parse(el.textContent))); } catch (e) { /* paneel overslaan */ }
    });
    // Elk product staat maar één keer in de pagina; alle panelen delen ze.
    var alleProducten = {};
    panelen.forEach(function (p) { Object.assign(alleProducten, p.producten || {}); });
    panelen.forEach(function (p) { p.producten = alleProducten; });

    // Opbouw: "losse" (losse artikelen met sets als startpunt, zoals altijd),
    // "sets" (eerst een kant-en-klare set) of "zelf" (paneel plus losse
    // artikelen). Kant-en-klare sets alleen als het verkoopblok ze heeft.
    var opbouwSets = data.opbouw === 'sets';
    var gewenst = 'sets';
    function modusVoor(paneelData) {
      if (!kantVan(paneelData).length) return 'losse';
      if (!opbouwSets && heeftGewoneSets(paneelData)) return 'losse';
      return gewenst === 'zelf' ? 'zelf' : 'sets';
    }

    // Wat de klant gekozen heeft blijft staan bij een ander paneel of een
    // andere opbouw, als dat daar ook kan: de set (bijv. Comfort), de plek
    // van de kant-en-klare set en de opties (bijv. Zwart).
    var keuze = { set: '', kant: -1, opties: {} };

    var opruimen = null;
    var huidig = { paneel: -1, modus: '' };
    function toon(index, focus) {
      var modus = modusVoor(panelen[index]);
      if (index === huidig.paneel && modus === huidig.modus) return;
      if (opruimen) opruimen();
      huidig = { paneel: index, modus: modus };
      opruimen = bouw(sectie, kaart, panelen[index], {
        panelen: panelen.length > 1 ? panelen : null,
        paneel: index,
        kiesPaneel: function (i) { toon(i, 'paneel'); },
        modus: modus,
        kiesModus: function (m) { gewenst = m; toon(huidig.paneel, 'modus'); },
        opbouwSets: opbouwSets,
        keuze: keuze,
        focus: focus
      });
    }
    // Bij het openen: het eerste paneel met het vinkje "standaard", anders
    // het eerste paneel.
    var beginPaneel = 0;
    for (var i = panelen.length - 1; i >= 0; i--) {
      if (panelen[i].paneel && panelen[i].paneel.standaard) beginPaneel = i;
    }
    toon(beginPaneel);
  }

  /**
   * Bouwt de kaart voor één verkoopblok. Geeft een functie terug die alles
   * opruimt wat buiten de kaart hangt (vaste balk, waarnemers), zodat de
   * kaart bij het kiezen van een ander paneel opnieuw gebouwd kan worden.
   */
  function bouw(sectie, kaart, data, opties) {
    var waarnemers = [];
    var T = data.teksten || {};
    var config = data.config || {};
    var modus = opties.modus || 'losse';
    var setModus = modus === 'sets';
    var zelfModus = modus === 'zelf';
    var keuze = opties.keuze || { set: '', kant: -1, opties: {} };
    // Met een kant-en-klare set of bij zelf samenstellen zijn er geen
    // gewone sets (badges): de klant begint met een set of met het paneel.
    var presets = modus === 'losse' ? (config.presets || []).filter(function (p) { return p && p.key; }) : [];
    var setInstellingen = opNummer(config.items);
    // Met "Bestaande setkorting verrekenen" (Setify) trekt de checkout de
    // korting die al in een setprijs zit af van de drempelkorting. Dat rekent
    // de sectie niet na: ze toont dan geen balk en geen extra korting. Wat de
    // checkout dan nog geeft is altijd mooi meegenomen, nooit minder dan hier
    // staat.
    var verreken = config.offsetExistingSetDiscount === true;
    var toonBalk = config.showBar !== false && !verreken;

    var tiers = (verreken ? [] : data.tiers || [])
      .map(function (t) {
        return { vanaf: Math.round(Number(t.min) * 100), korting: Math.round(Number(t.amount) * 100), naam: t.label || '' };
      })
      .filter(function (t) { return t.vanaf >= 0 && t.korting > 0; })
      .sort(function (a, b) { return a.vanaf - b.vanaf; });

    // ── Geld ──
    function geld(centen) {
      // Accolades los van elkaar: dit blok mag geen Liquid-uitvoer bevatten.
      var formaat = data.geld || '€{' + '{amount_with_comma_separator}' + '}';
      var waarde = Math.round(centen);
      var negatief = waarde < 0;
      waarde = Math.abs(waarde);
      function opmaak(decimalen, duizend, komma) {
        var delen = (waarde / 100).toFixed(decimalen).split('.');
        delen[0] = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
        return delen.join(komma);
      }
      var uit = formaat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, soort) {
        switch (soort) {
          case 'amount': return opmaak(2, ',', '.');
          case 'amount_no_decimals': return opmaak(0, ',', '.');
          case 'amount_with_comma_separator': return opmaak(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return opmaak(0, '.', ',');
          case 'amount_with_apostrophe_separator': return opmaak(2, "'", '.');
          case 'amount_with_space_separator': return opmaak(2, ' ', ',');
          default: return opmaak(2, '.', ',');
        }
      });
      uit = uit.replace(/<[^>]*>/g, '');
      return (negatief ? '−' : '') + uit;
    }

    /** Ronde bedragen zonder centen: "€35" in plaats van "€35,00". */
    function geldKort(centen) {
      return geld(centen).replace(/[.,]00(?!\d)/, '');
    }

    // ── Rijen opbouwen ──
    var producten = data.producten || {};
    var rijen = [];
    var rijPerSleutel = {};

    function eersteLeverbaar(product, voorkeur) {
      var varianten = product.varianten || [];
      var gekozen = null;
      varianten.forEach(function (v) { if (String(v.id) === nummer(voorkeur)) gekozen = v; });
      if (gekozen && gekozen.leverbaar) return gekozen;
      for (var i = 0; i < varianten.length; i++) if (varianten[i].leverbaar) return varianten[i];
      return gekozen || varianten[0] || null;
    }

    function voegToe(productId, instelling, thuis, inSet) {
      var product = producten[String(productId)];
      if (!product || !(product.varianten || []).length) return;
      var basis = instelling || {};
      var standaard = eersteLeverbaar(product, basis.variant);
      var los = Boolean(basis.split) && product.varianten.length > 1;

      (los ? product.varianten : [standaard]).forEach(function (variant) {
        var sleutel = los ? 'v' + variant.id : 'p' + product.id;
        var bestaand = rijPerSleutel[sleutel];
        if (bestaand) {
          // Staat het product in de set én in een groep, dan is de groep zijn
          // plek zodra het aantal op nul staat.
          if (bestaand.thuis < 0 && thuis >= 0) bestaand.thuis = thuis;
          return;
        }
        var isStandaard = !los || variant.id === standaard.id;
        var rij = {
          sleutel: sleutel,
          product: product,
          variant: variant,
          los: los,
          vast: Boolean(basis.max1),
          thuis: thuis,
          inSet: inSet,
          perSet: inSet && isStandaard ? (basis.qty || {}) : {},
          aantal: 0,
          zelf: false,
          plek: '',
          volgnummer: rijen.length
        };
        rijen.push(rij);
        rijPerSleutel[sleutel] = rij;
      });
    }

    // Kant-en-klare sets: één rij per set, alleen de gekozen set staat (met
    // 1 stuk) in de lijst. Ze komen vóór de andere rijen.
    var kantIds = kantVan(data);
    var isKant = {};
    kantIds.forEach(function (id) { isKant[id] = true; });
    var kantRijen = [];
    if (setModus) {
      kantIds.forEach(function (id, i) {
        var product = producten[id];
        var rij = {
          sleutel: 'k' + id,
          product: product,
          variant: eersteLeverbaar(product),
          los: false,
          vast: true,
          kant: true,
          thuis: -1,
          inSet: false,
          perSet: {},
          aantal: 0,
          zelf: false,
          plek: '',
          volgnummer: i - kantIds.length
        };
        rijen.push(rij);
        rijPerSleutel[rij.sleutel] = rij;
        kantRijen.push(rij);
      });
    }

    // Losse upsells staan ook in de productlijst van het blok (zo kan Liquid
    // hun gegevens leveren), maar horen niet in de sets. Kant-en-klare sets
    // ook niet: die hebben hun eigen rij.
    var losseInfo = {};
    (config.extras || []).forEach(function (extra) {
      var id = nummer(extra && extra.product);
      if (id) losseInfo[id] = { telt: extra.telt !== false, tekst: extra.tekst || '' };
    });

    (data.setProducten || []).forEach(function (id) {
      if (losseInfo[String(id)] || isKant[String(id)]) return;
      voegToe(id, setInstellingen[String(id)], -1, true);
    });
    (data.groepen || []).forEach(function (groep, index) {
      var instellingen = opNummer((groep.instellingen || {}).items);
      (groep.producten || []).forEach(function (id) {
        if (isKant[String(id)]) return;
        voegToe(id, setInstellingen[String(id)] || instellingen[String(id)], index, false);
      });
    });
    // Staat een losse upsell ook in een groep, dan blijft hij in de groep.
    (config.extras || []).forEach(function (extra) {
      var id = nummer(extra && extra.product);
      if (!losseInfo[id] || rijen.some(function (rij) { return String(rij.product.id) === id; })) return;
      voegToe(id, {}, -1, false);
      if (rijPerSleutel['p' + id]) rijPerSleutel['p' + id].extra = losseInfo[id];
    });

    function leverbaar(rij) { return Boolean(rij.variant && rij.variant.leverbaar); }
    function aantalInSet(rij, sleutel) {
      var n = Math.floor(Number(rij.perSet[sleutel]));
      return n > 0 && leverbaar(rij) ? (rij.vast ? 1 : n) : 0;
    }

    // Bij een ander paneel blijft de gekozen set (bijv. Comfort) gekozen,
    // als dat paneel hem ook heeft.
    function presetMet(sleutel) {
      return presets.filter(function (p) { return p.key === sleutel; })[0];
    }
    var actief = presets.length
      ? (presetMet(keuze.set) || presetMet(config.defaultPreset) || presets[0]).key
      : '';

    function kiesSet(sleutel) {
      actief = sleutel;
      keuze.set = sleutel;
      rijen.forEach(function (rij) {
        var n = aantalInSet(rij, sleutel);
        if (n > 0) { rij.aantal = n; rij.zelf = false; }
        else if (!rij.zelf) rij.aantal = 0;
      });
    }

    // ── Kant-en-klare sets: keuze en opties ──
    var kantKeuze = -1;

    /** Optienamen van een product, zonder Shopify's "Title" bij één uitvoering. */
    function optieNamen(product) {
      return (product.opties || []).filter(function (naam) { return !/^title$/i.test(naam); });
    }

    /**
     * De uitvoering die past bij de gekozen opties (bijv. Paneelkleur Zwart,
     * Accessoires MINI). Opties die het product niet heeft tellen niet mee.
     */
    function variantMet(product, gekozen) {
      var namen = product.opties || [];
      var past = function (v) {
        return namen.every(function (naam, i) {
          return !Object.prototype.hasOwnProperty.call(gekozen, naam) || (v.opties || [])[i] === gekozen[naam];
        });
      };
      var varianten = product.varianten || [];
      return varianten.filter(function (v) { return past(v) && v.leverbaar; })[0] ||
        varianten.filter(past)[0] || null;
    }

    function zetKantVarianten() {
      kantRijen.forEach(function (rij) {
        var v = variantMet(rij.product, keuze.opties);
        if (v) rij.variant = v;
      });
    }

    function kiesKant(index) {
      kantKeuze = index;
      keuze.kant = index;
      kantRijen.forEach(function (rij, i) {
        rij.aantal = i === index && leverbaar(rij) ? 1 : 0;
      });
    }

    function kiesOptie(naam, waarde) {
      var gekozen = Object.assign({}, keuze.opties);
      gekozen[naam] = waarde;
      keuze.opties = gekozen;
      kantRijen.forEach(function (rij) {
        var v = variantMet(rij.product, gekozen);
        // Bestaat die combinatie niet, dan in elk geval de gekozen waarde.
        if (!v) {
          var plek = (rij.product.opties || []).indexOf(naam);
          v = (rij.product.varianten || []).filter(function (x) { return plek >= 0 && (x.opties || [])[plek] === waarde && x.leverbaar; })[0];
        }
        if (v) rij.variant = v;
      });
      if (kantKeuze >= 0) kiesKant(kantKeuze);
    }

    if (setModus && kantRijen.length) {
      zetKantVarianten();
      var beginKant = keuze.kant;
      if (!(beginKant >= 0 && beginKant < kantRijen.length)) beginKant = kantIds.indexOf(nummer(config.defaultReadySet));
      if (beginKant < 0) beginKant = 0;
      // Is de standaardset uitverkocht, dan de eerste die wel leverbaar is.
      if (!leverbaar(kantRijen[beginKant])) {
        for (var k = 0; k < kantRijen.length; k++) if (leverbaar(kantRijen[k])) { beginKant = k; break; }
      }
      kiesKant(beginKant);
    }

    // Zelf samenstellen: het paneel (het eerste product met "max 1") staat
    // erin, de rest op nul.
    if (zelfModus) {
      var paneelRij = rijen.filter(function (rij) { return rij.inSet && rij.vast && leverbaar(rij); })[0];
      if (paneelRij) paneelRij.aantal = 1;
    }

    // ── Rekenen ──
    function kortingBij(subtotaal) {
      var beste = null;
      tiers.forEach(function (t) {
        if (subtotaal >= t.vanaf && (!beste || t.korting > beste.korting)) beste = t;
      });
      return beste;
    }

    // ── Inhoud van een kant-en-klare set (metaveld custom.doos) ──
    // Per regel: aantal | naam | foto | link. Zelfde veld als "Dit zit in je
    // set" op de productpagina, dus niets dubbel bijhouden.
    function doosRegels(product) {
      return String(product.doos || '').split(/\r?\n|<br\s*\/?>/i)
        .map(function (regel) { return regel.split('|').map(function (s) { return s.trim(); }); })
        .filter(function (delen) { return delen[1]; })
        .map(function (delen) {
          return {
            aantal: Math.max(0, parseInt(delen[0], 10) || 0),
            titel: delen[1],
            beeld: klein(delen[2]),
            url: veiligeUrl(delen[3])
          };
        });
    }

    var perHandle = {};
    Object.keys(producten).forEach(function (id) {
      var p = producten[id];
      if (p && p.handle) perHandle[String(p.handle).toLowerCase()] = p;
    });

    /** Product op handle: uit de pagina, of opgehaald (null = bestaat niet, undefined = nog bezig). */
    function productOp(handle) {
      if (perHandle[handle]) return perHandle[handle];
      var item = productCache[handle];
      return item && item.klaar ? item.product : undefined;
    }

    function variantNaar(product, waarde) {
      var w = String(waarde || '').toLowerCase();
      return (product.varianten || []).filter(function (v) {
        return (v.opties || []).concat(v.titel || '').some(function (o) { return String(o).toLowerCase() === w; });
      })[0] || null;
    }

    function woordIn(tekst, woord) {
      var schoon = String(woord || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return Boolean(schoon) && new RegExp('(^|[^a-z0-9])' + schoon + '($|[^a-z0-9])', 'i').test(tekst);
    }

    /**
     * Eén onderdeel van de set, passend bij de gekozen uitvoering. De regel
     * met "paneel" in de naam volgt de optie met "paneel" in de naam
     * (Paneelkleur), de andere regels de andere optie (Accessoires,
     * Magneetkleur). Heeft het onderdeel een uitvoering met die waarde
     * (Wit, Zwart), dan komt zijn foto erbij. Staat de waarde in de naam van
     * de regel ("ShieldSense® Pro of Mini") en heeft het onderdeel hem niet,
     * dan is het een ander product (shieldsense-mini), in het wit.
     * opgehaald: functie die aangeroepen wordt als een product binnen is.
     */
    function onderdeel(regel, rij, opgehaald) {
      var uit = { aantal: regel.aantal, titel: regel.titel, beeld: regel.beeld, url: regel.url, handle: handleUit(regel.url) };
      if (!uit.handle) return uit;
      var namen = rij.product.opties || [];
      var waarden = rij.variant.opties || [];
      var paneelRegel = /paneel/i.test(regel.titel);
      var plek = -1;
      namen.forEach(function (naam, i) {
        if (plek < 0 && !/^title$/i.test(naam) && /paneel/i.test(naam) === paneelRegel) plek = i;
      });
      var waarde = plek >= 0 ? String(waarden[plek] || '') : '';
      if (!waarde) return uit;

      var handle = uit.handle;
      var product = productOp(handle);
      var ander = false;
      if (product ? !variantNaar(product, waarde) && woordIn(regel.titel, waarde) : product !== null && woordIn(regel.titel, waarde)) {
        handle = handle.replace(/-[a-z0-9]+$/, '') + '-' + waarde.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        product = productOp(handle);
        ander = true;
      }
      uit.handle = handle;
      if (product === undefined) {
        if (opgehaald) haalProduct(taalPad, handle).wachtend.push(opgehaald);
        return uit;
      }
      if (!product) return uit;
      var v = (!ander && variantNaar(product, waarde)) || variantNaar(product, 'wit') || (product.varianten || [])[0];
      uit.beeld = (v && v.beeld) || product.beeld || uit.beeld;
      if (ander || /naar keuze/i.test(regel.titel)) uit.titel = product.titel;
      uit.url = product.url || uit.url;
      return uit;
    }

    // ── Configuratieservice ──
    // Werkt zoals op de productpagina: de prijs hangt af van het aantal
    // sensoren, en de namen gaan als eigenschappen mee op de regel van de
    // service. De service telt niet mee voor de kortingsbalk.
    var service = null;
    if (data.service && (data.service.varianten || []).length) {
      var trappen = String(data.service.staffel || '').split(',').map(function (deel) {
        var stukken = deel.split(':');
        var max = parseInt(stukken[1], 10);
        var variant = data.service.varianten.filter(function (v) { return String(v.id) === String(stukken[0]).trim(); })[0];
        return variant && variant.leverbaar && max > 0 ? { variant: variant, max: max } : null;
      }).filter(Boolean).sort(function (a, b) { return a.max - b.max; });

      var labels = {}, heeftLabels = false;
      String(data.service.labels || '').split(/\r?\n/).forEach(function (regel) {
        var delen = regel.split('|').map(function (s) { return s.trim(); });
        if (!delen[0] || !delen[1]) return;
        labels[delen[0].toLowerCase()] = {
          naam: delen[1],
          voorbeelden: (delen[2] || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean)
        };
        heeftLabels = true;
      });

      if (trappen.length && heeftLabels) {
        service = { trappen: trappen, labels: labels, url: data.service.url || '', aan: false, modus: '', namen: {} };
      }
    }

    /** Eén regel per sensor in de set: "Magneetcontact 1", "Magneetcontact 2", … */
    function sensoren() {
      if (!service) return [];
      var perNaam = {}, volgorde = [];
      var tel = function (handle, aantal) {
        var info = service.labels[String(handle || '').toLowerCase()];
        if (!info || !aantal) return;
        if (!perNaam[info.naam]) { perNaam[info.naam] = { info: info, aantal: 0 }; volgorde.push(info.naam); }
        perNaam[info.naam].aantal += aantal;
      };
      rijen.forEach(function (rij) {
        if (!rij.aantal) return;
        // Een kant-en-klare set telt met de sensoren uit zijn inhoud.
        if (rij.kant) {
          doosRegels(rij.product).forEach(function (regel) {
            tel(onderdeel(regel, rij).handle, regel.aantal * rij.aantal);
          });
          return;
        }
        tel(rij.product.handle, rij.aantal);
      });
      var lijst = [];
      volgorde.forEach(function (naam) {
        for (var i = 1; i <= perNaam[naam].aantal; i++) {
          lijst.push({ sleutel: naam + ' ' + i, voorbeeld: perNaam[naam].info.voorbeelden[i - 1] || '' });
        }
      });
      return lijst;
    }

    function serviceVariant(aantal) {
      if (!service || aantal < 1) return null;
      for (var i = 0; i < service.trappen.length; i++) {
        if (aantal <= service.trappen[i].max) return service.trappen[i].variant;
      }
      return service.trappen[service.trappen.length - 1].variant;
    }

    function reken() {
      // telBedrag is wat meetelt voor de drempels: alles behalve losse
      // upsells waarbij "telt mee" uit staat. Zelfde regel als de korting.
      var subtotaal = 0, telBedrag = 0, van = 0, stuks = 0;
      rijen.forEach(function (rij) {
        if (!rij.aantal) return;
        subtotaal += rij.aantal * rij.variant.prijs;
        if (!rij.extra || rij.extra.telt) telBedrag += rij.aantal * rij.variant.prijs;
        van += rij.aantal * Math.max(rij.variant.van || 0, rij.variant.prijs);
        stuks += rij.aantal;
      });
      var tier = kortingBij(telBedrag);
      var korting = tier ? Math.min(tier.korting, telBedrag) : 0;

      var aantalSensoren = sensoren().length;
      var variant = serviceVariant(aantalSensoren);
      var servicePrijs = service && service.aan && variant ? variant.prijs : 0;

      return {
        subtotaal: subtotaal, telBedrag: telBedrag, van: van, stuks: stuks, tier: tier, korting: korting,
        sensoren: aantalSensoren, serviceVariant: variant, servicePrijs: servicePrijs,
        totaal: subtotaal - korting + servicePrijs
      };
    }

    /**
     * Wat een set kost en wat hij normaal kost. "Normaal" is de som van de
     * losse prijzen; staan de van-prijzen aan, dan tellen de
     * vergelijkingsprijzen van de producten mee. Zo is het verschil op de
     * badge gelijk aan "Je bespaart" onderaan de kaart.
     */
    function prijzenVanSet(sleutel) {
      var subtotaal = 0, van = 0;
      rijen.forEach(function (rij) {
        var n = aantalInSet(rij, sleutel);
        subtotaal += n * rij.variant.prijs;
        van += n * Math.max(rij.variant.van || 0, rij.variant.prijs);
      });
      var tier = kortingBij(subtotaal);
      return {
        prijs: subtotaal - (tier ? Math.min(tier.korting, subtotaal) : 0),
        normaal: data.toonVanprijs ? van : subtotaal
      };
    }

    // ── Geraamte ──
    var melding = kaart.querySelector('.neroo-vb__melding');
    kaart.innerHTML = '';
    if (melding) kaart.appendChild(melding);

    var balk = null;
    if (toonBalk && tiers.length) {
      balk = el('div', 'neroo-vb__balk');
      balk.setAttribute('data-vb-schuif', '');
      // De bolletjes staan op gelijke afstand van elkaar, ook als de bedragen
      // dat niet zijn. De hoogste drempel is het eind van het spoor: is die
      // gehaald, dan is de balk vol.
      var punten = '', labels = '';
      tiers.forEach(function (t, i) {
        var plek = (i + 1) / tiers.length;
        punten += '<span class="neroo-vb__balk-punt" data-vb-punt="' + i + '" style="--vb-plek:' + plek + '"></span>';
        labels += '<span class="neroo-vb__balk-label" data-vb-label="' + i + '" style="--vb-plek:' + plek + '">−' +
          veilig(geldKort(t.korting)) + '</span>';
      });
      balk.innerHTML =
        '<p class="neroo-vb__balk-tekst" data-vb-balktekst aria-live="polite"></p>' +
        '<div class="neroo-vb__balk-spoor"><span class="neroo-vb__balk-vulling" data-vb-vulling></span>' + punten + '</div>' +
        '<div class="neroo-vb__balk-labels" aria-hidden="true">' + labels + '</div>';
      kaart.appendChild(balk);
    }

    /**
     * Waar een bedrag op de balk staat, van 0 (begin) tot 1 (eind). Tussen
     * twee bolletjes loopt de vulling gelijkmatig mee met het bedrag.
     */
    function plekOpBalk(bedrag) {
      var vorige = 0;
      for (var i = 0; i < tiers.length; i++) {
        if (bedrag < tiers[i].vanaf) {
          var stuk = tiers[i].vanaf - vorige;
          return (i + (stuk > 0 ? Math.max(0, bedrag - vorige) / stuk : 0)) / tiers.length;
        }
        vorige = tiers[i].vanaf;
      }
      return 1;
    }

    // ── Panelen (alleen als de sectie paneel-blokken heeft) ──
    if (opties.panelen) {
      // Linkje rechts ("Bekijk de verschillen"), in een nieuw tabblad zodat
      // de keuze in de kaart blijft staan.
      var paneelLink = data.panelenLink && data.panelenLinkTekst
        ? '<a class="neroo-vb__kop-link" href="' + veilig(data.panelenLink) + '" target="_blank" rel="noopener">' + veilig(data.panelenLinkTekst) + '</a>'
        : '';
      var paneelBlok = el('div', 'neroo-vb__setblok neroo-vb__paneelblok',
        data.panelenTitel || paneelLink
          ? '<div class="neroo-vb__kop"><span class="neroo-vb__kop-titel">' + veilig(data.panelenTitel || '') + '</span>' + paneelLink + '</div>'
          : '');
      var paneelRij = el('div', 'neroo-vb__panelen');
      paneelRij.setAttribute('role', 'group');
      if (data.panelenTitel) paneelRij.setAttribute('aria-label', data.panelenTitel);
      paneelRij.style.setProperty('--vb-panelen', opties.panelen.length);
      opties.panelen.forEach(function (paneelData, index) {
        var info = paneelData.paneel || {};
        var gekozen = index === opties.paneel;
        // Met kant-en-klare sets staat onder de naam ook de laagste prijs van
        // de sets van dat paneel.
        var vanaf = opties.opbouwSets ? vanafPrijs(paneelData) : 0;
        var paneelKnop = el('button', 'neroo-vb__paneel' + (gekozen ? ' is-actief' : ''),
          '<span class="neroo-vb__paneel-foto">' +
            (info.foto ? '<img src="' + veilig(info.foto) + '" alt="" loading="lazy" width="120" height="120">' : '') +
          '</span>' +
          '<span class="neroo-vb__paneel-naam">' + veilig(info.naam || paneelData.blokNaam || '') + '</span>' +
          (vanaf > 0 ? '<span class="neroo-vb__paneel-vanaf">' + veilig(vul(T.from, { bedrag: geld(vanaf) })) + '</span>' : ''));
        paneelKnop.type = 'button';
        paneelKnop.setAttribute('aria-pressed', gekozen ? 'true' : 'false');
        paneelKnop.addEventListener('click', function () { opties.kiesPaneel(index); });
        paneelRij.appendChild(paneelKnop);
        if (gekozen && opties.focus === 'paneel') setTimeout(function () { paneelKnop.focus(); }, 0);
      });
      paneelBlok.appendChild(paneelRij);
      kaart.appendChild(paneelBlok);
    }

    // ── Kant-en-klare set of zelf samenstellen ──
    if ((setModus || zelfModus) && kantIds.length) {
      var modusRij = el('div', 'neroo-vb__modus');
      modusRij.setAttribute('role', 'group');
      modusRij.setAttribute('aria-label', T.mode_label || '');
      [['sets', T.mode_ready], ['zelf', T.mode_self]].forEach(function (optie) {
        var aan = optie[0] === modus;
        var knopje = el('button', 'neroo-vb__modus-knop' + (aan ? ' is-actief' : ''), veilig(optie[1]));
        knopje.type = 'button';
        knopje.setAttribute('aria-pressed', aan ? 'true' : 'false');
        knopje.addEventListener('click', function () { if (!aan) opties.kiesModus(optie[0]); });
        modusRij.appendChild(knopje);
        if (aan && opties.focus === 'modus') setTimeout(function () { knopje.focus(); }, 0);
      });
      kaart.appendChild(modusRij);
    }

    var setKnoppen = [];
    var optieRij = null;
    if (setModus && kantRijen.length) {
      var kantBlok = el('div', 'neroo-vb__setblok neroo-vb__kantblok',
        '<div class="neroo-vb__kop">' +
          '<span class="neroo-vb__kop-titel">' + veilig(T.ready_label) + '</span>' +
          '<span class="neroo-vb__kop-hint">' + veilig(T.ready_hint) + '</span>' +
        '</div>');
      kantBlok.setAttribute('data-vb-schuif', '');

      // Opties (bijv. Accessoires: Wit, Zwart, MINI) boven de sets. Alleen
      // als de sets ze hebben; de waarden komen uit de gekozen set.
      optieRij = el('div', 'neroo-vb__opties');
      kantBlok.appendChild(optieRij);

      var sets = el('div', 'neroo-vb__sets neroo-vb__sets--kant');
      sets.setAttribute('role', 'group');
      sets.setAttribute('aria-label', T.ready_label || '');
      sets.style.setProperty('--vb-sets', kantRijen.length);
      kantRijen.forEach(function (rij, index) {
        var titel = String(rij.product.titel || '');
        var deel = titel.indexOf(' - ');
        var merk = deel > 0 ? titel.slice(0, deel) : '';
        var naam = deel > 0 ? titel.slice(deel + 3) : titel;
        var knop = el('button', 'neroo-vb__set neroo-vb__kant',
          '<span class="neroo-vb__kant-beeld"><img alt="" loading="lazy" width="120" height="120" data-vb-kantbeeld></span>' +
          (merk ? '<span class="neroo-vb__kant-merk">' + veilig(merk) + '</span>' : '') +
          '<span class="neroo-vb__set-naam">' + veilig(naam) + '</span>' +
          '<span class="neroo-vb__set-prijzen">' +
            '<span class="neroo-vb__set-prijs" data-vb-kantprijs></span>' +
            '<s class="neroo-vb__set-normaal" data-vb-kantvan></s>' +
          '</span>' +
          '<span class="neroo-vb__kant-bespaar" data-vb-kantbespaar></span>');
        knop.type = 'button';
        knop.addEventListener('click', function () {
          if (kantKeuze === index || !leverbaar(rij)) return;
          wijzig(function () { kiesKant(index); });
        });
        setKnoppen.push({ sleutel: 'k' + index, knop: knop, rij: rij });
        sets.appendChild(knop);
      });
      kantBlok.appendChild(sets);
      kaart.appendChild(kantBlok);
    }

    // Kant-en-klare set en zelf samenstellen: de artikelen staan in een eigen
    // omrand vlak met een titel ("Je bestelling" of "Stel je set samen"),
    // los van de setkaarten.
    var lijstBlok = null;
    if (setModus && kantRijen.length) {
      lijstBlok = el('div', 'neroo-vb__setblok neroo-vb__bestelling',
        '<div class="neroo-vb__kop"><span class="neroo-vb__kop-titel">' + veilig(T.order_label) + '</span></div>');
    } else if (zelfModus) {
      lijstBlok = el('div', 'neroo-vb__setblok neroo-vb__bestelling',
        '<div class="neroo-vb__kop">' +
          '<span class="neroo-vb__kop-titel">' + veilig(T.self_label) + '</span>' +
          '<span class="neroo-vb__kop-hint">' + veilig(T.self_hint) + '</span>' +
        '</div>');
    }
    if (lijstBlok) {
      lijstBlok.setAttribute('data-vb-schuif', '');
      kaart.appendChild(lijstBlok);
    }

    function tekenOpties() {
      if (!optieRij) return;
      var bron = kantRijen[kantKeuze >= 0 ? kantKeuze : 0];
      var namen = bron ? optieNamen(bron.product) : [];
      var teken = namen.join('|') + '#' + JSON.stringify(keuze.opties) + '#' + (bron ? bron.variant.id : '');
      if (optieRij.getAttribute('data-teken') === teken) return;
      optieRij.setAttribute('data-teken', teken);
      optieRij.hidden = !namen.length;
      optieRij.innerHTML = namen.map(function (naam) {
        var plek = bron.product.opties.indexOf(naam);
        var waarden = [];
        bron.product.varianten.forEach(function (v) {
          var w = (v.opties || [])[plek];
          if (w && waarden.indexOf(w) === -1) waarden.push(w);
        });
        var huidigeWaarde = (bron.variant.opties || [])[plek];
        return '<div class="neroo-vb__optie">' +
          '<span class="neroo-vb__optie-naam">' + veilig(naam) + '</span>' +
          '<div class="neroo-vb__varianten" role="group" aria-label="' + veilig(naam) + '">' +
          waarden.map(function (w) {
            var kan = bron.product.varianten.some(function (v) { return (v.opties || [])[plek] === w && v.leverbaar; });
            var aan = w === huidigeWaarde;
            var stip = /^(wit|zwart)$/i.test(w) ? '<span class="neroo-vb__kleurstip' + (/zwart/i.test(w) ? ' is-zwart' : '') + '" aria-hidden="true"></span>' : '';
            return '<button type="button" class="neroo-vb__variant' + (aan ? ' is-gekozen' : '') + '" data-vb-optie="' + veilig(naam) + '" data-vb-waarde="' + veilig(w) + '"' +
              ' aria-pressed="' + (aan ? 'true' : 'false') + '"' + (kan ? '' : ' disabled') + '>' + stip + veilig(w) + '</button>';
          }).join('') +
          '</div></div>';
      }).join('');
    }

    if (optieRij) {
      optieRij.addEventListener('click', function (event) {
        var knopje = event.target.closest('[data-vb-optie]');
        if (!knopje || knopje.disabled || knopje.classList.contains('is-gekozen')) return;
        wijzig(function () { kiesOptie(knopje.getAttribute('data-vb-optie'), knopje.getAttribute('data-vb-waarde')); });
      });
    }

    if (presets.length > 1) {
      // Kop en badges horen bij elkaar: zo is duidelijk dat het sets zijn.
      var setBlok = el('div', 'neroo-vb__setblok',
        '<div class="neroo-vb__kop">' +
          '<span class="neroo-vb__kop-titel">' + veilig(T.sets_label) + '</span>' +
          '<span class="neroo-vb__kop-hint">' + veilig(T.sets_hint) + '</span>' +
        '</div>');
      setBlok.setAttribute('data-vb-schuif', '');

      var sets = el('div', 'neroo-vb__sets');
      sets.setAttribute('role', 'group');
      sets.setAttribute('aria-label', T.sets_label || '');
      sets.style.setProperty('--vb-sets', presets.length);
      presets.forEach(function (preset) {
        var icoon = setIcoon(preset.icon);
        var prijzen = prijzenVanSet(preset.key);
        var toonNormaal = data.toonSetNormaal !== false && prijzen.normaal > prijzen.prijs;
        var knop = el('button', 'neroo-vb__set' + (icoon ? ' neroo-vb__set--icoon' : ''),
          (icoon ? '<span class="neroo-vb__set-icoon">' + icoon + '</span>' : '') +
          '<span class="neroo-vb__set-naam">' + veilig(preset.label) + '</span>' +
          (preset.sub ? '<span class="neroo-vb__set-sub">' + veilig(preset.sub) + '</span>' : '') +
          '<span class="neroo-vb__set-prijzen">' +
            '<span class="neroo-vb__set-prijs">' + veilig(geld(prijzen.prijs)) + '</span>' +
            (toonNormaal
              ? '<s class="neroo-vb__set-normaal"><span class="neroo-vb__alleen-lezer">' + veilig(T.set_normal) + ' </span>' +
                veilig(geld(prijzen.normaal)) + '</s>'
              : '') +
          '</span>');
        knop.type = 'button';
        knop.addEventListener('click', function () {
          if (actief === preset.key && !gewijzigd()) return;
          wijzig(function () { kiesSet(preset.key); });
        });
        setKnoppen.push({ sleutel: preset.key, knop: knop });
        sets.appendChild(knop);
      });
      kaart.appendChild(setBlok);
    }

    // Met sets staan de artikelen direct onder de badges, in één vlak met de
    // gekozen badge: zijn rand en achtergrond lopen om de hele set heen.
    var setLijst = el('ul', 'neroo-vb__lijst');
    setLijst.setAttribute('role', 'list');
    // Zelf samenstellen: onder het groene vlak een eigen blok "Vaak gekozen
    // bij dit paneel" met de artikelen van het blok die nog op 0 staan.
    var suggestieBlok = null, suggestieLijst = null;
    if (lijstBlok) {
      setLijst.classList.add('neroo-vb__lijst--set');
      lijstBlok.appendChild(setLijst);
      if (zelfModus) {
        suggestieBlok = el('div', 'neroo-vb__setblok neroo-vb__suggesties',
          '<div class="neroo-vb__kop"><span class="neroo-vb__kop-titel">' + veilig(T.suggestions_label) + '</span></div>');
        suggestieBlok.setAttribute('data-vb-schuif', '');
        suggestieLijst = el('ul', 'neroo-vb__lijst');
        suggestieLijst.setAttribute('role', 'list');
        suggestieBlok.appendChild(suggestieLijst);
        kaart.appendChild(suggestieBlok);
      }
    } else if (setKnoppen.length) {
      var setKeuze = el('div', 'neroo-vb__setkeuze');
      setLijst.classList.add('neroo-vb__lijst--set');
      setKeuze.appendChild(sets);
      setKeuze.appendChild(setLijst);
      setBlok.appendChild(setKeuze);
    } else {
      kaart.appendChild(setLijst);
    }

    var extra = el('div', 'neroo-vb__extra');
    var groepen = [];
    (data.groepen || []).forEach(function (groep, index) {
      var heeftRijen = rijen.some(function (rij) { return rij.thuis === index; });
      if (!heeftRijen) { groepen.push(null); return; }

      var wrap = el('div', 'neroo-vb__groep');
      wrap.setAttribute('data-vb-schuif', '');
      var paneelId = 'neroo-vb-paneel-' + nummer(data.blokId) + '-' + index;
      var kop = el('button', 'neroo-vb__groep-kop',
        '<span class="neroo-vb__groep-naam">' + veilig(groep.naam) + '</span>' +
        '<span class="neroo-vb__groep-aantal" data-vb-teller></span>' + ICOON.pijl);
      kop.type = 'button';
      kop.setAttribute('aria-controls', paneelId);
      var paneel = el('div', 'neroo-vb__groep-paneel');
      paneel.id = paneelId;
      var binnen = el('div', 'neroo-vb__groep-binnen');
      var lijst = el('ul', 'neroo-vb__lijst');
      lijst.setAttribute('role', 'list');
      var leeg = el('p', 'neroo-vb__groep-leeg', veilig(T.all_added));
      leeg.hidden = true;
      binnen.appendChild(lijst);
      binnen.appendChild(leeg);
      paneel.appendChild(binnen);
      wrap.appendChild(kop);
      wrap.appendChild(paneel);

      var item = { wrap: wrap, kop: kop, lijst: lijst, leeg: leeg, teller: kop.querySelector('[data-vb-teller]'), open: false };
      kop.addEventListener('click', function () {
        // Eén groep tegelijk open: de andere klappen dicht.
        var openen = !item.open;
        groepen.forEach(function (ander) { if (ander && ander !== item && ander.open) zetOpen(ander, false); });
        zetOpen(item, openen);
      });
      groepen.push(item);
      extra.appendChild(wrap);
    });

    function zetOpen(item, open) {
      item.open = open;
      item.wrap.classList.toggle('is-open', open);
      item.kop.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    var echteGroepen = groepen.filter(Boolean);

    // Zijpaneel (instelling): de groepen staan achter de knop "Maak je set
    // compleet" en openen in een paneel aan de zijkant (telefoon: van
    // onderen). Een artikel blijft daar staan als het erbij komt; in de lijst
    // verschijnt dan een tweede regel.
    var ladeAan = data.zijpaneel === true && echteGroepen.length > 0;
    var lade = null, ladeKnop = null;
    if (ladeAan) {
      var ladeTitelId = 'neroo-vb-lade-' + nummer(data.blokId);
      lade = el('dialog', 'neroo-vb__lade',
        '<div class="neroo-vb__lade-kop">' +
          '<h3 class="neroo-vb__lade-titel" id="' + ladeTitelId + '">' + veilig(T.extras_heading) + '</h3>' +
          '<button type="button" class="neroo-vb__lade-weg" data-vb-ladedicht aria-label="' + veilig(T.tip_close) + '">' + ICOON.kruis + '</button>' +
        '</div>' +
        '<div class="neroo-vb__lade-inhoud" data-vb-ladeinhoud></div>' +
        '<div class="neroo-vb__lade-voet">' +
          '<span class="neroo-vb__lade-totaal"><span>' + veilig(T.drawer_total) + '</span><strong data-vb-ladetotaal></strong></span>' +
          '<button type="button" class="neroo-btn neroo-btn--primary neroo-vb__lade-klaar" data-vb-ladedicht>' + veilig(T.drawer_done) + '</button>' +
        '</div>');
      lade.setAttribute('aria-labelledby', ladeTitelId);
      var ladeInhoud = lade.querySelector('[data-vb-ladeinhoud]');
      echteGroepen.forEach(function (item) { ladeInhoud.appendChild(item.wrap); });
      sectie.appendChild(lade);

      ladeKnop = el('button', 'neroo-vb__lade-knop',
        '<span class="neroo-vb__lade-plus">' + ICOON.plus + '</span>' +
        '<span class="neroo-vb__lade-knoptekst">' + veilig(T.extras_heading) + '</span>' +
        '<span class="neroo-vb__groep-aantal" data-vb-ladeteller hidden></span>' + ICOON.verder);
      ladeKnop.type = 'button';
      ladeKnop.setAttribute('aria-haspopup', 'dialog');
      ladeKnop.setAttribute('data-vb-schuif', '');
      extra.insertBefore(ladeKnop, extra.firstChild);

      var scrollStand = '';
      var sluitLade = function () { if (lade.open) lade.close(); };
      ladeKnop.addEventListener('click', function () {
        if (lade.open) return;
        scrollStand = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        if (typeof lade.showModal === 'function') lade.showModal();
        else lade.setAttribute('open', '');
      });
      lade.addEventListener('close', function () {
        document.documentElement.style.overflow = scrollStand;
        ladeKnop.focus();
      });
      lade.addEventListener('click', function (event) {
        // Klik naast het paneel (op de achtergrond) of op een sluitknop.
        if (event.target === lade || event.target.closest('[data-vb-ladedicht]')) sluitLade();
      });
    }

    if (echteGroepen.length && !ladeAan) {
      var extraKop = el('h3', 'neroo-vb__extra-kop', veilig(T.extras_heading));
      extraKop.setAttribute('data-vb-schuif', '');
      extra.insertBefore(extraKop, extra.firstChild);
    }
    if (echteGroepen.length) {
      // Of de eerste groep open staat is een instelling van de sectie.
      var eersteOpen = data.eersteOpen !== false;
      echteGroepen.forEach(function (item, i) { zetOpen(item, eersteOpen && i === 0); });
    }

    // Losse upsells: elk een eigen vinkje, tussen de groepen en de
    // configuratieservice.
    var heeftLosse = rijen.some(function (rij) { return rij.extra; });
    var losseLijst = el('div', 'neroo-vb__losse');
    losseLijst.setAttribute('role', 'list');
    if (heeftLosse) extra.appendChild(losseLijst);

    // Configuratieservice: vinkje onder de laatste groep.
    var serviceEl = null;
    if (service) {
      var keuze = function (modus, icoon, titel, sub) {
        return '<button type="button" class="neroo-vb__keuze" data-vb-modus="' + modus + '" aria-pressed="false">' +
          '<span class="neroo-vb__keuze-icoon">' + icoon + '</span>' +
          '<span class="neroo-vb__keuze-titel">' + veilig(titel) + '</span>' +
          '<span class="neroo-vb__keuze-sub">' + veilig(sub) + '</span></button>';
      };
      serviceEl = el('div', 'neroo-vb__service',
        '<label class="neroo-vb__service-kop">' +
          '<input type="checkbox" class="neroo-vb__service-vink" data-vb-service>' +
          '<span class="neroo-vb__service-tekst">' +
            '<span class="neroo-vb__service-titel">' + veilig(T.service_title) + '</span>' +
            '<span class="neroo-vb__service-uitleg">' + veilig(T.service_text) +
              (service.url ? ' <a href="' + veilig(service.url) + '" target="_blank" rel="noopener">' + veilig(T.service_more) + '</a>' : '') +
            '</span>' +
          '</span>' +
          '<span class="neroo-vb__service-prijs">' +
            '<span class="neroo-vb__prijs-nu" data-vb-serviceprijs></span>' +
            '<span class="neroo-vb__prijs-extra" data-vb-serviceaantal></span>' +
          '</span>' +
        '</label>' +
        '<div class="neroo-vb__service-paneel"><div class="neroo-vb__service-binnen">' +
          '<div class="neroo-vb__keuzes" role="group">' +
            keuze('namen', ICOON.label, T.names_yes_title, T.names_yes_sub) +
            keuze('geen', ICOON.vink, T.names_no_title, T.names_no_sub) +
          '</div>' +
          '<div class="neroo-vb__namen" data-vb-namen hidden>' +
            '<p class="neroo-vb__namen-intro">' + veilig(T.names_intro) + '</p>' +
            '<div class="neroo-vb__namen-velden" data-vb-velden></div>' +
          '</div>' +
          '<p class="neroo-vb__service-fout" data-vb-servicefout role="alert" hidden></p>' +
        '</div></div>');
      serviceEl.setAttribute('data-vb-schuif', '');
      extra.appendChild(serviceEl);
    }

    if (echteGroepen.length || heeftLosse || serviceEl) kaart.appendChild(extra);

    var totaal = el('div', 'neroo-vb__totaal',
      '<div class="neroo-vb__som"><span>' + veilig(T.subtotal) + '</span><span data-vb-subtotaal></span></div>' +
      '<div class="neroo-vb__som neroo-vb__som--korting" data-vb-kortingregel hidden><span data-vb-kortingnaam></span><span data-vb-korting></span></div>' +
      '<div class="neroo-vb__som" data-vb-serviceregel hidden><span>' + veilig(T.service_line) + '</span><span data-vb-servicebedrag></span></div>' +
      '<div class="neroo-vb__som neroo-vb__som--totaal"><span>' + veilig(T.total) + '</span><span class="neroo-vb__totaalbedrag" data-vb-totaal></span></div>' +
      '<span class="neroo-vb__besparing" data-vb-besparing hidden></span>' +
      '<button type="button" class="neroo-btn neroo-btn--primary neroo-vb__knop" data-vb-knop><span data-vb-knoptekst>' + veilig(T.add_to_cart) + '</span></button>' +
      '<p class="neroo-vb__status" data-vb-status role="status" aria-live="polite"></p>' +
      (data.voetregel ? '<p class="neroo-vb__voetregel">' + veilig(data.voetregel) + '</p>' : '') +
      // Linkje naar een andere manier van samenstellen, bijv. de 2D-configurator
      (data.voetLink && data.voetLinkTekst
        ? '<p class="neroo-vb__voetlink"><a href="' + veilig(data.voetLink) + '">' + veilig(data.voetLinkTekst) + ICOON.verder + '</a></p>'
        : ''));
    totaal.setAttribute('data-vb-schuif', '');
    kaart.appendChild(totaal);

    var plak = el('div', 'neroo-vb__plak',
      '<div class="neroo-vb__plak-prijs"><span class="neroo-vb__plak-label">' + veilig(T.total) + '</span>' +
      '<span class="neroo-vb__plak-bedrag" data-vb-plakbedrag></span></div>' +
      '<button type="button" class="neroo-btn neroo-btn--primary neroo-btn--small" data-vb-plakknop>' + veilig(T.add_to_cart) + '</button>');
    plak.setAttribute('aria-hidden', 'true');
    sectie.appendChild(plak);

    var knop = totaal.querySelector('[data-vb-knop]');
    var knopTekst = totaal.querySelector('[data-vb-knoptekst]');
    var plakKnop = plak.querySelector('[data-vb-plakknop]');
    var status = totaal.querySelector('[data-vb-status]');

    // ── Rij-elementen ──
    /** Klein linkje "Bekijk product" (instelling in de sectie), nieuw tabblad. */
    function bekijkLink(url) {
      if (!data.toonBekijk || !url || !T.view_product) return '';
      return '<a class="neroo-vb__bekijk" href="' + veilig(url) + '" target="_blank" rel="noopener">' + veilig(T.view_product) + '</a>';
    }

    function maakRij(rij) {
      if (rij.extra) return maakLos(rij);
      if (rij.kant) return maakKant(rij);
      var v = maakWeergave(rij);
      rij.el = v.el;
      rij.beeld = v.beeld;
      rij.stuks = v.stuks;
      rij.sub = v.sub;
      rij.prijs = v.prijs;
      rij.prijsExtra = v.prijsExtra;
      rij.acties = v.acties;
      rij.pillen = v.pillen;
      // Met het zijpaneel blijft een artikel uit een groep in het zijpaneel
      // staan; zodra het erbij komt staat er een tweede regel in de lijst.
      // Bij zelf samenstellen staan de artikelen van het blok zelf altijd in
      // de lijst.
      if (ladeAan && rij.thuis >= 0 && !(zelfModus && rij.inSet)) rij.tweede = maakWeergave(rij);
      return v.el;
    }

    function maakWeergave(rij) {
      var li = el('li', 'neroo-vb__rij');
      li.setAttribute('data-vb-schuif', '');
      var url = rij.product.url;
      var titel = rij.product.titel + (rij.los && rij.variant.titel ? ' — ' + rij.variant.titel : '');

      var varianten = '';
      if (!rij.los && rij.product.varianten.length > 1) {
        varianten = '<div class="neroo-vb__varianten" role="group" aria-label="' + veilig(T.choose) + '">' +
          rij.product.varianten.map(function (v) {
            return '<button type="button" class="neroo-vb__variant" data-vb-variant="' + v.id + '"' +
              (v.leverbaar ? '' : ' disabled') + '>' + veilig(v.titel) + '</button>';
          }).join('') + '</div>';
      }

      // De foto linkt naar het product, net als de titel. Voor het
      // toetsenbord en de schermlezer is de titel de link; de foto zou
      // dezelfde link alleen maar herhalen. Beide openen in een nieuw
      // tabblad, zodat de samengestelde set in dit tabblad blijft staan.
      // Het groene bolletje met het aantal (zoals op de oplossingen-pagina's)
      // staat bij de foto; het getal staat ook in de teller ernaast.
      var foto = '<img alt="" loading="lazy" width="64" height="64" data-vb-beeld>' +
        '<span class="neroo-vb__rij-stuks" data-vb-stuks hidden></span>';

      li.innerHTML =
        (url
          ? '<a class="neroo-vb__rij-beeld" href="' + veilig(url) + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">' + foto + '</a>'
          : '<div class="neroo-vb__rij-beeld">' + foto + '</div>') +
        '<div class="neroo-vb__rij-info">' +
          (url
            ? '<a class="neroo-vb__rij-titel" href="' + veilig(url) + '" target="_blank" rel="noopener">' + veilig(titel) + '</a>'
            : '<span class="neroo-vb__rij-titel">' + veilig(titel) + '</span>') +
          '<span class="neroo-vb__rij-sub" data-vb-sub></span>' +
          varianten +
          bekijkLink(url) +
        '</div>' +
        '<div class="neroo-vb__rij-rechts">' +
          '<div class="neroo-vb__prijs"><span class="neroo-vb__prijs-nu" data-vb-prijs></span><span class="neroo-vb__prijs-extra" data-vb-prijsextra></span></div>' +
          '<div class="neroo-vb__acties" data-vb-acties></div>' +
        '</div>';

      var weergave = {
        el: li,
        beeld: li.querySelector('[data-vb-beeld]'),
        stuks: li.querySelector('[data-vb-stuks]'),
        sub: li.querySelector('[data-vb-sub]'),
        prijs: li.querySelector('[data-vb-prijs]'),
        prijsExtra: li.querySelector('[data-vb-prijsextra]'),
        acties: li.querySelector('[data-vb-acties]'),
        pillen: Array.prototype.slice.call(li.querySelectorAll('[data-vb-variant]'))
      };

      weergave.pillen.forEach(function (pil) {
        pil.addEventListener('click', function () {
          var id = pil.getAttribute('data-vb-variant');
          var nieuw = rij.product.varianten.filter(function (v) { return String(v.id) === id; })[0];
          if (!nieuw || nieuw === rij.variant) return;
          wijzig(function () { rij.variant = nieuw; });
        });
      });

      li.addEventListener('click', function (event) {
        var doel = event.target.closest('[data-vb-doe]');
        if (!doel || doel.disabled) return;
        var doe = doel.getAttribute('data-vb-doe');
        wijzig(function () {
          if (doe === 'meer') rij.aantal = Math.min(99, rij.aantal + 1);
          if (doe === 'minder') rij.aantal = Math.max(0, rij.aantal - 1);
          if (doe === 'weg') rij.aantal = 0;
          if (doe === 'erbij') rij.aantal = 1;
          if (rij.aantal === 0) rij.zelf = false;
          else if (!aantalInSet(rij, actief)) rij.zelf = true;
        }, !rij.tweede && (doe === 'erbij' || rij.aantal <= 1) ? rij : null);
      });

      return weergave;
    }

    /**
     * De gekozen kant-en-klare set: foto, naam, uitvoering, vast 1 stuk, en
     * uitklapbaar wat erin zit. De foto's van de onderdelen volgen de gekozen
     * uitvoering (kleur, MINI).
     */
    function maakKant(rij) {
      var li = el('li', 'neroo-vb__rij neroo-vb__rij--kant');
      li.setAttribute('data-vb-schuif', '');
      var url = rij.product.url;
      var inhoudId = 'neroo-vb-inhoud-' + nummer(data.blokId) + '-' + rij.product.id;
      var regels = doosRegels(rij.product);
      // "Dit zit in deze Comfort set": de naam na " - " in de producttitel.
      var titel = String(rij.product.titel || '');
      var setNaam = titel.indexOf(' - ') > 0 ? titel.slice(titel.indexOf(' - ') + 3) : titel;
      var foto = '<img alt="" loading="lazy" width="64" height="64" data-vb-beeld>';
      li.innerHTML =
        (url
          ? '<a class="neroo-vb__rij-beeld" href="' + veilig(url) + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">' + foto + '</a>'
          : '<div class="neroo-vb__rij-beeld">' + foto + '</div>') +
        '<div class="neroo-vb__rij-info">' +
          (url
            ? '<a class="neroo-vb__rij-titel" href="' + veilig(url) + '" target="_blank" rel="noopener">' + veilig(rij.product.titel) + '</a>'
            : '<span class="neroo-vb__rij-titel">' + veilig(rij.product.titel) + '</span>') +
          '<span class="neroo-vb__rij-sub" data-vb-sub></span>' +
          (regels.length ? '<span class="neroo-vb__inhoud-kort" data-vb-kort></span>' : '') +
          ((data.toonBekijk && url) || regels.length
            ? '<span class="neroo-vb__rij-links">' + bekijkLink(url) +
              (regels.length
                ? '<button type="button" class="neroo-vb__inhoud-knop" aria-expanded="false" aria-controls="' + inhoudId + '">' +
                  veilig(vul(T.contents, { set: setNaam })) + ICOON.pijl + '</button>'
                : '') +
              '</span>'
            : '') +
        '</div>' +
        '<div class="neroo-vb__rij-rechts">' +
          '<div class="neroo-vb__prijs"><span class="neroo-vb__prijs-nu" data-vb-prijs></span><span class="neroo-vb__prijs-extra" data-vb-prijsextra></span></div>' +
          '<div class="neroo-vb__acties"><span class="neroo-vb__vast" title="' + veilig(T.fixed) + '">' + ICOON.slot + '1×</span></div>' +
        '</div>' +
        (regels.length
          ? '<div class="neroo-vb__inhoud" id="' + inhoudId + '"><div class="neroo-vb__inhoud-binnen">' +
            '<ul class="neroo-vb__inhoud-lijst" role="list" data-vb-inhoud></ul></div></div>'
          : '');

      rij.el = li;
      rij.beeld = li.querySelector('[data-vb-beeld]');
      rij.sub = li.querySelector('[data-vb-sub]');
      rij.prijs = li.querySelector('[data-vb-prijs]');
      rij.prijsExtra = li.querySelector('[data-vb-prijsextra]');
      rij.kort = li.querySelector('[data-vb-kort]');
      rij.inhoud = li.querySelector('[data-vb-inhoud]');

      var knopje = li.querySelector('.neroo-vb__inhoud-knop');
      if (knopje) {
        knopje.addEventListener('click', function () {
          var open = !li.classList.contains('is-open');
          li.classList.toggle('is-open', open);
          knopje.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      return li;
    }

    function werkKantBij(rij) {
      zetBeeld(rij);
      var v = rij.variant;
      var kan = leverbaar(rij);
      rij.sub.textContent = kan ? (v.titel || rij.product.sub || '') : (T.sold_out || '');
      rij.sub.classList.toggle('is-uitverkocht', !kan);
      rij.sub.hidden = !rij.sub.textContent;
      rij.prijs.textContent = geld(v.prijs);
      var extra = v.van > v.prijs ? '<s>' + veilig(geld(v.van)) + '</s>' : '';
      rij.prijsExtra.innerHTML = extra;
      rij.prijsExtra.hidden = !extra;
      tekenInhoud(rij);
    }

    /** Lijst "Dit zit in je set" en de korte regel; opnieuw als een foto binnen is. */
    function tekenInhoud(rij) {
      if (!rij.inhoud) return;
      var opnieuw = function () { if (rij.el.isConnected) tekenInhoud(rij); };
      var delen = doosRegels(rij.product).map(function (regel) { return onderdeel(regel, rij, opnieuw); });
      var teken = JSON.stringify(delen);
      if (rij.inhoud.getAttribute('data-teken') === teken) return;
      rij.inhoud.setAttribute('data-teken', teken);
      rij.kort.textContent = delen.map(function (d) { return (d.aantal ? d.aantal + '× ' : '') + d.titel; }).join(' · ');
      rij.inhoud.innerHTML = delen.map(function (d) {
        var naam = (d.aantal ? d.aantal + '× ' : '') + veilig(d.titel);
        return '<li class="neroo-vb__inhoud-regel">' +
          '<span class="neroo-vb__inhoud-beeld">' + (d.beeld ? '<img src="' + veilig(d.beeld) + '" alt="" loading="lazy" width="40" height="40">' : '') + '</span>' +
          (d.url
            ? '<a class="neroo-vb__inhoud-naam" href="' + veilig(d.url) + '" target="_blank" rel="noopener">' + naam + '</a>'
            : '<span class="neroo-vb__inhoud-naam">' + naam + '</span>') +
          '</li>';
      }).join('');
    }

    function werkKantkaartBij(s) {
      var rij = s.rij, v = rij.variant, knop = s.knop;
      var kan = leverbaar(rij);
      var img = knop.querySelector('[data-vb-kantbeeld]');
      var bron = v.beeld || rij.product.beeld || '';
      if (img.getAttribute('data-bron') !== bron) {
        img.setAttribute('data-bron', bron);
        if (bron) img.src = bron; else img.removeAttribute('src');
      }
      knop.querySelector('[data-vb-kantprijs]').textContent = geld(v.prijs);
      var van = knop.querySelector('[data-vb-kantvan]');
      var heeftVan = v.van > v.prijs;
      van.hidden = !heeftVan;
      van.innerHTML = heeftVan ? '<span class="neroo-vb__alleen-lezer">' + veilig(T.set_normal) + ' </span>' + veilig(geld(v.van)) : '';
      var bespaar = knop.querySelector('[data-vb-kantbespaar]');
      bespaar.textContent = !kan ? (T.sold_out || '') : heeftVan ? vul(T.save, { bedrag: geld(v.van - v.prijs) }) : '';
      bespaar.hidden = !bespaar.textContent;
      bespaar.classList.toggle('is-uitverkocht', !kan);
      knop.classList.toggle('is-uit', !kan);
      knop.setAttribute('aria-disabled', kan ? 'false' : 'true');
    }

    /**
     * Losse upsell: een kaart met vinkje, foto, naam, korte tekst en prijs.
     * Na aanvinken verschijnen de keuze van de uitvoering en het aantal. Het
     * product blijft op zijn plek staan; het gaat niet naar de set.
     */
    function maakLos(rij) {
      var kaartje = el('div', 'neroo-vb__los');
      kaartje.setAttribute('role', 'listitem');
      kaartje.setAttribute('data-vb-schuif', '');

      var varianten = '';
      if (rij.product.varianten.length > 1) {
        varianten = '<div class="neroo-vb__varianten" role="group" aria-label="' + veilig(T.choose) + '">' +
          rij.product.varianten.map(function (v) {
            return '<button type="button" class="neroo-vb__variant" data-vb-variant="' + v.id + '"' +
              (v.leverbaar ? '' : ' disabled') + '>' + veilig(v.titel) + '</button>';
          }).join('') + '</div>';
      }

      kaartje.innerHTML =
        '<label class="neroo-vb__los-kop">' +
          '<input type="checkbox" class="neroo-vb__service-vink" data-vb-losvink>' +
          '<span class="neroo-vb__los-beeld"><img alt="" loading="lazy" width="48" height="48" data-vb-beeld></span>' +
          '<span class="neroo-vb__los-tekst">' +
            '<span class="neroo-vb__los-titel">' + veilig(rij.product.titel) + '</span>' +
            '<span class="neroo-vb__los-uitleg" data-vb-sub></span>' +
            bekijkLink(rij.product.url) +
          '</span>' +
          '<span class="neroo-vb__prijs"><span class="neroo-vb__prijs-nu" data-vb-prijs></span><span class="neroo-vb__prijs-extra" data-vb-prijsextra></span></span>' +
        '</label>' +
        '<div class="neroo-vb__los-paneel"><div class="neroo-vb__los-binnen">' +
          varianten +
          '<div class="neroo-vb__acties" data-vb-acties></div>' +
        '</div></div>';

      rij.el = kaartje;
      rij.beeld = kaartje.querySelector('[data-vb-beeld]');
      rij.sub = kaartje.querySelector('[data-vb-sub]');
      rij.prijs = kaartje.querySelector('[data-vb-prijs]');
      rij.prijsExtra = kaartje.querySelector('[data-vb-prijsextra]');
      rij.acties = kaartje.querySelector('[data-vb-acties]');
      rij.vink = kaartje.querySelector('[data-vb-losvink]');
      rij.pillen = Array.prototype.slice.call(kaartje.querySelectorAll('[data-vb-variant]'));

      rij.vink.addEventListener('change', function () {
        var aan = rij.vink.checked;
        wijzig(function () {
          rij.aantal = aan ? Math.max(1, rij.aantal) : 0;
          rij.zelf = aan;
        });
      });

      rij.pillen.forEach(function (pil) {
        pil.addEventListener('click', function () {
          var id = pil.getAttribute('data-vb-variant');
          var nieuw = rij.product.varianten.filter(function (v) { return String(v.id) === id; })[0];
          if (!nieuw || nieuw === rij.variant) return;
          wijzig(function () { rij.variant = nieuw; });
        });
      });

      // Min bij 1 stuk haalt het vinkje weg.
      rij.acties.addEventListener('click', function (event) {
        var doel = event.target.closest('[data-vb-doe]');
        if (!doel || doel.disabled) return;
        var doe = doel.getAttribute('data-vb-doe');
        wijzig(function () {
          if (doe === 'meer') rij.aantal = Math.min(99, rij.aantal + 1);
          if (doe === 'minder') rij.aantal = Math.max(0, rij.aantal - 1);
          rij.zelf = rij.aantal > 0;
        });
      });

      return kaartje;
    }

    function werkLosBij(rij) {
      var kan = leverbaar(rij);
      var aan = rij.aantal > 0;
      zetBeeld(rij);

      var tekst = kan ? (rij.extra.tekst || rij.product.sub || '') : (T.sold_out || '');
      rij.sub.textContent = tekst;
      rij.sub.hidden = !tekst;
      rij.sub.classList.toggle('is-uitverkocht', !kan);

      rij.vink.checked = aan;
      rij.vink.disabled = !kan && !aan;
      rij.el.classList.toggle('is-aan', aan);
      rij.el.classList.toggle('is-uit', !kan && !aan);

      werkPillenBij(rij);
      werkPrijsBij(rij);

      var teken = aan ? 'teller:' + rij.aantal : 'uit';
      if (rij.acties.getAttribute('data-teken') === teken) return;
      rij.acties.setAttribute('data-teken', teken);
      rij.acties.innerHTML = aan
        ? '<div class="neroo-vb__aantal" role="group" aria-label="' + veilig(T.quantity) + ': ' + veilig(rij.product.titel) + '">' +
            '<button type="button" data-vb-doe="minder" aria-label="' + veilig(T.decrease) + '">' + ICOON.min + '</button>' +
            '<span class="neroo-vb__aantal-getal" aria-live="polite">' + rij.aantal + '</span>' +
            '<button type="button" data-vb-doe="meer" aria-label="' + veilig(T.increase) + '"' + (rij.aantal >= 99 ? ' disabled' : '') + '>' + ICOON.plus + '</button>' +
          '</div>'
        : '';
    }

    // Weergave w: de elementen van een rij. Meestal de rij zelf; met het
    // zijpaneel heeft een rij uit een groep er twee (zijpaneel en lijst).
    function werkPillenBij(rij, w) {
      w = w || rij;
      w.pillen.forEach(function (pil) {
        var gekozen = pil.getAttribute('data-vb-variant') === String(rij.variant.id);
        pil.classList.toggle('is-gekozen', gekozen);
        pil.setAttribute('aria-pressed', gekozen ? 'true' : 'false');
      });
    }

    function werkPrijsBij(rij, w) {
      w = w || rij;
      var v = rij.variant;
      var stuks = Math.max(1, rij.aantal);
      w.prijs.textContent = geld(v.prijs * stuks);
      // De stukprijs staat links van de vergelijkingsprijs. Zo blijft de
      // vergelijkingsprijs recht onder de prijs staan, ook als het aantal
      // verandert.
      var extra = '';
      if (rij.aantal > 1) extra += '<span class="neroo-vb__prijs-stuk">' + veilig(geld(v.prijs)) + ' ' + veilig(T.each) + '</span>';
      if (data.toonVanprijs && v.van > v.prijs) extra += '<s>' + veilig(geld(v.van * stuks)) + '</s>';
      w.prijsExtra.innerHTML = extra;
      w.prijsExtra.hidden = !extra;
    }

    function zetBeeld(rij, w) {
      var beeld = (w || rij).beeld;
      var bron = rij.variant.beeld || rij.product.beeld || '';
      if (beeld.getAttribute('data-bron') === bron) return;
      var eerste = !beeld.getAttribute('data-bron');
      beeld.setAttribute('data-bron', bron);
      if (!bron) { beeld.removeAttribute('src'); return; }
      if (eerste || rustig) { beeld.src = bron; return; }
      beeld.classList.add('is-wissel');
      setTimeout(function () {
        beeld.src = bron;
        beeld.classList.remove('is-wissel');
      }, 180);
    }

    function werkRijBij(rij) {
      if (rij.extra) return werkLosBij(rij);
      if (rij.kant) return werkKantBij(rij);
      werkWeergaveBij(rij, rij, rij.plek);
      if (rij.tweede) werkWeergaveBij(rij, rij.tweede, rij.tweedePlek);
    }

    function werkWeergaveBij(rij, w, plek) {
      var kan = leverbaar(rij);
      zetBeeld(rij, w);

      w.sub.textContent = kan ? (rij.product.sub || '') : (T.sold_out || '');
      w.sub.classList.toggle('is-uitverkocht', !kan);
      w.sub.hidden = !w.sub.textContent;

      werkPillenBij(rij, w);
      werkPrijsBij(rij, w);

      // Grijs als hij uit de set is gehaald; een suggestie bij zelf
      // samenstellen is niet grijs.
      w.el.classList.toggle('is-leeg', rij.aantal === 0 && plek === 'set' && !zelfModus);

      // Aantal bij de foto: alleen in de set, pas vanaf 2 stuks, en uit te
      // zetten in de sectie-instellingen.
      var toonStuks = data.toonStuks !== false && plek === 'set' && rij.aantal > 1;
      w.stuks.hidden = !toonStuks;
      if (toonStuks) w.stuks.textContent = rij.aantal + '×';

      var soort;
      if (!kan) soort = 'niets';
      else if (rij.aantal === 0) soort = 'erbij';
      else if (rij.vast && !rij.zelf) soort = 'vast';
      else if (rij.vast) soort = 'vast-weg';
      else soort = 'teller';

      var teken = soort + ':' + rij.aantal;
      if (w.acties.getAttribute('data-teken') === teken) return;
      w.acties.setAttribute('data-teken', teken);
      var naam = veilig(rij.product.titel);

      if (soort === 'niets') {
        w.acties.innerHTML = '';
      } else if (soort === 'erbij') {
        w.acties.innerHTML = '<button type="button" class="neroo-vb__rond neroo-vb__rond--toevoegen" data-vb-doe="erbij" aria-label="' +
          veilig(T.add) + ': ' + naam + '">' + ICOON.plus + '</button>';
      } else if (soort === 'vast' || soort === 'vast-weg') {
        w.acties.innerHTML = '<span class="neroo-vb__vast" title="' + veilig(T.fixed) + '">' + ICOON.slot + '1×</span>' +
          (soort === 'vast-weg'
            ? '<button type="button" class="neroo-vb__rond neroo-vb__rond--weg" data-vb-doe="weg" aria-label="' + veilig(T.remove) + ': ' + naam + '">' + ICOON.kruis + '</button>'
            : '');
      } else {
        w.acties.innerHTML = '<div class="neroo-vb__aantal" role="group" aria-label="' + veilig(T.quantity) + ': ' + naam + '">' +
          '<button type="button" data-vb-doe="minder" aria-label="' + veilig(T.decrease) + '">' + ICOON.min + '</button>' +
          '<span class="neroo-vb__aantal-getal" aria-live="polite">' + rij.aantal + '</span>' +
          '<button type="button" data-vb-doe="meer" aria-label="' + veilig(T.increase) + '"' + (rij.aantal >= 99 ? ' disabled' : '') + '>' + ICOON.plus + '</button>' +
          '</div>';
      }
    }

    rijen.forEach(maakRij);

    // ── Plaatsen ──
    function plekVan(rij) {
      if (rij.extra) return 'los';
      if (rij.kant) return rij.aantal > 0 ? 'set' : 'weg';
      // Met het zijpaneel blijft een artikel uit een groep in die groep.
      if (rij.tweede) return 'groep';
      if (rij.aantal > 0) return 'set';
      if (zelfModus && rij.inSet) return 'suggestie';
      if (rij.thuis >= 0 && groepen[rij.thuis]) return 'groep';
      return aantalInSet(rij, actief) > 0 || (rij.inSet && Number(rij.perSet[actief]) > 0) ? 'set' : 'weg';
    }

    // Zelf samenstellen: in het groene vlak wat erin zit (het paneel, daarna
    // in de volgorde van toevoegen, ook uit het zijpaneel). Eronder, buiten
    // het vlak, de artikelen van het blok die nog op 0 staan: suggesties met
    // een plusje. Komt er een bij, dan schuift hij omhoog het vlak in.
    var toegevoegdTeller = 0;

    function plaats() {
      var perLijst = [];
      var leg = function (rij, elem, doel) {
        if (!doel) { if (elem.parentNode) elem.parentNode.removeChild(elem); return; }
        var bak = perLijst.filter(function (b) { return b.lijst === doel; })[0];
        if (!bak) { bak = { lijst: doel, items: [] }; perLijst.push(bak); }
        bak.items.push({ rij: rij, el: elem });
      };
      rijen.forEach(function (rij) {
        if (zelfModus) {
          if (rij.aantal > 0 && !rij.toegevoegd) rij.toegevoegd = ++toegevoegdTeller;
          if (!rij.aantal) rij.toegevoegd = 0;
        }
        rij.plek = plekVan(rij);
        leg(rij, rij.el, rij.plek === 'set' ? setLijst
          : rij.plek === 'groep' ? groepen[rij.thuis].lijst
          : rij.plek === 'suggestie' ? suggestieLijst
          : rij.plek === 'los' ? losseLijst : null);
        if (rij.tweede) {
          rij.tweedePlek = rij.aantal > 0 ? 'set' : '';
          leg(rij, rij.tweede.el, rij.tweedePlek ? setLijst : null);
        }
      });

      // Eigen toevoegingen komen onder de producten van de set. Bij zelf
      // samenstellen in de volgorde van toevoegen.
      perLijst.forEach(function (bak) {
        var zelfLijst = zelfModus && bak.lijst === setLijst;
        bak.items.sort(function (a, b) {
          if (zelfLijst) return a.rij.toegevoegd - b.rij.toegevoegd;
          if (bak.lijst === setLijst && a.rij.zelf !== b.rij.zelf) return a.rij.zelf ? 1 : -1;
          return a.rij.volgnummer - b.rij.volgnummer;
        });
        bak.items.forEach(function (item, i) {
          if (bak.lijst.children[i] !== item.el) bak.lijst.insertBefore(item.el, bak.lijst.children[i] || null);
        });
      });
      if (suggestieBlok) suggestieBlok.hidden = !suggestieLijst.children.length;

      groepen.forEach(function (item) {
        if (!item) return;
        var n = item.lijst.children.length;
        item.teller.textContent = n;
        item.teller.hidden = n === 0;
        item.leeg.hidden = n !== 0;
      });
    }

    function gewijzigd() {
      return rijen.some(function (rij) { return rij.aantal !== aantalInSet(rij, actief); });
    }

    // ── Bedragen laten oplopen ──
    var tellers = [];
    function telNaar(elem, doel) {
      var t = tellers.filter(function (x) { return x.elem === elem; })[0];
      if (!t) { t = { elem: elem, nu: doel, id: 0, vangnet: 0 }; tellers.push(t); elem.textContent = geld(doel); return; }
      cancelAnimationFrame(t.id);
      clearTimeout(t.vangnet);
      var direct = function () { t.nu = doel; elem.textContent = geld(doel); };
      if (rustig || document.hidden || t.nu === doel) { direct(); return; }
      var van = t.nu, begin = null, duur = 380;
      function stap(tijd) {
        if (begin === null) begin = tijd;
        var p = Math.min(1, (tijd - begin) / duur);
        var zacht = 1 - Math.pow(1 - p, 3);
        t.nu = Math.round(van + (doel - van) * zacht);
        elem.textContent = geld(t.nu);
        if (p < 1) t.id = requestAnimationFrame(stap);
        else clearTimeout(t.vangnet);
      }
      t.id = requestAnimationFrame(stap);
      // Een browser die niet tekent (tabblad op de achtergrond) slaat de
      // animatie over; het bedrag moet dan toch kloppen.
      t.vangnet = setTimeout(function () { cancelAnimationFrame(t.id); direct(); }, duur + 120);
    }

    function werkTotaalBij() {
      var r = reken();

      var sub = totaal.querySelector('[data-vb-subtotaal]');
      sub.innerHTML = (data.toonVanprijs && r.van > r.subtotaal ? '<s>' + veilig(geld(r.van)) + '</s>' : '') + veilig(geld(r.subtotaal));

      var regel = totaal.querySelector('[data-vb-kortingregel]');
      regel.hidden = r.korting <= 0;
      if (r.korting > 0) {
        totaal.querySelector('[data-vb-kortingnaam]').textContent = r.tier.naam || T.discount;
        totaal.querySelector('[data-vb-korting]').textContent = '−' + geld(r.korting);
      }

      var serviceRegel = totaal.querySelector('[data-vb-serviceregel]');
      serviceRegel.hidden = r.servicePrijs <= 0;
      if (r.servicePrijs > 0) totaal.querySelector('[data-vb-servicebedrag]').textContent = geld(r.servicePrijs);

      telNaar(totaal.querySelector('[data-vb-totaal]'), r.totaal);
      telNaar(plak.querySelector('[data-vb-plakbedrag]'), r.totaal);

      var besparing = totaal.querySelector('[data-vb-besparing]');
      var bespaard = (data.toonVanprijs ? r.van : r.subtotaal) - (r.subtotaal - r.korting);
      besparing.hidden = bespaard <= 0;
      if (bespaard > 0) besparing.textContent = vul(T.you_save, { bedrag: geld(bespaard) });

      var leeg = r.stuks === 0;
      knop.disabled = leeg || bezig;
      plakKnop.disabled = leeg || bezig;

      // Zijpaneel: hoeveel artikelen uit de groepen erbij zitten, en het totaal.
      if (lade) {
        var erbij = rijen.filter(function (rij) { return rij.tweede && rij.aantal > 0; }).length;
        var teller = ladeKnop.querySelector('[data-vb-ladeteller]');
        teller.textContent = vul(T.drawer_added, { aantal: erbij });
        teller.hidden = erbij === 0;
        ladeKnop.classList.toggle('is-gevuld', erbij > 0);
        telNaar(lade.querySelector('[data-vb-ladetotaal]'), r.totaal);
      }

      var plekActief = -1;
      // Zijn alle kant-en-klare sets uitverkocht, dan is er geen gekozen set
      // en ook geen lege bestelling onder de kaarten.
      var kantGekozen = kantRijen.some(function (rij) { return rij.aantal > 0; });
      var actieveSleutel = setModus ? (kantGekozen ? 'k' + kantKeuze : '') : actief;
      if (setModus && lijstBlok) lijstBlok.hidden = !setLijst.children.length;
      setKnoppen.forEach(function (s, i) {
        if (s.sleutel === actieveSleutel) plekActief = i;
        s.knop.classList.toggle('is-actief', s.sleutel === actieveSleutel);
        s.knop.setAttribute('aria-pressed', s.sleutel === actieveSleutel ? 'true' : 'false');
        if (s.rij) werkKantkaartBij(s);
      });
      tekenOpties();
      tekenSetlijn();
      // Staat de gekozen badge aan de rand, dan heeft het vlak daar geen ronde
      // hoek: de rand van de badge loopt er recht in over.
      if (setKnoppen.length && !lijstBlok) {
        setLijst.classList.toggle('is-links', plekActief === 0);
        setLijst.classList.toggle('is-rechts', plekActief === setKnoppen.length - 1);
      }

      if (balk) {
        // Zelfde schaal als de bolletjes, zodat de vulling een bolletje
        // raakt op het moment dat de drempel gehaald is.
        var deel = plekOpBalk(r.telBedrag);
        balk.querySelector('[data-vb-vulling]').style.width =
          deel <= 0 ? '0%' : deel >= 1 ? '100%' : 'calc(8px + (100% - 16px) * ' + deel.toFixed(4) + ')';
        var volgende = null;
        tiers.forEach(function (t, i) {
          var behaald = r.telBedrag >= t.vanaf;
          balk.querySelector('[data-vb-punt="' + i + '"]').classList.toggle('is-behaald', behaald);
          balk.querySelector('[data-vb-label="' + i + '"]').classList.toggle('is-behaald', behaald);
          if (!behaald && !volgende) volgende = t;
        });
        var tekst;
        if (volgende) {
          tekst = vul(r.korting > 0 ? T.bar_next : T.bar_start, {
            bedrag: '<strong>' + veilig(geld(volgende.vanaf - r.telBedrag)) + '</strong>',
            korting: '<strong>' + veilig(geldKort(volgende.korting)) + '</strong>'
          });
        } else {
          tekst = vul(T.bar_reached, { korting: '<strong>' + veilig(geldKort(r.korting)) + '</strong>' });
        }
        balk.querySelector('[data-vb-balktekst]').innerHTML = tekst;
      }
    }

    // ── Soepel verschuiven ──
    function meet() {
      var posities = [];
      Array.prototype.forEach.call(kaart.querySelectorAll('[data-vb-schuif]'), function (node) {
        var r = node.getBoundingClientRect();
        if (r.width || r.height) posities.push({ node: node, top: r.top, left: r.left, breedte: r.width, hoogte: r.height });
      });
      return posities;
    }

    function zichtbaar(node) {
      var paneel = node.closest('.neroo-vb__groep');
      return !paneel || paneel.classList.contains('is-open');
    }

    function schuif(voor, vlieger) {
      if (rustig || !kaart.animate) return;
      var vliegStart = null;

      voor.forEach(function (oud) {
        var node = oud.node;
        if (!node.isConnected) return;
        var nu = node.getBoundingClientRect();
        var dx = oud.left - nu.left, dy = oud.top - nu.top;
        if (vlieger && node === vlieger.el) { vliegStart = oud; return; }
        if (!zichtbaar(node) || (Math.abs(dx) < 1 && Math.abs(dy) < 1)) return;
        node.animate(
          [{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }],
          { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
      });

      // Nieuwe rijen (nog niet gemeten) komen rustig in beeld.
      var gemeten = voor.map(function (o) { return o.node; });
      rijen.forEach(function (rij) {
        if (rij.el.isConnected && gemeten.indexOf(rij.el) === -1 && zichtbaar(rij.el)) {
          rij.el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
            { duration: 280, easing: 'ease-out' });
        }
      });

      if (!vlieger || !vliegStart) return;

      // De rij die van lijst wisselt vliegt als kopie naar zijn nieuwe plek.
      var doelNode = vlieger.el.isConnected && zichtbaar(vlieger.el)
        ? vlieger.el
        : (groepen[vlieger.thuis] ? groepen[vlieger.thuis].kop : null);
      if (!doelNode) return;
      var doel = doelNode.getBoundingClientRect();
      var inBeeld = doelNode === vlieger.el;

      var geest = vlieger.el.cloneNode(true);
      geest.className = 'neroo-vb__rij neroo-vb__geest';
      geest.removeAttribute('data-vb-schuif');
      geest.style.left = vliegStart.left - 12 + 'px';
      geest.style.top = vliegStart.top + 'px';
      geest.style.width = vliegStart.breedte + 24 + 'px';
      document.body.appendChild(geest);

      if (inBeeld) vlieger.el.style.visibility = 'hidden';
      var vlucht = geest.animate(
        [
          { transform: 'none', opacity: 1 },
          {
            transform: 'translate(' + (doel.left - vliegStart.left) + 'px,' + (doel.top - vliegStart.top) + 'px)' + (inBeeld ? '' : ' scale(0.92)'),
            opacity: inBeeld ? 1 : 0
          }
        ],
        { duration: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      var klaar = function () {
        if (geest.parentNode) geest.parentNode.removeChild(geest);
        vlieger.el.style.visibility = '';
      };
      vlucht.onfinish = klaar;
      vlucht.oncancel = klaar;
    }

    // ── Configuratieservice: tekenen en bedienen ──
    var veldenTeken = '';

    function toonServiceFout(tekst) {
      if (!serviceEl) return;
      var fout = serviceEl.querySelector('[data-vb-servicefout]');
      fout.textContent = tekst || '';
      fout.hidden = !tekst;
    }

    function werkServiceBij() {
      if (!serviceEl) return;
      var lijst = sensoren();
      var variant = serviceVariant(lijst.length);

      // Zonder sensoren valt er niets te koppelen.
      serviceEl.hidden = !variant;
      if (!variant) { service.aan = false; service.modus = ''; }

      var vink = serviceEl.querySelector('[data-vb-service]');
      vink.checked = service.aan;
      serviceEl.classList.toggle('is-aan', service.aan);

      if (variant) {
        serviceEl.querySelector('[data-vb-serviceprijs]').textContent = (service.aan ? '' : '+ ') + geld(variant.prijs);
        serviceEl.querySelector('[data-vb-serviceaantal]').textContent =
          vul(lijst.length === 1 && T.service_count_one ? T.service_count_one : T.service_count, { aantal: lijst.length });
      }

      Array.prototype.forEach.call(serviceEl.querySelectorAll('[data-vb-modus]'), function (knopje) {
        var gekozen = knopje.getAttribute('data-vb-modus') === service.modus;
        knopje.classList.toggle('is-gekozen', gekozen);
        knopje.setAttribute('aria-pressed', gekozen ? 'true' : 'false');
      });

      var namen = serviceEl.querySelector('[data-vb-namen]');
      var toonNamen = service.aan && service.modus === 'namen';
      namen.hidden = !toonNamen;

      // Velden alleen opnieuw opbouwen als de lijst sensoren veranderd is;
      // wat al is ingevuld blijft staan.
      var teken = toonNamen ? lijst.map(function (s) { return s.sleutel; }).join('|') : '';
      if (teken === veldenTeken) return;
      veldenTeken = teken;

      var velden = serviceEl.querySelector('[data-vb-velden]');
      velden.innerHTML = '';
      if (!toonNamen) return;
      lijst.forEach(function (sensor, i) {
        var id = 'neroo-vb-naam-' + nummer(data.blokId) + '-' + i;
        var veld = el('div', 'neroo-vb__veld',
          '<label for="' + id + '">' + veilig(sensor.sleutel) + '</label>' +
          '<input type="text" id="' + id + '" maxlength="16" autocomplete="off"' +
          (sensor.voorbeeld ? ' placeholder="' + veilig(vul(T.names_example, { voorbeeld: sensor.voorbeeld })) + '"' : '') + '>');
        var invoer = veld.querySelector('input');
        invoer.value = service.namen[sensor.sleutel] || '';
        invoer.setAttribute('data-vb-sleutel', sensor.sleutel);
        invoer.addEventListener('input', function () {
          service.namen[sensor.sleutel] = invoer.value;
          toonServiceFout('');
        });
        velden.appendChild(veld);
      });
    }

    /**
     * Geeft false en toont waarom als de service nog niet compleet is
     * ingevuld. Alleen de keuze (namen of geen namen) is verplicht; een
     * naamveld leeg laten mag.
     */
    function serviceKlopt() {
      if (!service || !service.aan) return true;
      if (!service.modus) {
        toonServiceFout(T.names_choose_first);
        serviceEl.scrollIntoView({ behavior: rustig ? 'auto' : 'smooth', block: 'center' });
        return false;
      }
      toonServiceFout('');
      return true;
    }

    function serviceRegelVoorWinkelwagen() {
      var r = reken();
      if (!service || !service.aan || !r.serviceVariant) return null;
      var set = presets.filter(function (p) { return p.key === actief; })[0];
      var kantRij = kantRijen.filter(function (rij) { return rij.aantal > 0; })[0];
      var eigenschappen = {};
      eigenschappen[T.prop_service] = T.prop_yes;
      eigenschappen[T.prop_for] = kantRij
        ? kantRij.product.titel + (kantRij.variant.titel ? ' – ' + kantRij.variant.titel : '')
        : data.blokNaam + (set ? ' – ' + set.label : '');
      // Alleen ingevulde namen gaan mee. Is er niets ingevuld, dan is dat
      // hetzelfde als "geen namen"; is een deel ingevuld, dan staat erbij dat
      // de rest genummerd wordt.
      var lijst = sensoren();
      var ingevuld = service.modus === 'namen'
        ? lijst.filter(function (sensor) { return String(service.namen[sensor.sleutel] || '').trim(); })
        : [];
      if (!ingevuld.length) {
        eigenschappen[T.prop_labels] = T.prop_no_names;
      } else {
        if (ingevuld.length < lijst.length) eigenschappen[T.prop_labels] = T.prop_rest_numbered;
        ingevuld.forEach(function (sensor) {
          eigenschappen[sensor.sleutel] = String(service.namen[sensor.sleutel]).trim();
        });
      }
      return { id: r.serviceVariant.id, quantity: 1, properties: eigenschappen };
    }

    if (serviceEl) {
      serviceEl.querySelector('[data-vb-service]').addEventListener('change', function (event) {
        var aan = event.target.checked;
        wijzig(function () {
          service.aan = aan;
          if (!aan) service.modus = '';
          toonServiceFout('');
        });
      });
      Array.prototype.forEach.call(serviceEl.querySelectorAll('[data-vb-modus]'), function (knopje) {
        knopje.addEventListener('click', function () {
          wijzig(function () {
            service.modus = knopje.getAttribute('data-vb-modus');
            toonServiceFout('');
          });
        });
      });
    }

    /** Eén plek waar elke wijziging doorheen gaat: meten, wijzigen, tekenen, schuiven. */
    function wijzig(actie, mogelijkeVlieger) {
      var plekVoor = mogelijkeVlieger ? mogelijkeVlieger.plek : '';
      var voor = meet();
      actie();
      plaats();
      rijen.forEach(werkRijBij);
      werkServiceBij();
      werkTotaalBij();
      zetStatus('', '');
      var vlieger = mogelijkeVlieger && mogelijkeVlieger.plek !== plekVoor ? mogelijkeVlieger : null;
      schuif(voor, vlieger);
    }

    // ── Winkelwagen ──
    var bezig = false;

    function zetStatus(tekst, soort) {
      status.textContent = tekst;
      status.className = 'neroo-vb__status' + (soort ? ' is-' + soort : '');
    }

    // Het pad bepaalt de taal, niet Shopify.routes.root: die staat op deze
    // winkel op "/en/" terwijl de pagina Nederlands is.
    var deel = (window.location.pathname.split('/')[1] || '').toLowerCase();
    var taalPad = (data.talen || []).indexOf(deel) !== -1 && deel !== '' ? '/' + deel : '';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root !== taalPad + '/') {
      window.Shopify.routes.root = taalPad + '/';
    }

    function openWinkelwagen() {
      return fetch(taalPad + '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          ['cart:updated', 'cart:refresh', 'cart-drawer:open'].forEach(function (naam) {
            try { document.dispatchEvent(new CustomEvent(naam, { bubbles: true, detail: { cart: cart } })); } catch (x) {}
            try { window.dispatchEvent(new CustomEvent(naam, { detail: { cart: cart } })); } catch (x) {}
          });
          var lade = document.querySelector('m-cart-drawer');
          var opener = document.querySelector(
            '.m-cart-drawer-button, [data-open-cart-drawer], .m-cart-icon-bubble, .m-header__icon--cart, a.m-header__icon[href*="/cart"]'
          );
          if (opener) setTimeout(function () { opener.click(); }, 150);
          else if (lade && typeof lade.open === 'function') lade.open();
        })
        .catch(function () {});
    }

    function voegToeAanWinkelwagen() {
      if (bezig) return;
      // Met een kant-en-klare set horen de regels bij elkaar, net als op de
      // productpagina: zelfde samenstelling, de set is de hoofdregel. Setify
      // gebruikt dat alleen met "Bestaande setkorting verrekenen" aan.
      var kantRij = kantRijen.filter(function (rij) { return rij.aantal > 0 && leverbaar(rij); })[0];
      var samenstelling = kantRij ? 'vb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8) : '';
      var items = rijen
        .filter(function (rij) { return rij.aantal > 0 && leverbaar(rij); })
        .map(function (rij) {
          var eigenschappen = { _setify_vb: String(nummer(data.blokId)) };
          if (kantRij) {
            eigenschappen._neroo_selection = samenstelling;
            eigenschappen._neroo_product = String(kantRij.product.id);
            eigenschappen._neroo_role = rij === kantRij ? 'main' : 'extra';
          }
          return { id: rij.variant.id, quantity: rij.aantal, properties: eigenschappen };
        });
      if (!items.length) { zetStatus(T.empty, 'fout'); return; }

      if (!serviceKlopt()) return;
      var serviceRegel = serviceRegelVoorWinkelwagen();
      if (serviceRegel) items.push(serviceRegel);

      bezig = true;
      knop.disabled = true;
      plakKnop.disabled = true;
      knop.classList.add('is-bezig');
      knopTekst.textContent = T.adding;
      zetStatus('', '');

      fetch(taalPad + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (res.ok) return res.json();
          return res.json().then(function (fout) {
            throw new Error((fout && (fout.description || fout.message)) || T.error);
          });
        })
        .then(function () {
          if (data.naToevoegen === 'checkout') {
            window.location.href = taalPad + '/checkout';
            return;
          }
          zetStatus(T.added, 'succes');
          return openWinkelwagen();
        })
        .catch(function (fout) {
          zetStatus((fout && fout.message) || T.error, 'fout');
        })
        .then(function () {
          bezig = false;
          knop.classList.remove('is-bezig');
          knopTekst.textContent = T.add_to_cart;
          var leeg = reken().stuks === 0;
          knop.disabled = leeg;
          plakKnop.disabled = leeg;
        });
    }

    knop.addEventListener('click', voegToeAanWinkelwagen);
    plakKnop.addEventListener('click', voegToeAanWinkelwagen);

    // ── Vaste balk op mobiel: alleen als de kaart in beeld is en de knop niet ──
    if ('IntersectionObserver' in window) {
      var kaartInBeeld = false, knopInBeeld = false;
      var werkPlakBij = function () {
        var toon = kaartInBeeld && !knopInBeeld;
        plak.classList.toggle('is-zichtbaar', toon);
        plak.setAttribute('aria-hidden', toon ? 'false' : 'true');
      };
      var kaartKijker = new IntersectionObserver(function (e) { kaartInBeeld = e[0].isIntersecting; werkPlakBij(); });
      var knopKijker = new IntersectionObserver(function (e) { knopInBeeld = e[0].isIntersecting; werkPlakBij(); });
      kaartKijker.observe(kaart);
      knopKijker.observe(knop);
      waarnemers.push(kaartKijker, knopKijker);
    }

    // ── Zwevende kortingsbalk ──
    // De balk is sticky (zie CSS). Hier alleen: onder een zichtbare
    // menubalk blijven, een schaduw tonen als hij zweeft, en wegvagen zodra
    // de knop "In winkelwagen" in beeld is.
    var zweefAan = Boolean(balk && sectie.classList.contains('neroo-vb--zwevend'));
    var zweefLus = 0;
    var zweefTot = 0;
    var zweefTop = -1;

    /** Onderkant van een vaste menubalk bovenin (of 0 als die er niet is). */
    function menubalkOnder() {
      if (!document.elementsFromPoint) return 0;
      var lijst = document.elementsFromPoint(window.innerWidth / 2, 2);
      for (var i = 0; i < lijst.length; i++) {
        for (var e = lijst[i]; e && e !== document.body && e !== document.documentElement; e = e.parentElement) {
          if (sectie.contains(e)) break;
          var positie = getComputedStyle(e).position;
          if (positie !== 'fixed' && positie !== 'sticky') continue;
          var vak = e.getBoundingClientRect();
          if (vak.top <= 2 && vak.height >= 30 && vak.height <= 200) return Math.max(0, Math.round(vak.bottom));
          break;
        }
      }
      return 0;
    }

    function zweefStap() {
      zweefLus = 0;
      var top = menubalkOnder() + 12;
      if (top !== zweefTop) {
        zweefTop = top;
        balk.style.setProperty('--vb-zweef-top', top + 'px');
      }
      var plakt = balk.getBoundingClientRect().top <= top + 1 && kaart.getBoundingClientRect().top < top - 1;
      balk.classList.toggle('is-zwevend', plakt);
      balk.classList.toggle('is-weg', plakt && Boolean(knopInBeeld));
      // Nog even doorgaan na de laatste scroll: een menubalk die in- of
      // uitschuift beweegt nog na.
      if (Date.now() < zweefTot) zweefLus = requestAnimationFrame(zweefStap);
    }

    function zweefBijScroll() {
      zweefTot = Date.now() + 450;
      if (!zweefLus) zweefLus = requestAnimationFrame(zweefStap);
    }

    if (zweefAan) {
      window.addEventListener('scroll', zweefBijScroll, { passive: true });
      window.addEventListener('resize', zweefBijScroll);
      zweefBijScroll();
    }

    // Liggen twee drempels dicht bij elkaar, dan passen hun bedragen niet
    // naast elkaar onder de balk. De rechter blijft, de linker verdwijnt.
    function schikLabels() {
      if (!balk) return;
      var labels = Array.prototype.slice.call(balk.querySelectorAll('.neroo-vb__balk-label'));
      var rand = balk.getBoundingClientRect();
      var gemeten = rand.width >= 120;
      var grens = Infinity;
      for (var i = labels.length - 1; i >= 0; i--) {
        labels[i].classList.remove('is-verborgen');
        labels[i].classList.remove('is-rechts');
        // Zonder breedte (sectie nog niet in beeld) valt er niets te meten.
        if (!gemeten) continue;
        var vak = labels[i].getBoundingClientRect();
        // Een breed bedrag onder het laatste bolletje mag niet buiten de
        // balk steken.
        if (vak.right > rand.right - 4) {
          labels[i].classList.add('is-rechts');
          vak = labels[i].getBoundingClientRect();
        }
        if (vak.right + 6 > grens) labels[i].classList.add('is-verborgen');
        else grens = vak.left;
      }
    }

    // ── Stippellijn van de gekozen set naar "Je bestelling" ──
    // Loopt van achter de gekozen setkaart naar het midden van het groene
    // vlak. Bij de middelste set recht omlaag, anders met twee bochtjes in de
    // ruimte tussen de kaarten en de kop "Je bestelling". De streepjes lopen
    // richting de bestelling (CSS). Posities via offsetTop/offsetLeft: die
    // tellen de schuif-animaties niet mee.
    var setlijn = null, setlijnPad = null, setlijnVorige = '';
    if (setModus && lijstBlok && setKnoppen.length) {
      var SVG = 'http://www.w3.org/2000/svg';
      setlijn = document.createElementNS(SVG, 'svg');
      setlijn.setAttribute('class', 'neroo-vb__setlijn');
      setlijn.setAttribute('aria-hidden', 'true');
      setlijn.setAttribute('focusable', 'false');
      setlijnPad = document.createElementNS(SVG, 'path');
      setlijnPad.setAttribute('fill', 'none');
      setlijn.appendChild(setlijnPad);
      kaart.appendChild(setlijn);
    }

    function plekInKaart(elem) {
      var x = 0, y = 0;
      for (var e = elem; e && e !== kaart; e = e.offsetParent) { x += e.offsetLeft; y += e.offsetTop; }
      return { x: x, y: y, w: elem.offsetWidth, h: elem.offsetHeight };
    }

    function tekenSetlijn() {
      if (!setlijn) return;
      var gekozen = setKnoppen.filter(function (s) { return s.knop.classList.contains('is-actief'); })[0];
      if (!gekozen || lijstBlok.hidden || kaart.offsetWidth < 50) { setlijnPad.setAttribute('d', ''); setlijnVorige = ''; return; }
      var rond = function (n) { return Math.round(n * 10) / 10; };
      var kaartje = plekInKaart(gekozen.knop);
      var vlak = plekInKaart(lijstBlok);
      // Begin en eind een paar pixels achter de kaart en het vlak.
      var x1 = kaartje.x + kaartje.w / 2, y1 = kaartje.y + kaartje.h - 6;
      var x2 = vlak.x + vlak.w / 2, y2 = vlak.y + 6;
      var midden = (kaartje.y + kaartje.h + vlak.y) / 2;
      var d = 'M' + rond(x1) + ' ' + rond(y1);
      var afstand = Math.abs(x2 - x1);
      // Middelste set: recht omlaag, zonder halve pixel scheef.
      if (afstand < 2) x2 = x1;
      if (afstand >= 2) {
        var kant = x2 > x1 ? 1 : -1;
        var r = Math.max(0, Math.min(12, midden - (kaartje.y + kaartje.h), afstand / 2));
        d += ' L' + rond(x1) + ' ' + rond(midden - r) +
          ' A' + rond(r) + ' ' + rond(r) + ' 0 0 ' + (kant > 0 ? 0 : 1) + ' ' + rond(x1 + kant * r) + ' ' + rond(midden) +
          ' L' + rond(x2 - kant * r) + ' ' + rond(midden) +
          ' A' + rond(r) + ' ' + rond(r) + ' 0 0 ' + (kant > 0 ? 1 : 0) + ' ' + rond(x2) + ' ' + rond(midden + r);
      }
      d += ' L' + rond(x2) + ' ' + rond(y2);
      setlijn.setAttribute('viewBox', '0 0 ' + kaart.offsetWidth + ' ' + kaart.offsetHeight);
      if (d === setlijnVorige) return;
      // Andere set gekozen: de lijn komt even opnieuw in beeld.
      var andereSet = setlijnVorige && setlijnVorige.split(' ')[0] !== d.split(' ')[0];
      setlijnVorige = d;
      setlijnPad.setAttribute('d', d);
      if (andereSet && !rustig) {
        setlijn.classList.remove('is-nieuw');
        void setlijn.getBoundingClientRect();
        setlijn.classList.add('is-nieuw');
      }
    }

    if (setlijn) {
      if ('ResizeObserver' in window) {
        var lijnKijker = new ResizeObserver(function () { tekenSetlijn(); });
        lijnKijker.observe(kaart);
        lijnKijker.observe(kantBlok);
        lijnKijker.observe(lijstBlok);
        waarnemers.push(lijnKijker);
      }
      window.addEventListener('resize', tekenSetlijn);
    }

    // ── Eerste keer tekenen ──
    if (actief) kiesSet(actief);
    plaats();
    rijen.forEach(werkRijBij);
    werkServiceBij();
    werkTotaalBij();
    schikLabels();

    // ── Tip bij de tweede regel: "Klik op de naam voor meer informatie" ──
    // Eén keer per bezoek. Verschijnt een halve seconde nadat de tweede
    // regel van de set helemaal in beeld is, en verdwijnt na 8 seconden,
    // met het kruisje of bij een klik ergens in de kaart. Het ballonnetje
    // staat in de ruimte van de eerste regel; daar past het binnen de rand.
    var TIP_SLEUTEL = 'neroo-vb-tip-gezien';
    var tip = null;
    var tipRij = null;
    var tipTimer = 0;
    var tipKijker = null;

    function tipAlGezien() {
      try { return window.sessionStorage.getItem(TIP_SLEUTEL) === '1'; } catch (e) { return false; }
    }

    function stopTipKijker() {
      if (tipKijker) { tipKijker.disconnect(); tipKijker = null; }
    }

    function sluitTip(meteen) {
      clearTimeout(tipTimer);
      stopTipKijker();
      if (!tip) return;
      var weg = tip;
      var rij = tipRij;
      tip = null;
      tipRij = null;
      var haalWeg = function () {
        if (weg.parentNode) weg.parentNode.removeChild(weg);
        if (rij) rij.classList.remove('heeft-tip');
      };
      if (meteen) { haalWeg(); return; }
      weg.classList.remove('is-zichtbaar');
      setTimeout(haalWeg, 220);
    }

    function toonTip() {
      var rij = setLijst.children[1];
      var titel = rij && rij.querySelector('.neroo-vb__rij-titel');
      if (!titel || tip) return;
      try { window.sessionStorage.setItem(TIP_SLEUTEL, '1'); } catch (e) { /* dan elke keer */ }

      tip = el('div', 'neroo-vb__tip',
        '<span class="neroo-vb__tip-tekst">' + ICOON.info + '<span>' + veilig(data.tip) + '</span></span>' +
        '<button type="button" class="neroo-vb__tip-weg" aria-label="' + veilig(T.tip_close) + '">' + ICOON.kruis + '</button>');
      tip.setAttribute('role', 'status');
      tipRij = rij;
      rij.classList.add('heeft-tip');
      rij.appendChild(tip);

      // Het pijltje wijst naar het einde van de eerste regel van de naam.
      var vak = rij.getBoundingClientRect();
      var bereik = document.createRange();
      bereik.selectNodeContents(titel);
      var regels = bereik.getClientRects();
      var tekst = regels.length ? regels[0] : titel.getBoundingClientRect();
      var eind = tekst.right - vak.left;
      var breedte = tip.offsetWidth;
      var links = Math.max(0, Math.min(eind - breedte + 28, vak.width - breedte));
      var pijl = Math.max(16, Math.min(eind - links - 4, breedte - 16));
      tip.style.left = links + 'px';
      tip.style.top = (tekst.top - vak.top - 9) + 'px';
      tip.style.setProperty('--vb-pijl-x', pijl + 'px');

      tip.querySelector('.neroo-vb__tip-weg').addEventListener('click', function (event) {
        event.stopPropagation();
        sluitTip();
      });
      requestAnimationFrame(function () { if (tip) tip.classList.add('is-zichtbaar'); });
      tipTimer = setTimeout(function () { sluitTip(); }, 8000);
    }

    // Meteen weg (vóór de klik zelf iets verandert), zodat een regel die
    // daarna verhuist het ballonnetje niet meeneemt.
    function sluitTipBijKlik(event) {
      if (tip && !tip.contains(event.target)) sluitTip(true);
    }

    // Alleen bij een andere breedte: op de telefoon verandert de hoogte al
    // tijdens het scrollen, als de adresbalk in- en uitschuift.
    var tipVensterBreedte = window.innerWidth;
    function sluitTipBijMaat() {
      if (window.innerWidth !== tipVensterBreedte) sluitTip(true);
    }

    if (data.tip && !tipAlGezien() && 'IntersectionObserver' in window && setLijst.children.length > 1) {
      tipKijker = new IntersectionObserver(function (items) {
        clearTimeout(tipTimer);
        if (!items[0].isIntersecting || items[0].intersectionRatio < 0.98) return;
        tipTimer = setTimeout(function () {
          stopTipKijker();
          if (!tipAlGezien()) toonTip();
        }, 500);
      // Marges: bovenin staat vaak een vaste menubalk (en het ballonnetje
      // zelf boven de regel), onderin op mobiel de vaste balk met het totaal.
      }, { threshold: [0, 1], rootMargin: '-130px 0px -90px 0px' });
      tipKijker.observe(setLijst.children[1]);
      kaart.addEventListener('click', sluitTipBijKlik, true);
      window.addEventListener('resize', sluitTipBijMaat);
    }

    // Opnieuw schikken zodra de balk van breedte verandert. Dat gebeurt niet
    // alleen bij het verkleinen van het venster, maar ook als de sectie eerst
    // onzichtbaar of zonder breedte is opgebouwd.
    var schikTimer = 0;
    var schikLater = function () {
      clearTimeout(schikTimer);
      schikTimer = setTimeout(schikLabels, 120);
    };
    if (balk) {
      if ('ResizeObserver' in window) {
        var balkKijker = new ResizeObserver(schikLater);
        balkKijker.observe(balk);
        waarnemers.push(balkKijker);
      } else {
        window.addEventListener('resize', schikLater);
      }
    }

    return function opruimen() {
      sluitTip(true);
      if (lade) {
        if (lade.open) lade.close();
        if (lade.parentNode) lade.parentNode.removeChild(lade);
      }
      kaart.removeEventListener('click', sluitTipBijKlik, true);
      window.removeEventListener('scroll', zweefBijScroll);
      window.removeEventListener('resize', zweefBijScroll);
      if (zweefLus) cancelAnimationFrame(zweefLus);
      window.removeEventListener('resize', sluitTipBijMaat);
      waarnemers.forEach(function (w) { w.disconnect(); });
      window.removeEventListener('resize', schikLater);
      window.removeEventListener('resize', tekenSetlijn);
      if (setlijn && setlijn.parentNode) setlijn.parentNode.removeChild(setlijn);
      clearTimeout(schikTimer);
      if (plak.parentNode) plak.parentNode.removeChild(plak);
    };
  }

  /**
   * Google-score in het linkerblok. Eén fetch per pagina, gedeeld met de
   * andere neroo-secties via window.__nerooReviewsCache.
   */
  function startReviews(sectie) {
    var blok = sectie.querySelector('[data-vb-reviews]:not([data-vb-klaar])');
    if (!blok) return;
    blok.setAttribute('data-vb-klaar', '1');

    var url = blok.getAttribute('data-proxy');
    if (!url || !window.fetch) return;

    window.__nerooReviewsCache = window.__nerooReviewsCache || {};
    if (!window.__nerooReviewsCache[url]) {
      window.__nerooReviewsCache[url] = fetch(url).then(function (r) { return r.json(); });
    }

    window.__nerooReviewsCache[url].then(function (data) {
      if (!data || typeof data.rating !== 'number') return;
      var score = data.rating.toFixed(1).replace('.', ',');
      blok.querySelector('[data-vb-reviews-score]').textContent = score;

      // Afronden op hele sterren, net als in de andere secties (4,8 = 5 vol).
      var vol = Math.round(data.rating), sterren = '';
      for (var i = 1; i <= 5; i++) {
        sterren += '<span' + (i <= vol ? '' : ' class="neroo-vb__reviews-ster--leeg"') + '>★</span>';
      }
      blok.querySelector('[data-vb-reviews-sterren]').innerHTML = sterren;

      if (data.total) {
        blok.querySelector('[data-vb-reviews-tekst]').textContent =
          vul(blok.getAttribute('data-sjabloon'), { aantal: data.total });
      }
    }).catch(function () {});
  }

  /**
   * Slinger: de stippellijn die de punten om en om verbindt. Van elke cirkel
   * loopt hij omlaag, met een bocht door de ruimte tussen twee punten naar de
   * overkant, en met een bocht de volgende cirkel in.
   */
  function startSlinger(sectie) {
    var laag = sectie.querySelector('[data-vb-slinger]:not([data-vb-klaar])');
    if (!laag) return;
    laag.setAttribute('data-vb-klaar', '');

    var lijst = laag.parentNode;
    var svg = laag.querySelector('svg');
    var pad = laag.querySelector('path');
    var STRAAL = 44;

    function rond(getal) { return Math.round(getal * 10) / 10; }

    function teken() {
      var punten = Array.prototype.filter.call(lijst.children, function (li) {
        return li !== laag && li.querySelector('.neroo-vb__cirkel');
      });
      var breedte = lijst.clientWidth, hoogte = lijst.clientHeight;
      // Zonder breedte (sectie nog niet in beeld) valt er niets te meten.
      if (breedte < 120 || punten.length < 2) { pad.setAttribute('d', ''); return; }
      svg.setAttribute('viewBox', '0 0 ' + breedte + ' ' + hoogte);

      // offsetTop en offsetLeft trekken zich niets aan van de verschuiving
      // waarmee de punten in beeld komen.
      var plekken = punten.map(function (li) {
        var cirkel = li.querySelector('.neroo-vb__cirkel');
        return {
          x: li.offsetLeft + cirkel.offsetLeft + cirkel.offsetWidth / 2,
          y: li.offsetTop + cirkel.offsetTop + cirkel.offsetHeight / 2,
          boven: li.offsetTop,
          onder: li.offsetTop + li.offsetHeight
        };
      });

      var d = 'M' + rond(plekken[0].x) + ' ' + rond(plekken[0].y);
      for (var i = 1; i < plekken.length; i++) {
        var van = plekken[i - 1], naar = plekken[i];
        var afstand = Math.abs(naar.x - van.x);
        // Staan twee cirkels recht onder elkaar, dan is de lijn gewoon recht.
        if (afstand >= 2) {
          var kant = naar.x > van.x ? 1 : -1;
          var midden = (van.onder + naar.boven) / 2;
          var r1 = Math.max(0, Math.min(STRAAL, midden - van.y, afstand / 2));
          var r2 = Math.max(0, Math.min(STRAAL, naar.y - midden, afstand / 2));
          d += ' L' + rond(van.x) + ' ' + rond(midden - r1) +
            ' A' + rond(r1) + ' ' + rond(r1) + ' 0 0 ' + (kant > 0 ? 0 : 1) + ' ' + rond(van.x + kant * r1) + ' ' + rond(midden) +
            ' L' + rond(naar.x - kant * r2) + ' ' + rond(midden) +
            ' A' + rond(r2) + ' ' + rond(r2) + ' 0 0 ' + (kant > 0 ? 1 : 0) + ' ' + rond(naar.x) + ' ' + rond(midden + r2);
        }
        d += ' L' + rond(naar.x) + ' ' + rond(naar.y);
      }
      pad.setAttribute('d', d);
    }

    teken();
    if ('ResizeObserver' in window) new ResizeObserver(teken).observe(lijst);
    else window.addEventListener('resize', teken);
  }

  function startAlles(bereik) {
    Array.prototype.forEach.call((bereik || document).querySelectorAll('[data-neroo-vb]'), function (sectie) {
      startSlinger(sectie);
      startReviews(sectie);
      start(sectie);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { startAlles(); });
  } else {
    startAlles();
  }

  document.addEventListener('shopify:section:load', function (event) { startAlles(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neroo-verkoopblok2"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ICOON = {
    plus: '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M8 3v10M3 8h10"/></svg>',
    min: '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M3 8h10"/></svg>',
    kruis: '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="m4 4 8 8M12 4l-8 8"/></svg>',
    slot: '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M4.5 7V5a3.5 3.5 0 0 1 7 0v2M3.5 7h9v6.5h-9z"/></svg>',
    pijl: '<svg class="neroo-vb2__groep-pijl" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m3 6 5 5 5-5"/></svg>',
    verder: '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M3 8h10M9 4l4 4-4 4"/></svg>',
    info: '<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M8 7.2v4"/><circle cx="8" cy="4.9" r="1" fill="currentColor"/></svg>',
    label: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 2H2v10l9.29 9.29a1 1 0 0 0 1.42 0l8.58-8.58a1 1 0 0 0 0-1.42L12 2Z"/><circle cx="7" cy="7" r="1.5"/></svg>',
    vink: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="m8.5 12 2.5 2.5 4.5-5"/></svg>'
  };

  // Iconen per upsell-groep, dezelfde als op de productpagina (neroo-pdp-v1).
  // Gekozen op de naam van de groep; een andere naam krijgt het schild.
  var GROEP_ICONEN = {
    inbraak: '<rect x="4" y="3" width="11" height="18" rx="1"/><path d="M2 21h15M11 12h.01"/><rect x="18" y="5" width="3" height="7" rx="1"/><path d="M15 6v5"/>',
    veiligheid: '<path d="M12 3c1 4 7 6 7 11a7 7 0 0 1-14 0c0-3 2-5 4-7 0 3 1 4 1 4s3-3 2-8Z"/><path d="M12 13c0 2-2 3-2 5a2 2 0 0 0 4 0c0-2-2-3-2-5Z"/>',
    bediening: '<rect x="6" y="2" width="12" height="20" rx="4"/><circle cx="12" cy="8" r="2"/><path d="M10 14h.01M14 14h.01M10 18h.01M14 18h.01"/>',
    sirene: '<path d="M6 17v-5a6 6 0 0 1 12 0v5M9 12a3 3 0 0 1 3-3M12 2v1M3 5l2 2M19 7l2-2M1 12h2M21 12h2"/><rect x="4" y="17" width="16" height="4" rx="1"/>',
    camera: '<path d="m4 5 15 4-3 7L2 12Z"/><path d="m19 9 3 1-2 5-3-1M9 14l-1 5H4M4 17v4"/>',
    schild: '<path d="M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6Z"/><path d="m8 12 3 3 5-6"/>'
  };

  function groepIcoon(naam) {
    var tekst = String(naam || '').toLowerCase();
    var soort = /inbraak|intrusion|burglar/.test(tekst) ? 'inbraak'
      : /veiligheid|safety/.test(tekst) ? 'veiligheid'
      : /bediening|control/.test(tekst) ? 'bediening'
      : /afschrik|sirene|siren/.test(tekst) ? 'sirene'
      : /camera/.test(tekst) ? 'camera'
      : 'schild';
    return '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      GROEP_ICONEN[soort] + '</svg>';
  }

  // Iconen voor de sets (badges). Welk icoon een set krijgt kies je in
  // Setify; de namen zijn gelijk aan die in de app. Een naam die hier niet
  // staat geeft geen icoon.
  var SET_ICONEN = {
    appartement: '<rect x="5" y="3" width="14" height="18" rx="1.5"/><path d="M9 7h2M13 7h2M9 10.5h2M13 10.5h2M9 14h2M13 14h2"/><path d="M10.5 21v-3.5h3V21"/>',
    tussenwoning: '<path d="M2 12l3.5-3.5L9 12l3-3.5 3 3.5 3.5-3.5L22 12"/><path d="M3.5 10.8V20h17v-9.2"/><path d="M9 12v8M15 12v8"/>',
    vrijstaand: '<path d="M3.5 11.5 12 4.5l8.5 7"/><path d="M5.5 10v9.5h13V10"/><path d="M10 19.5v-5h4v5"/><path d="M16.5 8.2V5.5h-2"/><path d="M2 19.5h20"/>',
    huis: '<path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 9.8V20h13V9.8"/><path d="M10 20v-5.5h4V20"/>',
    // De drie schilden komen uit Lucide (shield, shield-half, shield-check).
    // ISC License, Copyright (c) Lucide Icons and Contributors.
    schild: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>',
    schild_half: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="M12 22V2"/>',
    schild_vink: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>',
    slot: '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/><path d="M12 14.5v2"/>',
    ster: '<path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6-5.4-2.8L6.6 19.7l1-6L3.2 9.4l6.1-.9L12 3Z"/>',
    kroon: '<path d="m4 16-1.5-9 5.5 4 4-6 4 6 5.5-4L20 16H4Z"/><path d="M4.5 19.5h15"/>',
    camper: '<path d="M2.5 16.5V8a2 2 0 0 1 2-2H14v10.5"/><path d="M14 9h3.6l3.4 4v3.5h-1.6"/><path d="M9.4 16.5h5.2M2.5 16.5h2.1"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M5.5 9.5h4.5"/>',
    winkel: '<path d="M4.5 10.5V20h15v-9.5"/><path d="M3 8.5 4.8 4h14.4L21 8.5a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0Z"/><path d="M10 20v-5h4v5"/>'
  };

  function setIcoon(naam) {
    if (!naam || !Object.prototype.hasOwnProperty.call(SET_ICONEN, naam)) return '';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      SET_ICONEN[naam] + '</svg>';
  }

  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function nummer(id) {
    var m = String(id == null ? '' : id).match(/(\d+)$/);
    return m ? m[1] : '';
  }

  function el(tag, klasse, html) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function veilig(tekst) {
    return String(tekst == null ? '' : tekst)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function vul(tekst, waarden) {
    var uit = String(tekst || '');
    Object.keys(waarden).forEach(function (naam) {
      uit = uit.split('{' + naam + '}').join(waarden[naam]);
    });
    return uit;
  }

  /** Maakt een instellingen-object met gid's als sleutel bruikbaar op nummer. */
  function opNummer(bron) {
    var uit = {};
    Object.keys(bron || {}).forEach(function (sleutel) { uit[nummer(sleutel)] = bron[sleutel]; });
    return uit;
  }

  /** De kant-en-klare sets van een verkoopblok (nummers), alleen met productgegevens. */
  function kantVan(data) {
    return ((data.config || {}).readySets || [])
      .map(function (set) { return nummer(set && set.product); })
      .filter(function (id) {
        var product = (data.producten || {})[id];
        return product && (product.varianten || []).length;
      });
  }

  function heeftGewoneSets(data) {
    return ((data.config || {}).presets || []).some(function (p) { return p && p.key; });
  }

  /** Laagste prijs van de kant-en-klare sets van een paneel ("vanaf"), in centen. */
  function vanafPrijs(data) {
    var leverbaar = 0, alle = 0;
    kantVan(data).forEach(function (id) {
      (data.producten[id].varianten || []).forEach(function (v) {
        if (!alle || v.prijs < alle) alle = v.prijs;
        if (v.leverbaar && (!leverbaar || v.prijs < leverbaar)) leverbaar = v.prijs;
      });
    });
    return leverbaar || alle;
  }

  /** Alleen links binnen de winkel of naar https; de rest valt weg. */
  function veiligeUrl(url) {
    var schoon = String(url || '').trim();
    if (/^\/(?!\/)/.test(schoon) || /^https:\/\//i.test(schoon)) return schoon;
    if (/^\/\//.test(schoon)) return 'https:' + schoon;
    return '';
  }

  function handleUit(url) {
    var m = String(url || '').match(/\/products\/([a-z0-9][a-z0-9-]*)/i);
    return m ? m[1].toLowerCase() : '';
  }

  /** Kleinere variant van een Shopify-foto. */
  function klein(url) {
    var bron = veiligeUrl(url);
    if (!bron || !/cdn\.shopify\.com|\/cdn\/shop\//.test(bron) || /[?&]width=/.test(bron)) return bron;
    return bron + (bron.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  // Producten die niet in de pagina staan (bijv. de ShieldSense Mini die bij
  // de keuze MINI in een set hoort), één keer per bezoek opgehaald.
  var productCache = {};
  function haalProduct(taalPad, handle) {
    if (!productCache[handle]) {
      productCache[handle] = { klaar: false, product: null, wachtend: [] };
      var item = productCache[handle];
      fetch(taalPad + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && p.variants) {
            item.product = {
              handle: p.handle,
              titel: p.title,
              url: p.url || '/products/' + p.handle,
              beeld: klein(p.featured_image || ''),
              varianten: p.variants.map(function (v) {
                var foto = v.featured_image && (v.featured_image.src || v.featured_image);
                return { titel: v.title || '', opties: v.options || [], beeld: foto ? klein(foto) : null };
              })
            };
          }
        })
        .catch(function () {})
        .then(function () {
          item.klaar = true;
          item.wachtend.forEach(function (fn) { try { fn(); } catch (e) {} });
          item.wachtend = [];
        });
    }
    return productCache[handle];
  }

  function start(sectie) {
    if (sectie.getAttribute('data-vb-klaar')) return;
    var kaart = sectie.querySelector('[data-vb-kaart]');
    var bron = sectie.querySelector('[data-vb-data]');
    if (!kaart || !bron) return;

    var data;
    try { data = JSON.parse(bron.textContent); } catch (e) { return; }
    sectie.setAttribute('data-vb-klaar', '1');

    // Panelen: elk volgend paneel is een eigen verkoopblok met dezelfde
    // algemene gegevens (service, teksten, instellingen) als het eerste.
    var panelen = [data];
    Array.prototype.forEach.call(sectie.querySelectorAll('[data-vb-paneeldata]'), function (el) {
      try { panelen.push(Object.assign({}, data, JSON.parse(el.textContent))); } catch (e) { /* paneel overslaan */ }
    });
    // Elk product staat maar één keer in de pagina; alle panelen delen ze.
    var alleProducten = {};
    panelen.forEach(function (p) { Object.assign(alleProducten, p.producten || {}); });
    panelen.forEach(function (p) { p.producten = alleProducten; });

    // Opbouw: "losse" (losse artikelen met sets als startpunt, zoals altijd),
    // "sets" (eerst een kant-en-klare set) of "zelf" (paneel plus losse
    // artikelen). Kant-en-klare sets alleen als het verkoopblok ze heeft.
    var opbouwSets = data.opbouw === 'sets';
    var gewenst = 'sets';
    function modusVoor(paneelData) {
      if (!kantVan(paneelData).length) return 'losse';
      if (!opbouwSets && heeftGewoneSets(paneelData)) return 'losse';
      return gewenst === 'zelf' ? 'zelf' : 'sets';
    }

    // Wat de klant gekozen heeft blijft staan bij een ander paneel of een
    // andere opbouw, als dat daar ook kan: de set (bijv. Comfort), de plek
    // van de kant-en-klare set en de opties (bijv. Zwart).
    var keuze = { set: '', kant: -1, opties: {} };

    var opruimen = null;
    var huidig = { paneel: -1, modus: '' };
    function toon(index, focus) {
      var modus = modusVoor(panelen[index]);
      if (index === huidig.paneel && modus === huidig.modus) return;
      if (opruimen) opruimen();
      huidig = { paneel: index, modus: modus };
      opruimen = bouw(sectie, kaart, panelen[index], {
        panelen: panelen.length > 1 ? panelen : null,
        paneel: index,
        kiesPaneel: function (i) { toon(i, 'paneel'); },
        modus: modus,
        kiesModus: function (m) { gewenst = m; toon(huidig.paneel, 'modus'); },
        opbouwSets: opbouwSets,
        keuze: keuze,
        focus: focus
      });
    }
    // Bij het openen: het eerste paneel met het vinkje "standaard", anders
    // het eerste paneel.
    var beginPaneel = 0;
    for (var i = panelen.length - 1; i >= 0; i--) {
      if (panelen[i].paneel && panelen[i].paneel.standaard) beginPaneel = i;
    }
    toon(beginPaneel);
  }

  /**
   * Bouwt de kaart voor één verkoopblok. Geeft een functie terug die alles
   * opruimt wat buiten de kaart hangt (vaste balk, waarnemers), zodat de
   * kaart bij het kiezen van een ander paneel opnieuw gebouwd kan worden.
   */
  function bouw(sectie, kaart, data, opties) {
    var waarnemers = [];
    var T = data.teksten || {};
    var config = data.config || {};
    var modus = opties.modus || 'losse';
    var setModus = modus === 'sets';
    var zelfModus = modus === 'zelf';
    var keuze = opties.keuze || { set: '', kant: -1, opties: {} };
    // Met een kant-en-klare set of bij zelf samenstellen zijn er geen
    // gewone sets (badges): de klant begint met een set of met het paneel.
    var presets = modus === 'losse' ? (config.presets || []).filter(function (p) { return p && p.key; }) : [];
    var setInstellingen = opNummer(config.items);
    // Verkoopblok 2 heeft geen kortingsbalk en rekent de drempels van het
    // verkoopblok niet: de regels gaan zonder _setify_vb de winkelwagen in.
    // Korting komt van de stapelkortingen bij de groepen (zie hieronder).
    var toonBalk = false;

    var tiers = []
      .map(function (t) {
        return { vanaf: Math.round(Number(t.min) * 100), korting: Math.round(Number(t.amount) * 100), naam: t.label || '' };
      })
      .filter(function (t) { return t.vanaf >= 0 && t.korting > 0; })
      .sort(function (a, b) { return a.vanaf - b.vanaf; });

    // ── Geld ──
    function geld(centen) {
      // Accolades los van elkaar: dit blok mag geen Liquid-uitvoer bevatten.
      var formaat = data.geld || '€{' + '{amount_with_comma_separator}' + '}';
      var waarde = Math.round(centen);
      var negatief = waarde < 0;
      waarde = Math.abs(waarde);
      function opmaak(decimalen, duizend, komma) {
        var delen = (waarde / 100).toFixed(decimalen).split('.');
        delen[0] = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
        return delen.join(komma);
      }
      var uit = formaat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, soort) {
        switch (soort) {
          case 'amount': return opmaak(2, ',', '.');
          case 'amount_no_decimals': return opmaak(0, ',', '.');
          case 'amount_with_comma_separator': return opmaak(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return opmaak(0, '.', ',');
          case 'amount_with_apostrophe_separator': return opmaak(2, "'", '.');
          case 'amount_with_space_separator': return opmaak(2, ' ', ',');
          default: return opmaak(2, '.', ',');
        }
      });
      uit = uit.replace(/<[^>]*>/g, '');
      return (negatief ? '−' : '') + uit;
    }

    /** Ronde bedragen zonder centen: "€35" in plaats van "€35,00". */
    function geldKort(centen) {
      return geld(centen).replace(/[.,]00(?!\d)/, '');
    }

    // ── Rijen opbouwen ──
    var producten = data.producten || {};
    var rijen = [];
    var rijPerSleutel = {};

    function eersteLeverbaar(product, voorkeur) {
      var varianten = product.varianten || [];
      var gekozen = null;
      varianten.forEach(function (v) { if (String(v.id) === nummer(voorkeur)) gekozen = v; });
      if (gekozen && gekozen.leverbaar) return gekozen;
      for (var i = 0; i < varianten.length; i++) if (varianten[i].leverbaar) return varianten[i];
      return gekozen || varianten[0] || null;
    }

    function voegToe(productId, instelling, thuis, inSet) {
      var product = producten[String(productId)];
      if (!product || !(product.varianten || []).length) return;
      var basis = instelling || {};
      var standaard = eersteLeverbaar(product, basis.variant);
      var los = Boolean(basis.split) && product.varianten.length > 1;

      (los ? product.varianten : [standaard]).forEach(function (variant) {
        var sleutel = los ? 'v' + variant.id : 'p' + product.id;
        var bestaand = rijPerSleutel[sleutel];
        if (bestaand) {
          // Staat het product in de set én in een groep, dan is de groep zijn
          // plek zodra het aantal op nul staat.
          if (bestaand.thuis < 0 && thuis >= 0) bestaand.thuis = thuis;
          return;
        }
        var isStandaard = !los || variant.id === standaard.id;
        var rij = {
          sleutel: sleutel,
          product: product,
          variant: variant,
          los: los,
          vast: Boolean(basis.max1),
          thuis: thuis,
          inSet: inSet,
          perSet: inSet && isStandaard ? (basis.qty || {}) : {},
          aantal: 0,
          zelf: false,
          plek: '',
          volgnummer: rijen.length
        };
        rijen.push(rij);
        rijPerSleutel[sleutel] = rij;
      });
    }

    // Kant-en-klare sets: één rij per set, alleen de gekozen set staat (met
    // 1 stuk) in de lijst. Ze komen vóór de andere rijen.
    var kantIds = kantVan(data);
    var isKant = {};
    kantIds.forEach(function (id) { isKant[id] = true; });
    var kantRijen = [];
    if (setModus) {
      kantIds.forEach(function (id, i) {
        var product = producten[id];
        var rij = {
          sleutel: 'k' + id,
          product: product,
          variant: eersteLeverbaar(product),
          los: false,
          vast: true,
          kant: true,
          thuis: -1,
          inSet: false,
          perSet: {},
          aantal: 0,
          zelf: false,
          plek: '',
          volgnummer: i - kantIds.length
        };
        rijen.push(rij);
        rijPerSleutel[rij.sleutel] = rij;
        kantRijen.push(rij);
      });
    }

    // Losse upsells staan ook in de productlijst van het blok (zo kan Liquid
    // hun gegevens leveren), maar horen niet in de sets. Kant-en-klare sets
    // ook niet: die hebben hun eigen rij.
    var losseInfo = {};
    (config.extras || []).forEach(function (extra) {
      var id = nummer(extra && extra.product);
      if (id) losseInfo[id] = { telt: extra.telt !== false, tekst: extra.tekst || '' };
    });

    // Plek van elk product in (de eerste) groep waar het in staat.
    var plekInGroep = {};
    (data.setProducten || []).forEach(function (id) {
      if (losseInfo[String(id)] || isKant[String(id)]) return;
      voegToe(id, setInstellingen[String(id)], -1, true);
    });
    (data.groepen || []).forEach(function (groep, index) {
      var instellingen = opNummer((groep.instellingen || {}).items);
      (groep.producten || []).forEach(function (id, plek) {
        if (isKant[String(id)]) return;
        if (!Object.prototype.hasOwnProperty.call(plekInGroep, String(id))) plekInGroep[String(id)] = plek;
        voegToe(id, setInstellingen[String(id)] || instellingen[String(id)], index, false);
      });
    });
    // Staat een losse upsell ook in een groep, dan blijft hij in de groep.
    (config.extras || []).forEach(function (extra) {
      var id = nummer(extra && extra.product);
      if (!losseInfo[id] || rijen.some(function (rij) { return String(rij.product.id) === id; })) return;
      voegToe(id, {}, -1, false);
      if (rijPerSleutel['p' + id]) rijPerSleutel['p' + id].extra = losseInfo[id];
    });

    function leverbaar(rij) { return Boolean(rij.variant && rij.variant.leverbaar); }
    function aantalInSet(rij, sleutel) {
      var n = Math.floor(Number(rij.perSet[sleutel]));
      return n > 0 && leverbaar(rij) ? (rij.vast ? 1 : n) : 0;
    }

    // Bij een ander paneel blijft de gekozen set (bijv. Comfort) gekozen,
    // als dat paneel hem ook heeft.
    function presetMet(sleutel) {
      return presets.filter(function (p) { return p.key === sleutel; })[0];
    }
    var actief = presets.length
      ? (presetMet(keuze.set) || presetMet(config.defaultPreset) || presets[0]).key
      : '';

    function kiesSet(sleutel) {
      actief = sleutel;
      keuze.set = sleutel;
      rijen.forEach(function (rij) {
        var n = aantalInSet(rij, sleutel);
        if (n > 0) { rij.aantal = n; rij.zelf = false; }
        else if (!rij.zelf) rij.aantal = 0;
      });
    }

    // ── Kant-en-klare sets: keuze en opties ──
    var kantKeuze = -1;

    /** Optienamen van een product, zonder Shopify's "Title" bij één uitvoering. */
    function optieNamen(product) {
      return (product.opties || []).filter(function (naam) { return !/^title$/i.test(naam); });
    }

    /**
     * De uitvoering die past bij de gekozen opties (bijv. Paneelkleur Zwart,
     * Accessoires MINI). Opties die het product niet heeft tellen niet mee.
     */
    function variantMet(product, gekozen) {
      var namen = product.opties || [];
      var past = function (v) {
        return namen.every(function (naam, i) {
          return !Object.prototype.hasOwnProperty.call(gekozen, naam) || (v.opties || [])[i] === gekozen[naam];
        });
      };
      var varianten = product.varianten || [];
      return varianten.filter(function (v) { return past(v) && v.leverbaar; })[0] ||
        varianten.filter(past)[0] || null;
    }

    function zetKantVarianten() {
      kantRijen.forEach(function (rij) {
        var v = variantMet(rij.product, keuze.opties);
        if (v) rij.variant = v;
      });
    }

    function kiesKant(index) {
      kantKeuze = index;
      keuze.kant = index;
      kantRijen.forEach(function (rij, i) {
        rij.aantal = i === index && leverbaar(rij) ? 1 : 0;
      });
    }

    function kiesOptie(naam, waarde) {
      var gekozen = Object.assign({}, keuze.opties);
      gekozen[naam] = waarde;
      keuze.opties = gekozen;
      kantRijen.forEach(function (rij) {
        var v = variantMet(rij.product, gekozen);
        // Bestaat die combinatie niet, dan in elk geval de gekozen waarde.
        if (!v) {
          var plek = (rij.product.opties || []).indexOf(naam);
          v = (rij.product.varianten || []).filter(function (x) { return plek >= 0 && (x.opties || [])[plek] === waarde && x.leverbaar; })[0];
        }
        if (v) rij.variant = v;
      });
      if (kantKeuze >= 0) kiesKant(kantKeuze);
    }

    if (setModus && kantRijen.length) {
      zetKantVarianten();
      var beginKant = keuze.kant;
      if (!(beginKant >= 0 && beginKant < kantRijen.length)) beginKant = kantIds.indexOf(nummer(config.defaultReadySet));
      if (beginKant < 0) beginKant = 0;
      // Is de standaardset uitverkocht, dan de eerste die wel leverbaar is.
      if (!leverbaar(kantRijen[beginKant])) {
        for (var k = 0; k < kantRijen.length; k++) if (leverbaar(kantRijen[k])) { beginKant = k; break; }
      }
      kiesKant(beginKant);
    }

    // Zelf samenstellen: het paneel (het eerste product met "max 1") staat
    // erin, de rest op nul.
    if (zelfModus) {
      var paneelRij = rijen.filter(function (rij) { return rij.inSet && rij.vast && leverbaar(rij); })[0];
      if (paneelRij) paneelRij.aantal = 1;
    }

    // ── Rekenen ──
    function kortingBij(subtotaal) {
      var beste = null;
      tiers.forEach(function (t) {
        if (subtotaal >= t.vanaf && (!beste || t.korting > beste.korting)) beste = t;
      });
      return beste;
    }

    // ── Stapelkortingen (Setify → Kortingsregels, gekoppeld aan een groep) ──
    // Per regel: de drempels op aantal stuks en de producten die meetellen.
    // Een product telt bij de eerste gekoppelde regel waarin het staat.
    var stapels = [];
    var stapelPerProduct = {};
    (data.groepen || []).forEach(function (groep, index) {
      var bron = groep && groep.stapel;
      if (!bron || !bron.id) return;
      var bestaand = stapels.filter(function (x) { return x.id === String(bron.id); })[0];
      if (bestaand) { bestaand.groepen.push(index); return; }
      var treden = (bron.tiers || [])
        .map(function (t) { return { stuks: Math.floor(Number(t.min)), korting: Math.round(Number(t.amount) * 100) }; })
        .filter(function (t) { return t.stuks >= 1 && t.korting > 0; })
        .sort(function (a, b) { return a.stuks - b.stuks; });
      if (!treden.length) return;
      var stapel = { id: String(bron.id), naam: bron.naam || '', treden: treden, groepen: [index] };
      stapels.push(stapel);
      (bron.producten || []).forEach(function (id) {
        if (!stapelPerProduct[String(id)]) stapelPerProduct[String(id)] = stapel;
      });
    });

    /**
     * De hoofdregel van de bestelling: de gekozen kant-en-klare set, anders
     * het paneel (het eerste artikel met "max 1" uit het blok). Alles
     * daarnaast is bijkoop; de hoofdregel zelf telt nooit voor een
     * stapelkorting. Zonder hoofdregel (accessoirepagina) telt alles.
     */
    function hoofdRij() {
      var kant = kantRijen.filter(function (rij) { return rij.aantal > 0 && leverbaar(rij); })[0];
      if (kant) return kant;
      return rijen.filter(function (rij) { return !rij.kant && rij.inSet && rij.vast && rij.aantal > 0 && leverbaar(rij); })[0] || null;
    }

    function stapelVan(rij, hoofd) {
      if (rij === hoofd || rij.kant) return null;
      return stapelPerProduct[String(rij.product.id)] || null;
    }

    /** Per stapelkorting: stuks bijkoop, behaalde en volgende drempel, korting. */
    function rekenStapels() {
      var hoofd = hoofdRij();
      var tellingen = stapels.map(function (stapel) {
        return { stapel: stapel, stuks: 0, bedrag: 0, trede: null, volgende: null, korting: 0 };
      });
      rijen.forEach(function (rij) {
        if (!rij.aantal || !leverbaar(rij)) return;
        var stapel = stapelVan(rij, hoofd);
        if (!stapel) return;
        var t = tellingen[stapels.indexOf(stapel)];
        t.stuks += rij.aantal;
        t.bedrag += rij.aantal * rij.variant.prijs;
      });
      tellingen.forEach(function (t) {
        t.stapel.treden.forEach(function (trede) {
          if (t.stuks >= trede.stuks && (!t.trede || trede.korting > t.trede.korting)) t.trede = trede;
        });
        var huidig = t.trede ? t.trede.korting : 0;
        t.volgende = t.stapel.treden.filter(function (trede) { return trede.stuks > t.stuks && trede.korting > huidig; })[0] || null;
        t.korting = t.trede ? Math.min(t.trede.korting, t.bedrag) : 0;
      });
      return tellingen;
    }

    // ── Inhoud van een kant-en-klare set (metaveld custom.doos) ──
    // Per regel: aantal | naam | foto | link. Zelfde veld als "Dit zit in je
    // set" op de productpagina, dus niets dubbel bijhouden.
    function doosRegels(product) {
      return String(product.doos || '').split(/\r?\n|<br\s*\/?>/i)
        .map(function (regel) { return regel.split('|').map(function (s) { return s.trim(); }); })
        .filter(function (delen) { return delen[1]; })
        .map(function (delen) {
          return {
            aantal: Math.max(0, parseInt(delen[0], 10) || 0),
            titel: delen[1],
            beeld: klein(delen[2]),
            url: veiligeUrl(delen[3])
          };
        });
    }

    var perHandle = {};
    Object.keys(producten).forEach(function (id) {
      var p = producten[id];
      if (p && p.handle) perHandle[String(p.handle).toLowerCase()] = p;
    });

    /** Product op handle: uit de pagina, of opgehaald (null = bestaat niet, undefined = nog bezig). */
    function productOp(handle) {
      if (perHandle[handle]) return perHandle[handle];
      var item = productCache[handle];
      return item && item.klaar ? item.product : undefined;
    }

    function variantNaar(product, waarde) {
      var w = String(waarde || '').toLowerCase();
      return (product.varianten || []).filter(function (v) {
        return (v.opties || []).concat(v.titel || '').some(function (o) { return String(o).toLowerCase() === w; });
      })[0] || null;
    }

    function woordIn(tekst, woord) {
      var schoon = String(woord || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return Boolean(schoon) && new RegExp('(^|[^a-z0-9])' + schoon + '($|[^a-z0-9])', 'i').test(tekst);
    }

    /**
     * Eén onderdeel van de set, passend bij de gekozen uitvoering. De regel
     * met "paneel" in de naam volgt de optie met "paneel" in de naam
     * (Paneelkleur), de andere regels de andere optie (Accessoires,
     * Magneetkleur). Heeft het onderdeel een uitvoering met die waarde
     * (Wit, Zwart), dan komt zijn foto erbij. Staat de waarde in de naam van
     * de regel ("ShieldSense® Pro of Mini") en heeft het onderdeel hem niet,
     * dan is het een ander product (shieldsense-mini), in het wit.
     * opgehaald: functie die aangeroepen wordt als een product binnen is.
     */
    function onderdeel(regel, rij, opgehaald) {
      var uit = { aantal: regel.aantal, titel: regel.titel, beeld: regel.beeld, url: regel.url, handle: handleUit(regel.url) };
      if (!uit.handle) return uit;
      var namen = rij.product.opties || [];
      var waarden = rij.variant.opties || [];
      var paneelRegel = /paneel/i.test(regel.titel);
      var plek = -1;
      namen.forEach(function (naam, i) {
        if (plek < 0 && !/^title$/i.test(naam) && /paneel/i.test(naam) === paneelRegel) plek = i;
      });
      var waarde = plek >= 0 ? String(waarden[plek] || '') : '';
      if (!waarde) return uit;

      var handle = uit.handle;
      var product = productOp(handle);
      var ander = false;
      if (product ? !variantNaar(product, waarde) && woordIn(regel.titel, waarde) : product !== null && woordIn(regel.titel, waarde)) {
        handle = handle.replace(/-[a-z0-9]+$/, '') + '-' + waarde.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        product = productOp(handle);
        ander = true;
      }
      uit.handle = handle;
      if (product === undefined) {
        if (opgehaald) haalProduct(taalPad, handle).wachtend.push(opgehaald);
        return uit;
      }
      if (!product) return uit;
      var v = (!ander && variantNaar(product, waarde)) || variantNaar(product, 'wit') || (product.varianten || [])[0];
      uit.beeld = (v && v.beeld) || product.beeld || uit.beeld;
      if (ander || /naar keuze/i.test(regel.titel)) uit.titel = product.titel;
      uit.url = product.url || uit.url;
      return uit;
    }

    // ── Configuratieservice ──
    // Werkt zoals op de productpagina: de prijs hangt af van het aantal
    // sensoren, en de namen gaan als eigenschappen mee op de regel van de
    // service. De service telt niet mee voor de kortingsbalk.
    var service = null;
    if (data.service && (data.service.varianten || []).length) {
      var trappen = String(data.service.staffel || '').split(',').map(function (deel) {
        var stukken = deel.split(':');
        var max = parseInt(stukken[1], 10);
        var variant = data.service.varianten.filter(function (v) { return String(v.id) === String(stukken[0]).trim(); })[0];
        return variant && variant.leverbaar && max > 0 ? { variant: variant, max: max } : null;
      }).filter(Boolean).sort(function (a, b) { return a.max - b.max; });

      var labels = {}, heeftLabels = false;
      String(data.service.labels || '').split(/\r?\n/).forEach(function (regel) {
        var delen = regel.split('|').map(function (s) { return s.trim(); });
        if (!delen[0] || !delen[1]) return;
        labels[delen[0].toLowerCase()] = {
          naam: delen[1],
          voorbeelden: (delen[2] || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean)
        };
        heeftLabels = true;
      });

      if (trappen.length && heeftLabels) {
        service = { trappen: trappen, labels: labels, url: data.service.url || '', aan: false, modus: '', namen: {} };
      }
    }

    /** Eén regel per sensor in de set: "Magneetcontact 1", "Magneetcontact 2", … */
    function sensoren() {
      if (!service) return [];
      var perNaam = {}, volgorde = [];
      var tel = function (handle, aantal) {
        var info = service.labels[String(handle || '').toLowerCase()];
        if (!info || !aantal) return;
        if (!perNaam[info.naam]) { perNaam[info.naam] = { info: info, aantal: 0 }; volgorde.push(info.naam); }
        perNaam[info.naam].aantal += aantal;
      };
      rijen.forEach(function (rij) {
        if (!rij.aantal) return;
        // Een kant-en-klare set telt met de sensoren uit zijn inhoud.
        if (rij.kant) {
          doosRegels(rij.product).forEach(function (regel) {
            tel(onderdeel(regel, rij).handle, regel.aantal * rij.aantal);
          });
          return;
        }
        tel(rij.product.handle, rij.aantal);
      });
      var lijst = [];
      volgorde.forEach(function (naam) {
        for (var i = 1; i <= perNaam[naam].aantal; i++) {
          lijst.push({ sleutel: naam + ' ' + i, voorbeeld: perNaam[naam].info.voorbeelden[i - 1] || '' });
        }
      });
      return lijst;
    }

    function serviceVariant(aantal) {
      if (!service || aantal < 1) return null;
      for (var i = 0; i < service.trappen.length; i++) {
        if (aantal <= service.trappen[i].max) return service.trappen[i].variant;
      }
      return service.trappen[service.trappen.length - 1].variant;
    }

    function reken() {
      // telBedrag is wat meetelt voor de drempels: alles behalve losse
      // upsells waarbij "telt mee" uit staat. Zelfde regel als de korting.
      var subtotaal = 0, telBedrag = 0, van = 0, stuks = 0;
      rijen.forEach(function (rij) {
        if (!rij.aantal) return;
        subtotaal += rij.aantal * rij.variant.prijs;
        if (!rij.extra || rij.extra.telt) telBedrag += rij.aantal * rij.variant.prijs;
        van += rij.aantal * Math.max(rij.variant.van || 0, rij.variant.prijs);
        stuks += rij.aantal;
      });
      var tier = null;
      var stapelTellingen = rekenStapels();
      var korting = 0;
      stapelTellingen.forEach(function (t) { korting += t.korting; });

      var aantalSensoren = sensoren().length;
      var variant = serviceVariant(aantalSensoren);
      var servicePrijs = service && service.aan && variant ? variant.prijs : 0;

      return {
        subtotaal: subtotaal, telBedrag: telBedrag, van: van, stuks: stuks, tier: tier, korting: korting, stapels: stapelTellingen,
        sensoren: aantalSensoren, serviceVariant: variant, servicePrijs: servicePrijs,
        totaal: subtotaal - korting + servicePrijs
      };
    }

    /**
     * Wat een set kost en wat hij normaal kost. "Normaal" is de som van de
     * losse prijzen; staan de van-prijzen aan, dan tellen de
     * vergelijkingsprijzen van de producten mee. Zo is het verschil op de
     * badge gelijk aan "Je bespaart" onderaan de kaart.
     */
    function prijzenVanSet(sleutel) {
      var subtotaal = 0, van = 0;
      rijen.forEach(function (rij) {
        var n = aantalInSet(rij, sleutel);
        subtotaal += n * rij.variant.prijs;
        van += n * Math.max(rij.variant.van || 0, rij.variant.prijs);
      });
      var tier = kortingBij(subtotaal);
      return {
        prijs: subtotaal - (tier ? Math.min(tier.korting, subtotaal) : 0),
        normaal: data.toonVanprijs ? van : subtotaal
      };
    }

    // ── Geraamte ──
    var melding = kaart.querySelector('.neroo-vb2__melding');
    kaart.innerHTML = '';
    if (melding) kaart.appendChild(melding);

    var balk = null;
    if (toonBalk && tiers.length) {
      balk = el('div', 'neroo-vb2__balk');
      balk.setAttribute('data-vb-schuif', '');
      // De bolletjes staan op gelijke afstand van elkaar, ook als de bedragen
      // dat niet zijn. De hoogste drempel is het eind van het spoor: is die
      // gehaald, dan is de balk vol.
      var punten = '', labels = '';
      tiers.forEach(function (t, i) {
        var plek = (i + 1) / tiers.length;
        punten += '<span class="neroo-vb2__balk-punt" data-vb-punt="' + i + '" style="--vb-plek:' + plek + '"></span>';
        labels += '<span class="neroo-vb2__balk-label" data-vb-label="' + i + '" style="--vb-plek:' + plek + '">−' +
          veilig(geldKort(t.korting)) + '</span>';
      });
      balk.innerHTML =
        '<p class="neroo-vb2__balk-tekst" data-vb-balktekst aria-live="polite"></p>' +
        '<div class="neroo-vb2__balk-spoor"><span class="neroo-vb2__balk-vulling" data-vb-vulling></span>' + punten + '</div>' +
        '<div class="neroo-vb2__balk-labels" aria-hidden="true">' + labels + '</div>';
      kaart.appendChild(balk);
    }

    /**
     * Waar een bedrag op de balk staat, van 0 (begin) tot 1 (eind). Tussen
     * twee bolletjes loopt de vulling gelijkmatig mee met het bedrag.
     */
    function plekOpBalk(bedrag) {
      var vorige = 0;
      for (var i = 0; i < tiers.length; i++) {
        if (bedrag < tiers[i].vanaf) {
          var stuk = tiers[i].vanaf - vorige;
          return (i + (stuk > 0 ? Math.max(0, bedrag - vorige) / stuk : 0)) / tiers.length;
        }
        vorige = tiers[i].vanaf;
      }
      return 1;
    }

    // ── Panelen (alleen als de sectie paneel-blokken heeft) ──
    if (opties.panelen) {
      // Linkje rechts ("Bekijk de verschillen"), in een nieuw tabblad zodat
      // de keuze in de kaart blijft staan.
      var paneelLink = data.panelenLink && data.panelenLinkTekst
        ? '<a class="neroo-vb2__kop-link" href="' + veilig(data.panelenLink) + '" target="_blank" rel="noopener">' + veilig(data.panelenLinkTekst) + '</a>'
        : '';
      var paneelBlok = el('div', 'neroo-vb2__setblok neroo-vb2__paneelblok',
        data.panelenTitel || paneelLink
          ? '<div class="neroo-vb2__kop"><span class="neroo-vb2__kop-titel">' + veilig(data.panelenTitel || '') + '</span>' + paneelLink + '</div>'
          : '');
      var paneelRij = el('div', 'neroo-vb2__panelen');
      paneelRij.setAttribute('role', 'group');
      if (data.panelenTitel) paneelRij.setAttribute('aria-label', data.panelenTitel);
      paneelRij.style.setProperty('--vb-panelen', opties.panelen.length);
      opties.panelen.forEach(function (paneelData, index) {
        var info = paneelData.paneel || {};
        var gekozen = index === opties.paneel;
        // Met kant-en-klare sets staat onder de naam ook de laagste prijs van
        // de sets van dat paneel.
        var vanaf = opties.opbouwSets ? vanafPrijs(paneelData) : 0;
        var paneelKnop = el('button', 'neroo-vb2__paneel' + (gekozen ? ' is-actief' : ''),
          '<span class="neroo-vb2__paneel-foto">' +
            (info.foto ? '<img src="' + veilig(info.foto) + '" alt="" loading="lazy" width="120" height="120">' : '') +
          '</span>' +
          '<span class="neroo-vb2__paneel-naam">' + veilig(info.naam || paneelData.blokNaam || '') + '</span>' +
          (vanaf > 0 ? '<span class="neroo-vb2__paneel-vanaf">' + veilig(vul(T.from, { bedrag: geld(vanaf) })) + '</span>' : ''));
        paneelKnop.type = 'button';
        paneelKnop.setAttribute('aria-pressed', gekozen ? 'true' : 'false');
        paneelKnop.addEventListener('click', function () { opties.kiesPaneel(index); });
        paneelRij.appendChild(paneelKnop);
        if (gekozen && opties.focus === 'paneel') setTimeout(function () { paneelKnop.focus(); }, 0);
      });
      paneelBlok.appendChild(paneelRij);
      kaart.appendChild(paneelBlok);
    }

    // ── Kant-en-klare set of zelf samenstellen ──
    if ((setModus || zelfModus) && kantIds.length) {
      var modusRij = el('div', 'neroo-vb2__modus');
      modusRij.setAttribute('role', 'group');
      modusRij.setAttribute('aria-label', T.mode_label || '');
      [['sets', T.mode_ready], ['zelf', T.mode_self]].forEach(function (optie) {
        var aan = optie[0] === modus;
        var knopje = el('button', 'neroo-vb2__modus-knop' + (aan ? ' is-actief' : ''), veilig(optie[1]));
        knopje.type = 'button';
        knopje.setAttribute('aria-pressed', aan ? 'true' : 'false');
        knopje.addEventListener('click', function () { if (!aan) opties.kiesModus(optie[0]); });
        modusRij.appendChild(knopje);
        if (aan && opties.focus === 'modus') setTimeout(function () { knopje.focus(); }, 0);
      });
      kaart.appendChild(modusRij);
    }

    var setKnoppen = [];
    var optieRij = null;
    if (setModus && kantRijen.length) {
      var kantBlok = el('div', 'neroo-vb2__setblok neroo-vb2__kantblok',
        '<div class="neroo-vb2__kop">' +
          '<span class="neroo-vb2__kop-titel">' + veilig(T.ready_label) + '</span>' +
          '<span class="neroo-vb2__kop-hint">' + veilig(T.ready_hint) + '</span>' +
        '</div>');
      kantBlok.setAttribute('data-vb-schuif', '');

      // Opties (bijv. Accessoires: Wit, Zwart, MINI) boven de sets. Alleen
      // als de sets ze hebben; de waarden komen uit de gekozen set.
      optieRij = el('div', 'neroo-vb2__opties');
      kantBlok.appendChild(optieRij);

      var sets = el('div', 'neroo-vb2__sets neroo-vb2__sets--kant');
      sets.setAttribute('role', 'group');
      sets.setAttribute('aria-label', T.ready_label || '');
      sets.style.setProperty('--vb-sets', kantRijen.length);
      kantRijen.forEach(function (rij, index) {
        var titel = String(rij.product.titel || '');
        var deel = titel.indexOf(' - ');
        var merk = deel > 0 ? titel.slice(0, deel) : '';
        var naam = deel > 0 ? titel.slice(deel + 3) : titel;
        var knop = el('button', 'neroo-vb2__set neroo-vb2__kant',
          '<span class="neroo-vb2__kant-beeld"><img alt="" loading="lazy" width="120" height="120" data-vb-kantbeeld></span>' +
          (merk ? '<span class="neroo-vb2__kant-merk">' + veilig(merk) + '</span>' : '') +
          '<span class="neroo-vb2__set-naam">' + veilig(naam) + '</span>' +
          '<span class="neroo-vb2__set-prijzen">' +
            '<span class="neroo-vb2__set-prijs" data-vb-kantprijs></span>' +
            '<s class="neroo-vb2__set-normaal" data-vb-kantvan></s>' +
          '</span>' +
          '<span class="neroo-vb2__kant-bespaar" data-vb-kantbespaar></span>');
        knop.type = 'button';
        knop.addEventListener('click', function () {
          if (kantKeuze === index || !leverbaar(rij)) return;
          wijzig(function () { kiesKant(index); });
        });
        setKnoppen.push({ sleutel: 'k' + index, knop: knop, rij: rij });
        sets.appendChild(knop);
      });
      kantBlok.appendChild(sets);
      kaart.appendChild(kantBlok);
    }

    // Kant-en-klare set en zelf samenstellen: de artikelen staan in een eigen
    // omrand vlak met een titel ("Je bestelling" of "Stel je set samen"),
    // los van de setkaarten.
    var lijstBlok = null;
    if (setModus && kantRijen.length) {
      lijstBlok = el('div', 'neroo-vb2__setblok neroo-vb2__bestelling',
        '<div class="neroo-vb2__kop"><span class="neroo-vb2__kop-titel">' + veilig(T.order_label) + '</span></div>');
    } else if (zelfModus) {
      lijstBlok = el('div', 'neroo-vb2__setblok neroo-vb2__bestelling',
        '<div class="neroo-vb2__kop">' +
          '<span class="neroo-vb2__kop-titel">' + veilig(T.self_label) + '</span>' +
          '<span class="neroo-vb2__kop-hint">' + veilig(T.self_hint) + '</span>' +
        '</div>');
    }
    if (lijstBlok) {
      lijstBlok.setAttribute('data-vb-schuif', '');
      kaart.appendChild(lijstBlok);
    }

    function tekenOpties() {
      if (!optieRij) return;
      var bron = kantRijen[kantKeuze >= 0 ? kantKeuze : 0];
      var namen = bron ? optieNamen(bron.product) : [];
      var teken = namen.join('|') + '#' + JSON.stringify(keuze.opties) + '#' + (bron ? bron.variant.id : '');
      if (optieRij.getAttribute('data-teken') === teken) return;
      optieRij.setAttribute('data-teken', teken);
      optieRij.hidden = !namen.length;
      optieRij.innerHTML = namen.map(function (naam) {
        var plek = bron.product.opties.indexOf(naam);
        var waarden = [];
        bron.product.varianten.forEach(function (v) {
          var w = (v.opties || [])[plek];
          if (w && waarden.indexOf(w) === -1) waarden.push(w);
        });
        var huidigeWaarde = (bron.variant.opties || [])[plek];
        return '<div class="neroo-vb2__optie">' +
          '<span class="neroo-vb2__optie-naam">' + veilig(naam) + '</span>' +
          '<div class="neroo-vb2__varianten" role="group" aria-label="' + veilig(naam) + '">' +
          waarden.map(function (w) {
            var kan = bron.product.varianten.some(function (v) { return (v.opties || [])[plek] === w && v.leverbaar; });
            var aan = w === huidigeWaarde;
            var stip = /^(wit|zwart)$/i.test(w) ? '<span class="neroo-vb2__kleurstip' + (/zwart/i.test(w) ? ' is-zwart' : '') + '" aria-hidden="true"></span>' : '';
            return '<button type="button" class="neroo-vb2__variant' + (aan ? ' is-gekozen' : '') + '" data-vb-optie="' + veilig(naam) + '" data-vb-waarde="' + veilig(w) + '"' +
              ' aria-pressed="' + (aan ? 'true' : 'false') + '"' + (kan ? '' : ' disabled') + '>' + stip + veilig(w) + '</button>';
          }).join('') +
          '</div></div>';
      }).join('');
    }

    if (optieRij) {
      optieRij.addEventListener('click', function (event) {
        var knopje = event.target.closest('[data-vb-optie]');
        if (!knopje || knopje.disabled || knopje.classList.contains('is-gekozen')) return;
        wijzig(function () { kiesOptie(knopje.getAttribute('data-vb-optie'), knopje.getAttribute('data-vb-waarde')); });
      });
    }

    if (presets.length > 1) {
      // Kop en badges horen bij elkaar: zo is duidelijk dat het sets zijn.
      var setBlok = el('div', 'neroo-vb2__setblok',
        '<div class="neroo-vb2__kop">' +
          '<span class="neroo-vb2__kop-titel">' + veilig(T.sets_label) + '</span>' +
          '<span class="neroo-vb2__kop-hint">' + veilig(T.sets_hint) + '</span>' +
        '</div>');
      setBlok.setAttribute('data-vb-schuif', '');

      var sets = el('div', 'neroo-vb2__sets');
      sets.setAttribute('role', 'group');
      sets.setAttribute('aria-label', T.sets_label || '');
      sets.style.setProperty('--vb-sets', presets.length);
      presets.forEach(function (preset) {
        var icoon = setIcoon(preset.icon);
        var prijzen = prijzenVanSet(preset.key);
        var toonNormaal = data.toonSetNormaal !== false && prijzen.normaal > prijzen.prijs;
        var knop = el('button', 'neroo-vb2__set' + (icoon ? ' neroo-vb2__set--icoon' : ''),
          (icoon ? '<span class="neroo-vb2__set-icoon">' + icoon + '</span>' : '') +
          '<span class="neroo-vb2__set-naam">' + veilig(preset.label) + '</span>' +
          (preset.sub ? '<span class="neroo-vb2__set-sub">' + veilig(preset.sub) + '</span>' : '') +
          '<span class="neroo-vb2__set-prijzen">' +
            '<span class="neroo-vb2__set-prijs">' + veilig(geld(prijzen.prijs)) + '</span>' +
            (toonNormaal
              ? '<s class="neroo-vb2__set-normaal"><span class="neroo-vb2__alleen-lezer">' + veilig(T.set_normal) + ' </span>' +
                veilig(geld(prijzen.normaal)) + '</s>'
              : '') +
          '</span>');
        knop.type = 'button';
        knop.addEventListener('click', function () {
          if (actief === preset.key && !gewijzigd()) return;
          wijzig(function () { kiesSet(preset.key); });
        });
        setKnoppen.push({ sleutel: preset.key, knop: knop });
        sets.appendChild(knop);
      });
      kaart.appendChild(setBlok);
    }

    // Met sets staan de artikelen direct onder de badges, in één vlak met de
    // gekozen badge: zijn rand en achtergrond lopen om de hele set heen.
    var setLijst = el('ul', 'neroo-vb2__lijst');
    setLijst.setAttribute('role', 'list');
    // Zelf samenstellen: onder het groene vlak een eigen blok "Vaak gekozen
    // bij dit paneel" met de artikelen van het blok die nog op 0 staan.
    var suggestieBlok = null, suggestieLijst = null;
    if (lijstBlok) {
      setLijst.classList.add('neroo-vb2__lijst--set');
      lijstBlok.appendChild(setLijst);
      if (zelfModus) {
        suggestieBlok = el('div', 'neroo-vb2__setblok neroo-vb2__suggesties',
          '<div class="neroo-vb2__kop"><span class="neroo-vb2__kop-titel">' + veilig(T.suggestions_label) + '</span></div>');
        suggestieBlok.setAttribute('data-vb-schuif', '');
        suggestieLijst = el('ul', 'neroo-vb2__lijst');
        suggestieLijst.setAttribute('role', 'list');
        suggestieBlok.appendChild(suggestieLijst);
        kaart.appendChild(suggestieBlok);
      }
    } else if (setKnoppen.length) {
      var setKeuze = el('div', 'neroo-vb2__setkeuze');
      setLijst.classList.add('neroo-vb2__lijst--set');
      setKeuze.appendChild(sets);
      setKeuze.appendChild(setLijst);
      setBlok.appendChild(setKeuze);
    } else {
      kaart.appendChild(setLijst);
    }

    var extra = el('div', 'neroo-vb2__extra');
    var groepen = [];
    (data.groepen || []).forEach(function (groep, index) {
      var heeftRijen = rijen.some(function (rij) { return rij.thuis === index; });
      if (!heeftRijen) { groepen.push(null); return; }

      var wrap = el('div', 'neroo-vb2__groep');
      wrap.setAttribute('data-vb-schuif', '');
      var paneelId = 'neroo-vb2-paneel-' + nummer(data.blokId) + '-' + index;
      var stapel = stapels.filter(function (s) { return s.groepen.indexOf(index) !== -1; })[0] || null;
      var kop = el('button', 'neroo-vb2__groep-kop',
        (data.groepIconen !== false ? '<span class="neroo-vb2__groep-icoon">' + groepIcoon(groep.naam) + '</span>' : '') +
        // Naam en kortingslabel samen: op de telefoon staat het label eronder.
        '<span class="neroo-vb2__groep-tekst">' +
          '<span class="neroo-vb2__groep-naam">' + veilig(groep.naam) + '</span>' +
          (stapel ? '<span class="neroo-vb2__groep-korting" data-vb-groepkorting></span>' : '') +
        '</span>' +
        '<span class="neroo-vb2__groep-aantal" data-vb-teller></span>' + ICOON.pijl);
      kop.type = 'button';
      kop.setAttribute('aria-controls', paneelId);
      var paneel = el('div', 'neroo-vb2__groep-paneel');
      paneel.id = paneelId;
      var binnen = el('div', 'neroo-vb2__groep-binnen');
      var lijst = el('ul', 'neroo-vb2__lijst');
      lijst.setAttribute('role', 'list');
      var leeg = el('p', 'neroo-vb2__groep-leeg', veilig(T.all_added));
      leeg.hidden = true;
      // Staffel van de stapelkorting, bovenaan in de opengeklapte groep.
      var stapelVak = null;
      if (stapel) {
        stapelVak = el('div', 'neroo-vb2__stapel',
          '<p class="neroo-vb2__stapel-kop"><span class="neroo-vb2__stapel-naam">' + veilig(T.stack_title || stapel.naam) + '</span>' +
            '<span class="neroo-vb2__stapel-tekst" data-vb-stapeltekst aria-live="polite"></span></p>' +
          '<div class="neroo-vb2__stapel-spoor" aria-hidden="true"><span class="neroo-vb2__stapel-vulling" data-vb-stapelvulling></span>' +
            stapel.treden.map(function (t, i) {
              return '<span class="neroo-vb2__stapel-punt" data-vb-stapelpunt="' + i + '" style="--vb-plek:' + ((i + 1) / stapel.treden.length) + '"></span>';
            }).join('') +
          '</div>' +
          '<div class="neroo-vb2__stapel-treden" style="--vb-treden:' + stapel.treden.length + '">' +
            stapel.treden.map(function (t, i) {
              return '<span class="neroo-vb2__stapel-trede" data-vb-stapeltrede="' + i + '" style="--vb-plek:' + ((i + 1) / stapel.treden.length) + '">' +
                veilig(vul(T.stack_pcs, { aantal: t.stuks })) + ' <b>' + veilig(vul(T.stack_off, { korting: geldKort(t.korting) })) + '</b></span>';
            }).join('') +
          '</div>');
        binnen.appendChild(stapelVak);
      }
      binnen.appendChild(lijst);
      binnen.appendChild(leeg);
      paneel.appendChild(binnen);
      wrap.appendChild(kop);
      wrap.appendChild(paneel);

      var item = {
        wrap: wrap, kop: kop, lijst: lijst, leeg: leeg, teller: kop.querySelector('[data-vb-teller]'), open: false,
        stapel: stapel, stapelVak: stapelVak, kortingLabel: kop.querySelector('[data-vb-groepkorting]')
      };
      kop.addEventListener('click', function () {
        // Eén groep tegelijk open: de andere klappen dicht.
        var openen = !item.open;
        groepen.forEach(function (ander) { if (ander && ander !== item && ander.open) zetOpen(ander, false); });
        zetOpen(item, openen);
      });
      groepen.push(item);
      extra.appendChild(wrap);
    });

    function zetOpen(item, open) {
      item.open = open;
      item.wrap.classList.toggle('is-open', open);
      item.kop.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    var echteGroepen = groepen.filter(Boolean);

    // Zijpaneel (instelling): de groepen staan achter de knop "Maak je set
    // compleet" en openen in een paneel aan de zijkant (telefoon: van
    // onderen). Een artikel blijft daar staan als het erbij komt; in de lijst
    // verschijnt dan een tweede regel.
    var ladeAan = data.zijpaneel === true && echteGroepen.length > 0;
    var lade = null, ladeKnop = null;
    if (ladeAan) {
      var ladeTitelId = 'neroo-vb2-lade-' + nummer(data.blokId);
      lade = el('dialog', 'neroo-vb2__lade',
        '<div class="neroo-vb2__lade-kop">' +
          '<h3 class="neroo-vb2__lade-titel" id="' + ladeTitelId + '">' + veilig(T.extras_heading) + '</h3>' +
          '<button type="button" class="neroo-vb2__lade-weg" data-vb-ladedicht aria-label="' + veilig(T.tip_close) + '">' + ICOON.kruis + '</button>' +
        '</div>' +
        '<div class="neroo-vb2__lade-inhoud" data-vb-ladeinhoud></div>' +
        '<div class="neroo-vb2__lade-voet">' +
          '<span class="neroo-vb2__lade-totaal"><span>' + veilig(T.drawer_total) + '</span><strong data-vb-ladetotaal></strong></span>' +
          '<button type="button" class="neroo-btn neroo-btn--primary neroo-vb2__lade-klaar" data-vb-ladedicht>' + veilig(T.drawer_done) + '</button>' +
        '</div>');
      lade.setAttribute('aria-labelledby', ladeTitelId);
      var ladeInhoud = lade.querySelector('[data-vb-ladeinhoud]');
      echteGroepen.forEach(function (item) { ladeInhoud.appendChild(item.wrap); });
      sectie.appendChild(lade);

      ladeKnop = el('button', 'neroo-vb2__lade-knop',
        '<span class="neroo-vb2__lade-plus">' + ICOON.plus + '</span>' +
        '<span class="neroo-vb2__lade-knoptekst">' + veilig(T.extras_heading) + '</span>' +
        '<span class="neroo-vb2__groep-aantal" data-vb-ladeteller hidden></span>' + ICOON.verder);
      ladeKnop.type = 'button';
      ladeKnop.setAttribute('aria-haspopup', 'dialog');
      ladeKnop.setAttribute('data-vb-schuif', '');
      extra.insertBefore(ladeKnop, extra.firstChild);

      var scrollStand = '';
      var sluitLade = function () { if (lade.open) lade.close(); };
      ladeKnop.addEventListener('click', function () {
        if (lade.open) return;
        scrollStand = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        if (typeof lade.showModal === 'function') lade.showModal();
        else lade.setAttribute('open', '');
      });
      lade.addEventListener('close', function () {
        document.documentElement.style.overflow = scrollStand;
        ladeKnop.focus();
      });
      lade.addEventListener('click', function (event) {
        // Klik naast het paneel (op de achtergrond) of op een sluitknop.
        if (event.target === lade || event.target.closest('[data-vb-ladedicht]')) sluitLade();
      });
    }

    if (echteGroepen.length && !ladeAan) {
      var extraKop = el('h3', 'neroo-vb2__extra-kop', veilig(T.extras_heading));
      extraKop.setAttribute('data-vb-schuif', '');
      extra.insertBefore(extraKop, extra.firstChild);
    }
    if (echteGroepen.length) {
      // Of de eerste groep open staat is een instelling van de sectie.
      var eersteOpen = data.eersteOpen !== false;
      echteGroepen.forEach(function (item, i) { zetOpen(item, eersteOpen && i === 0); });
    }

    // Losse upsells: elk een eigen vinkje, tussen de groepen en de
    // configuratieservice.
    var heeftLosse = rijen.some(function (rij) { return rij.extra; });
    var losseLijst = el('div', 'neroo-vb2__losse');
    losseLijst.setAttribute('role', 'list');
    if (heeftLosse) extra.appendChild(losseLijst);

    // Configuratieservice: vinkje onder de laatste groep.
    var serviceEl = null;
    if (service) {
      var keuzeKnop = function (modus, icoon, titel, sub) {
        return '<button type="button" class="neroo-vb2__keuze" data-vb-modus="' + modus + '" aria-pressed="false">' +
          '<span class="neroo-vb2__keuze-icoon">' + icoon + '</span>' +
          '<span class="neroo-vb2__keuze-titel">' + veilig(titel) + '</span>' +
          '<span class="neroo-vb2__keuze-sub">' + veilig(sub) + '</span></button>';
      };
      serviceEl = el('div', 'neroo-vb2__service',
        '<label class="neroo-vb2__service-kop">' +
          '<input type="checkbox" class="neroo-vb2__service-vink" data-vb-service>' +
          '<span class="neroo-vb2__service-tekst">' +
            '<span class="neroo-vb2__service-titel">' + veilig(T.service_title) + '</span>' +
            '<span class="neroo-vb2__service-uitleg">' + veilig(T.service_text) +
              (service.url ? ' <a href="' + veilig(service.url) + '" target="_blank" rel="noopener">' + veilig(T.service_more) + '</a>' : '') +
            '</span>' +
          '</span>' +
          '<span class="neroo-vb2__service-prijs">' +
            '<span class="neroo-vb2__prijs-nu" data-vb-serviceprijs></span>' +
            '<span class="neroo-vb2__prijs-extra" data-vb-serviceaantal></span>' +
          '</span>' +
        '</label>' +
        '<div class="neroo-vb2__service-paneel"><div class="neroo-vb2__service-binnen">' +
          '<div class="neroo-vb2__keuzes" role="group">' +
            keuzeKnop('namen', ICOON.label, T.names_yes_title, T.names_yes_sub) +
            keuzeKnop('geen', ICOON.vink, T.names_no_title, T.names_no_sub) +
          '</div>' +
          '<div class="neroo-vb2__namen" data-vb-namen hidden>' +
            '<p class="neroo-vb2__namen-intro">' + veilig(T.names_intro) + '</p>' +
            '<div class="neroo-vb2__namen-velden" data-vb-velden></div>' +
          '</div>' +
          '<p class="neroo-vb2__service-fout" data-vb-servicefout role="alert" hidden></p>' +
        '</div></div>');
      serviceEl.setAttribute('data-vb-schuif', '');
      extra.appendChild(serviceEl);
    }

    if (echteGroepen.length || heeftLosse || serviceEl) kaart.appendChild(extra);

    var totaal = el('div', 'neroo-vb2__totaal',
      '<div class="neroo-vb2__som"><span>' + veilig(T.subtotal) + '</span><span data-vb-subtotaal></span></div>' +
      '<div class="neroo-vb2__kortingen" data-vb-kortingen></div>' +
      '<div class="neroo-vb2__som" data-vb-serviceregel hidden><span>' + veilig(T.service_line) + '</span><span data-vb-servicebedrag></span></div>' +
      '<div class="neroo-vb2__som neroo-vb2__som--totaal"><span>' + veilig(T.total) + '</span><span class="neroo-vb2__totaalbedrag" data-vb-totaal></span></div>' +
      '<span class="neroo-vb2__besparing" data-vb-besparing hidden></span>' +
      '<button type="button" class="neroo-btn neroo-btn--primary neroo-vb2__knop" data-vb-knop><span data-vb-knoptekst>' + veilig(T.add_to_cart) + '</span></button>' +
      '<p class="neroo-vb2__status" data-vb-status role="status" aria-live="polite"></p>' +
      (data.voetregel ? '<p class="neroo-vb2__voetregel">' + veilig(data.voetregel) + '</p>' : '') +
      // Linkje naar een andere manier van samenstellen, bijv. de 2D-configurator
      (data.voetLink && data.voetLinkTekst
        ? '<p class="neroo-vb2__voetlink"><a href="' + veilig(data.voetLink) + '">' + veilig(data.voetLinkTekst) + ICOON.verder + '</a></p>'
        : ''));
    totaal.setAttribute('data-vb-schuif', '');
    kaart.appendChild(totaal);

    var plak = el('div', 'neroo-vb2__plak',
      '<div class="neroo-vb2__plak-prijs"><span class="neroo-vb2__plak-label">' + veilig(T.total) + '</span>' +
      '<span class="neroo-vb2__plak-bedrag" data-vb-plakbedrag></span></div>' +
      '<button type="button" class="neroo-btn neroo-btn--primary neroo-btn--small" data-vb-plakknop>' + veilig(T.add_to_cart) + '</button>');
    plak.setAttribute('aria-hidden', 'true');
    sectie.appendChild(plak);

    var knop = totaal.querySelector('[data-vb-knop]');
    var knopTekst = totaal.querySelector('[data-vb-knoptekst]');
    var plakKnop = plak.querySelector('[data-vb-plakknop]');
    var status = totaal.querySelector('[data-vb-status]');

    // ── Rij-elementen ──
    /** Klein linkje "Bekijk product" (instelling in de sectie), nieuw tabblad. */
    function bekijkLink(url) {
      if (!data.toonBekijk || !url || !T.view_product) return '';
      return '<a class="neroo-vb2__bekijk" href="' + veilig(url) + '" target="_blank" rel="noopener">' + veilig(T.view_product) + '</a>';
    }

    function maakRij(rij) {
      if (rij.extra) return maakLos(rij);
      if (rij.kant) return maakKant(rij);
      var v = maakWeergave(rij);
      rij.el = v.el;
      rij.beeld = v.beeld;
      rij.stuks = v.stuks;
      rij.sub = v.sub;
      rij.prijs = v.prijs;
      rij.prijsExtra = v.prijsExtra;
      rij.acties = v.acties;
      rij.pillen = v.pillen;
      // Met het zijpaneel blijft een artikel uit een groep in het zijpaneel
      // staan; zodra het erbij komt staat er een tweede regel in de lijst.
      // Bij zelf samenstellen staan de artikelen van het blok zelf altijd in
      // de lijst.
      if (ladeAan && rij.thuis >= 0 && !(zelfModus && rij.inSet)) rij.tweede = maakWeergave(rij);
      // Zelf samenstellen: het artikel staat onder "Vaak gekozen" of in de
      // lijst; in het zijpaneel staat het daarnaast altijd in zijn groep.
      if (ladeAan && rij.thuis >= 0 && zelfModus && rij.inSet) rij.ladeKopie = maakWeergave(rij);
      return v.el;
    }

    function maakWeergave(rij) {
      var li = el('li', 'neroo-vb2__rij');
      li.setAttribute('data-vb-schuif', '');
      var url = rij.product.url;
      var titel = rij.product.titel + (rij.los && rij.variant.titel ? ' — ' + rij.variant.titel : '');

      var varianten = '';
      if (!rij.los && rij.product.varianten.length > 1) {
        varianten = '<div class="neroo-vb2__varianten" role="group" aria-label="' + veilig(T.choose) + '">' +
          rij.product.varianten.map(function (v) {
            return '<button type="button" class="neroo-vb2__variant" data-vb-variant="' + v.id + '"' +
              (v.leverbaar ? '' : ' disabled') + '>' + veilig(v.titel) + '</button>';
          }).join('') + '</div>';
      }

      // De foto linkt naar het product, net als de titel. Voor het
      // toetsenbord en de schermlezer is de titel de link; de foto zou
      // dezelfde link alleen maar herhalen. Beide openen in een nieuw
      // tabblad, zodat de samengestelde set in dit tabblad blijft staan.
      // Het groene bolletje met het aantal (zoals op de oplossingen-pagina's)
      // staat bij de foto; het getal staat ook in de teller ernaast.
      var foto = '<img alt="" loading="lazy" width="64" height="64" data-vb-beeld>' +
        '<span class="neroo-vb2__rij-stuks" data-vb-stuks hidden></span>';

      li.innerHTML =
        (url
          ? '<a class="neroo-vb2__rij-beeld" href="' + veilig(url) + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">' + foto + '</a>'
          : '<div class="neroo-vb2__rij-beeld">' + foto + '</div>') +
        '<div class="neroo-vb2__rij-info">' +
          (url
            ? '<a class="neroo-vb2__rij-titel" href="' + veilig(url) + '" target="_blank" rel="noopener">' + veilig(titel) + '</a>'
            : '<span class="neroo-vb2__rij-titel">' + veilig(titel) + '</span>') +
          '<span class="neroo-vb2__rij-sub" data-vb-sub></span>' +
          // Uitvoeringen en prijs in één omhulsel: in het zijpaneel staan ze
          // samen op één regel, elders telt het omhulsel niet mee.
          '<div class="neroo-vb2__rij-onder">' +
            varianten +
            '<span class="neroo-vb2__rij-prijsregel">' +
              '<span class="neroo-vb2__prijs"><span class="neroo-vb2__prijs-nu" data-vb-prijs></span><span class="neroo-vb2__prijs-extra" data-vb-prijsextra></span></span>' +
              bekijkLink(url) +
            '</span>' +
          '</div>' +
        '</div>' +
        '<div class="neroo-vb2__rij-rechts">' +
          '<div class="neroo-vb2__acties" data-vb-acties></div>' +
        '</div>';

      var weergave = {
        el: li,
        beeld: li.querySelector('[data-vb-beeld]'),
        stuks: li.querySelector('[data-vb-stuks]'),
        sub: li.querySelector('[data-vb-sub]'),
        prijs: li.querySelector('[data-vb-prijs]'),
        prijsExtra: li.querySelector('[data-vb-prijsextra]'),
        acties: li.querySelector('[data-vb-acties]'),
        pillen: Array.prototype.slice.call(li.querySelectorAll('[data-vb-variant]'))
      };

      weergave.pillen.forEach(function (pil) {
        pil.addEventListener('click', function () {
          var id = pil.getAttribute('data-vb-variant');
          var nieuw = rij.product.varianten.filter(function (v) { return String(v.id) === id; })[0];
          if (!nieuw || nieuw === rij.variant) return;
          wijzig(function () { rij.variant = nieuw; });
        });
      });

      li.addEventListener('click', function (event) {
        var doel = event.target.closest('[data-vb-doe]');
        if (!doel || doel.disabled) return;
        var doe = doel.getAttribute('data-vb-doe');
        wijzig(function () {
          if (doe === 'meer') rij.aantal = Math.min(99, rij.aantal + 1);
          if (doe === 'minder') rij.aantal = Math.max(0, rij.aantal - 1);
          if (doe === 'weg') rij.aantal = 0;
          if (doe === 'erbij') rij.aantal = 1;
          if (rij.aantal === 0) rij.zelf = false;
          else if (!aantalInSet(rij, actief)) rij.zelf = true;
        }, !rij.tweede && !(lade && lade.contains(li)) && (doe === 'erbij' || rij.aantal <= 1) ? rij : null);
      });

      return weergave;
    }

    /**
     * De gekozen kant-en-klare set: foto, naam, uitvoering, vast 1 stuk, en
     * uitklapbaar wat erin zit. De foto's van de onderdelen volgen de gekozen
     * uitvoering (kleur, MINI).
     */
    function maakKant(rij) {
      var li = el('li', 'neroo-vb2__rij neroo-vb2__rij--kant');
      li.setAttribute('data-vb-schuif', '');
      var url = rij.product.url;
      var inhoudId = 'neroo-vb2-inhoud-' + nummer(data.blokId) + '-' + rij.product.id;
      var regels = doosRegels(rij.product);
      // "Dit zit in deze Comfort set": de naam na " - " in de producttitel.
      var titel = String(rij.product.titel || '');
      var setNaam = titel.indexOf(' - ') > 0 ? titel.slice(titel.indexOf(' - ') + 3) : titel;
      var foto = '<img alt="" loading="lazy" width="64" height="64" data-vb-beeld>';
      li.innerHTML =
        (url
          ? '<a class="neroo-vb2__rij-beeld" href="' + veilig(url) + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">' + foto + '</a>'
          : '<div class="neroo-vb2__rij-beeld">' + foto + '</div>') +
        '<div class="neroo-vb2__rij-info">' +
          (url
            ? '<a class="neroo-vb2__rij-titel" href="' + veilig(url) + '" target="_blank" rel="noopener">' + veilig(rij.product.titel) + '</a>'
            : '<span class="neroo-vb2__rij-titel">' + veilig(rij.product.titel) + '</span>') +
          '<span class="neroo-vb2__rij-sub" data-vb-sub></span>' +
          (regels.length ? '<span class="neroo-vb2__inhoud-kort" data-vb-kort></span>' : '') +
          '<span class="neroo-vb2__rij-prijsregel">' +
            '<span class="neroo-vb2__prijs"><span class="neroo-vb2__prijs-nu" data-vb-prijs></span><span class="neroo-vb2__prijs-extra" data-vb-prijsextra></span></span>' +
            bekijkLink(url) +
          '</span>' +
          (regels.length
            ? '<span class="neroo-vb2__rij-links">' +
              '<button type="button" class="neroo-vb2__inhoud-knop" aria-expanded="false" aria-controls="' + inhoudId + '">' +
                veilig(vul(T.contents, { set: setNaam })) + ICOON.pijl + '</button>' +
              '</span>'
            : '') +
        '</div>' +
        '<div class="neroo-vb2__rij-rechts">' +
          '<div class="neroo-vb2__acties"><span class="neroo-vb2__vast" title="' + veilig(T.fixed) + '">' + ICOON.slot + '1×</span></div>' +
        '</div>' +
        (regels.length
          ? '<div class="neroo-vb2__inhoud" id="' + inhoudId + '"><div class="neroo-vb2__inhoud-binnen">' +
            '<ul class="neroo-vb2__inhoud-lijst" role="list" data-vb-inhoud></ul></div></div>'
          : '');

      rij.el = li;
      rij.beeld = li.querySelector('[data-vb-beeld]');
      rij.sub = li.querySelector('[data-vb-sub]');
      rij.prijs = li.querySelector('[data-vb-prijs]');
      rij.prijsExtra = li.querySelector('[data-vb-prijsextra]');
      rij.kort = li.querySelector('[data-vb-kort]');
      rij.inhoud = li.querySelector('[data-vb-inhoud]');

      var knopje = li.querySelector('.neroo-vb2__inhoud-knop');
      if (knopje) {
        // Open of dicht geldt voor alle sets samen en blijft staan bij een
        // andere set, een ander paneel of een andere opbouw.
        rij.zetInhoudOpen = function (open) {
          li.classList.toggle('is-open', open);
          knopje.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        rij.zetInhoudOpen(Boolean(keuze.inhoudOpen));
        knopje.addEventListener('click', function () {
          keuze.inhoudOpen = !li.classList.contains('is-open');
          kantRijen.forEach(function (r) { if (r.zetInhoudOpen) r.zetInhoudOpen(keuze.inhoudOpen); });
        });
      }
      return li;
    }

    function werkKantBij(rij) {
      zetBeeld(rij);
      var v = rij.variant;
      var kan = leverbaar(rij);
      rij.sub.textContent = kan ? (v.titel || rij.product.sub || '') : (T.sold_out || '');
      rij.sub.classList.toggle('is-uitverkocht', !kan);
      rij.sub.hidden = !rij.sub.textContent;
      rij.prijs.textContent = geld(v.prijs);
      var extra = v.van > v.prijs ? '<s>' + veilig(geld(v.van)) + '</s>' : '';
      rij.prijsExtra.innerHTML = extra;
      rij.prijsExtra.hidden = !extra;
      tekenInhoud(rij);
    }

    /** Lijst "Dit zit in je set" en de korte regel; opnieuw als een foto binnen is. */
    function tekenInhoud(rij) {
      if (!rij.inhoud) return;
      var opnieuw = function () { if (rij.el.isConnected) tekenInhoud(rij); };
      var delen = doosRegels(rij.product).map(function (regel) { return onderdeel(regel, rij, opnieuw); });
      var teken = JSON.stringify(delen);
      if (rij.inhoud.getAttribute('data-teken') === teken) return;
      rij.inhoud.setAttribute('data-teken', teken);
      rij.kort.textContent = delen.map(function (d) { return (d.aantal ? d.aantal + '× ' : '') + d.titel; }).join(' · ');
      rij.inhoud.innerHTML = delen.map(function (d) {
        var naam = (d.aantal ? d.aantal + '× ' : '') + veilig(d.titel);
        return '<li class="neroo-vb2__inhoud-regel">' +
          '<span class="neroo-vb2__inhoud-beeld">' + (d.beeld ? '<img src="' + veilig(d.beeld) + '" alt="" loading="lazy" width="40" height="40">' : '') + '</span>' +
          (d.url
            ? '<a class="neroo-vb2__inhoud-naam" href="' + veilig(d.url) + '" target="_blank" rel="noopener">' + naam + '</a>'
            : '<span class="neroo-vb2__inhoud-naam">' + naam + '</span>') +
          '</li>';
      }).join('');
    }

    function werkKantkaartBij(s) {
      var rij = s.rij, v = rij.variant, knop = s.knop;
      var kan = leverbaar(rij);
      var img = knop.querySelector('[data-vb-kantbeeld]');
      var bron = v.beeld || rij.product.beeld || '';
      if (img.getAttribute('data-bron') !== bron) {
        img.setAttribute('data-bron', bron);
        if (bron) img.src = bron; else img.removeAttribute('src');
      }
      knop.querySelector('[data-vb-kantprijs]').textContent = geld(v.prijs);
      var van = knop.querySelector('[data-vb-kantvan]');
      var heeftVan = v.van > v.prijs;
      van.hidden = !heeftVan;
      van.innerHTML = heeftVan ? '<span class="neroo-vb2__alleen-lezer">' + veilig(T.set_normal) + ' </span>' + veilig(geld(v.van)) : '';
      var bespaar = knop.querySelector('[data-vb-kantbespaar]');
      bespaar.textContent = !kan ? (T.sold_out || '') : heeftVan ? vul(T.save, { bedrag: geld(v.van - v.prijs) }) : '';
      bespaar.hidden = !bespaar.textContent;
      bespaar.classList.toggle('is-uitverkocht', !kan);
      knop.classList.toggle('is-uit', !kan);
      knop.setAttribute('aria-disabled', kan ? 'false' : 'true');
    }

    /**
     * Losse upsell: een kaart met vinkje, foto, naam, korte tekst en prijs.
     * Na aanvinken verschijnen de keuze van de uitvoering en het aantal. Het
     * product blijft op zijn plek staan; het gaat niet naar de set.
     */
    function maakLos(rij) {
      var kaartje = el('div', 'neroo-vb2__los');
      kaartje.setAttribute('role', 'listitem');
      kaartje.setAttribute('data-vb-schuif', '');

      var varianten = '';
      if (rij.product.varianten.length > 1) {
        varianten = '<div class="neroo-vb2__varianten" role="group" aria-label="' + veilig(T.choose) + '">' +
          rij.product.varianten.map(function (v) {
            return '<button type="button" class="neroo-vb2__variant" data-vb-variant="' + v.id + '"' +
              (v.leverbaar ? '' : ' disabled') + '>' + veilig(v.titel) + '</button>';
          }).join('') + '</div>';
      }

      kaartje.innerHTML =
        '<label class="neroo-vb2__los-kop">' +
          '<input type="checkbox" class="neroo-vb2__service-vink" data-vb-losvink>' +
          '<span class="neroo-vb2__los-beeld"><img alt="" loading="lazy" width="48" height="48" data-vb-beeld></span>' +
          '<span class="neroo-vb2__los-tekst">' +
            '<span class="neroo-vb2__los-titel">' + veilig(rij.product.titel) + '</span>' +
            '<span class="neroo-vb2__los-uitleg" data-vb-sub></span>' +
            bekijkLink(rij.product.url) +
          '</span>' +
          '<span class="neroo-vb2__prijs"><span class="neroo-vb2__prijs-nu" data-vb-prijs></span><span class="neroo-vb2__prijs-extra" data-vb-prijsextra></span></span>' +
        '</label>' +
        '<div class="neroo-vb2__los-paneel"><div class="neroo-vb2__los-binnen">' +
          varianten +
          '<div class="neroo-vb2__acties" data-vb-acties></div>' +
        '</div></div>';

      rij.el = kaartje;
      rij.beeld = kaartje.querySelector('[data-vb-beeld]');
      rij.sub = kaartje.querySelector('[data-vb-sub]');
      rij.prijs = kaartje.querySelector('[data-vb-prijs]');
      rij.prijsExtra = kaartje.querySelector('[data-vb-prijsextra]');
      rij.acties = kaartje.querySelector('[data-vb-acties]');
      rij.vink = kaartje.querySelector('[data-vb-losvink]');
      rij.pillen = Array.prototype.slice.call(kaartje.querySelectorAll('[data-vb-variant]'));

      rij.vink.addEventListener('change', function () {
        var aan = rij.vink.checked;
        wijzig(function () {
          rij.aantal = aan ? Math.max(1, rij.aantal) : 0;
          rij.zelf = aan;
        });
      });

      rij.pillen.forEach(function (pil) {
        pil.addEventListener('click', function () {
          var id = pil.getAttribute('data-vb-variant');
          var nieuw = rij.product.varianten.filter(function (v) { return String(v.id) === id; })[0];
          if (!nieuw || nieuw === rij.variant) return;
          wijzig(function () { rij.variant = nieuw; });
        });
      });

      // Min bij 1 stuk haalt het vinkje weg.
      rij.acties.addEventListener('click', function (event) {
        var doel = event.target.closest('[data-vb-doe]');
        if (!doel || doel.disabled) return;
        var doe = doel.getAttribute('data-vb-doe');
        wijzig(function () {
          if (doe === 'meer') rij.aantal = Math.min(99, rij.aantal + 1);
          if (doe === 'minder') rij.aantal = Math.max(0, rij.aantal - 1);
          rij.zelf = rij.aantal > 0;
        });
      });

      return kaartje;
    }

    function werkLosBij(rij) {
      var kan = leverbaar(rij);
      var aan = rij.aantal > 0;
      zetBeeld(rij);

      var tekst = kan ? (rij.extra.tekst || rij.product.sub || '') : (T.sold_out || '');
      rij.sub.textContent = tekst;
      rij.sub.hidden = !tekst;
      rij.sub.classList.toggle('is-uitverkocht', !kan);

      rij.vink.checked = aan;
      rij.vink.disabled = !kan && !aan;
      rij.el.classList.toggle('is-aan', aan);
      rij.el.classList.toggle('is-uit', !kan && !aan);

      werkPillenBij(rij);
      werkPrijsBij(rij);

      var teken = aan ? 'teller:' + rij.aantal : 'uit';
      if (rij.acties.getAttribute('data-teken') === teken) return;
      rij.acties.setAttribute('data-teken', teken);
      rij.acties.innerHTML = aan
        ? '<div class="neroo-vb2__aantal" role="group" aria-label="' + veilig(T.quantity) + ': ' + veilig(rij.product.titel) + '">' +
            '<button type="button" data-vb-doe="minder" aria-label="' + veilig(T.decrease) + '">' + ICOON.min + '</button>' +
            '<span class="neroo-vb2__aantal-getal" aria-live="polite">' + rij.aantal + '</span>' +
            '<button type="button" data-vb-doe="meer" aria-label="' + veilig(T.increase) + '"' + (rij.aantal >= 99 ? ' disabled' : '') + '>' + ICOON.plus + '</button>' +
          '</div>'
        : '';
    }

    // Weergave w: de elementen van een rij. Meestal de rij zelf; met het
    // zijpaneel heeft een rij uit een groep er twee (zijpaneel en lijst).
    function werkPillenBij(rij, w) {
      w = w || rij;
      w.pillen.forEach(function (pil) {
        var gekozen = pil.getAttribute('data-vb-variant') === String(rij.variant.id);
        pil.classList.toggle('is-gekozen', gekozen);
        pil.setAttribute('aria-pressed', gekozen ? 'true' : 'false');
      });
    }

    function werkPrijsBij(rij, w) {
      w = w || rij;
      var v = rij.variant;
      var stuks = Math.max(1, rij.aantal);
      w.prijs.textContent = geld(v.prijs * stuks);
      // De stukprijs staat links van de vergelijkingsprijs. Zo blijft de
      // vergelijkingsprijs recht onder de prijs staan, ook als het aantal
      // verandert.
      var extra = '';
      if (rij.aantal > 1) extra += '<span class="neroo-vb2__prijs-stuk">' + veilig(geld(v.prijs)) + ' ' + veilig(T.each) + '</span>';
      if (data.toonVanprijs && v.van > v.prijs) extra += '<s>' + veilig(geld(v.van * stuks)) + '</s>';
      w.prijsExtra.innerHTML = extra;
      w.prijsExtra.hidden = !extra;
    }

    function zetBeeld(rij, w) {
      var beeld = (w || rij).beeld;
      var bron = rij.variant.beeld || rij.product.beeld || '';
      if (beeld.getAttribute('data-bron') === bron) return;
      var eerste = !beeld.getAttribute('data-bron');
      beeld.setAttribute('data-bron', bron);
      if (!bron) { beeld.removeAttribute('src'); return; }
      if (eerste || rustig) { beeld.src = bron; return; }
      beeld.classList.add('is-wissel');
      setTimeout(function () {
        beeld.src = bron;
        beeld.classList.remove('is-wissel');
      }, 180);
    }

    function werkRijBij(rij) {
      if (rij.extra) return werkLosBij(rij);
      if (rij.kant) return werkKantBij(rij);
      werkWeergaveBij(rij, rij, rij.plek);
      if (rij.tweede) werkWeergaveBij(rij, rij.tweede, rij.tweedePlek);
      if (rij.ladeKopie) werkWeergaveBij(rij, rij.ladeKopie, 'groep');
    }

    function werkWeergaveBij(rij, w, plek) {
      var kan = leverbaar(rij);
      zetBeeld(rij, w);

      w.sub.textContent = kan ? (rij.product.sub || '') : (T.sold_out || '');
      w.sub.classList.toggle('is-uitverkocht', !kan);
      w.sub.hidden = !w.sub.textContent;

      werkPillenBij(rij, w);
      werkPrijsBij(rij, w);

      // Grijs als hij uit de set is gehaald; een suggestie bij zelf
      // samenstellen is niet grijs.
      w.el.classList.toggle('is-leeg', rij.aantal === 0 && plek === 'set' && !zelfModus);

      // Aantal bij de foto: alleen in de set, pas vanaf 2 stuks, en uit te
      // zetten in de sectie-instellingen.
      var toonStuks = data.toonStuks !== false && plek === 'set' && rij.aantal > 1;
      w.stuks.hidden = !toonStuks;
      if (toonStuks) w.stuks.textContent = rij.aantal + '×';

      var soort;
      if (!kan) soort = 'niets';
      else if (rij.aantal === 0) soort = 'erbij';
      else if (rij.vast && !rij.zelf) soort = 'vast';
      else if (rij.vast) soort = 'vast-weg';
      else soort = 'teller';

      var teken = soort + ':' + rij.aantal;
      if (w.acties.getAttribute('data-teken') === teken) return;
      w.acties.setAttribute('data-teken', teken);
      var naam = veilig(rij.product.titel);

      if (soort === 'niets') {
        w.acties.innerHTML = '';
      } else if (soort === 'erbij') {
        w.acties.innerHTML = '<button type="button" class="neroo-vb2__rond neroo-vb2__rond--toevoegen" data-vb-doe="erbij" aria-label="' +
          veilig(T.add) + ': ' + naam + '">' + ICOON.plus + '</button>';
      } else if (soort === 'vast' || soort === 'vast-weg') {
        w.acties.innerHTML = '<span class="neroo-vb2__vast" title="' + veilig(T.fixed) + '">' + ICOON.slot + '1×</span>' +
          (soort === 'vast-weg'
            ? '<button type="button" class="neroo-vb2__rond neroo-vb2__rond--weg" data-vb-doe="weg" aria-label="' + veilig(T.remove) + ': ' + naam + '">' + ICOON.kruis + '</button>'
            : '');
      } else {
        w.acties.innerHTML = '<div class="neroo-vb2__aantal" role="group" aria-label="' + veilig(T.quantity) + ': ' + naam + '">' +
          '<button type="button" data-vb-doe="minder" aria-label="' + veilig(T.decrease) + '">' + ICOON.min + '</button>' +
          '<span class="neroo-vb2__aantal-getal" aria-live="polite">' + rij.aantal + '</span>' +
          '<button type="button" data-vb-doe="meer" aria-label="' + veilig(T.increase) + '"' + (rij.aantal >= 99 ? ' disabled' : '') + '>' + ICOON.plus + '</button>' +
          '</div>';
      }
    }

    rijen.forEach(maakRij);

    // ── Plaatsen ──
    function plekVan(rij) {
      if (rij.extra) return 'los';
      if (rij.kant) return rij.aantal > 0 ? 'set' : 'weg';
      // Met het zijpaneel blijft een artikel uit een groep in die groep.
      if (rij.tweede) return 'groep';
      if (rij.aantal > 0) return 'set';
      if (zelfModus && rij.inSet) return 'suggestie';
      if (rij.thuis >= 0 && groepen[rij.thuis]) return 'groep';
      return aantalInSet(rij, actief) > 0 || (rij.inSet && Number(rij.perSet[actief]) > 0) ? 'set' : 'weg';
    }

    // Zelf samenstellen: in het groene vlak wat erin zit (het paneel, daarna
    // in de volgorde van toevoegen, ook uit het zijpaneel). Eronder, buiten
    // het vlak, de artikelen van het blok die nog op 0 staan: suggesties met
    // een plusje. Komt er een bij, dan schuift hij omhoog het vlak in.
    var toegevoegdTeller = 0;

    function plaats() {
      var perLijst = [];
      var leg = function (rij, elem, doel) {
        if (!doel) { if (elem.parentNode) elem.parentNode.removeChild(elem); return; }
        var bak = perLijst.filter(function (b) { return b.lijst === doel; })[0];
        if (!bak) { bak = { lijst: doel, items: [] }; perLijst.push(bak); }
        bak.items.push({ rij: rij, el: elem });
      };
      rijen.forEach(function (rij) {
        if (zelfModus) {
          if (rij.aantal > 0 && !rij.toegevoegd) rij.toegevoegd = ++toegevoegdTeller;
          if (!rij.aantal) rij.toegevoegd = 0;
        }
        rij.plek = plekVan(rij);
        leg(rij, rij.el, rij.plek === 'set' ? setLijst
          : rij.plek === 'groep' ? groepen[rij.thuis].lijst
          : rij.plek === 'suggestie' ? suggestieLijst
          : rij.plek === 'los' ? losseLijst : null);
        if (rij.tweede) {
          rij.tweedePlek = rij.aantal > 0 ? 'set' : '';
          leg(rij, rij.tweede.el, rij.tweedePlek ? setLijst : null);
        }
        if (rij.ladeKopie) leg(rij, rij.ladeKopie.el, groepen[rij.thuis] ? groepen[rij.thuis].lijst : null);
      });

      // Eigen toevoegingen komen onder de producten van de set. Bij zelf
      // samenstellen in de volgorde van toevoegen.
      perLijst.forEach(function (bak) {
        var zelfLijst = zelfModus && bak.lijst === setLijst;
        var groepLijst = groepen.some(function (g) { return g && g.lijst === bak.lijst; });
        bak.items.sort(function (a, b) {
          if (zelfLijst) return a.rij.toegevoegd - b.rij.toegevoegd;
          if (bak.lijst === setLijst && a.rij.zelf !== b.rij.zelf) return a.rij.zelf ? 1 : -1;
          if (groepLijst) {
            var pa = plekInGroep[String(a.rij.product.id)], pb = plekInGroep[String(b.rij.product.id)];
            if (pa !== pb) return (pa == null ? 999 : pa) - (pb == null ? 999 : pb);
          }
          return a.rij.volgnummer - b.rij.volgnummer;
        });
        bak.items.forEach(function (item, i) {
          if (bak.lijst.children[i] !== item.el) bak.lijst.insertBefore(item.el, bak.lijst.children[i] || null);
        });
      });
      if (suggestieBlok) suggestieBlok.hidden = !suggestieLijst.children.length;

      groepen.forEach(function (item) {
        if (!item) return;
        var n = item.lijst.children.length;
        item.teller.textContent = n;
        item.teller.hidden = n === 0;
        item.leeg.hidden = n !== 0;
      });
    }

    function gewijzigd() {
      return rijen.some(function (rij) { return rij.aantal !== aantalInSet(rij, actief); });
    }

    // ── Bedragen laten oplopen ──
    var tellers = [];
    function telNaar(elem, doel) {
      var t = tellers.filter(function (x) { return x.elem === elem; })[0];
      if (!t) { t = { elem: elem, nu: doel, id: 0, vangnet: 0 }; tellers.push(t); elem.textContent = geld(doel); return; }
      cancelAnimationFrame(t.id);
      clearTimeout(t.vangnet);
      var direct = function () { t.nu = doel; elem.textContent = geld(doel); };
      if (rustig || document.hidden || t.nu === doel) { direct(); return; }
      var van = t.nu, begin = null, duur = 380;
      function stap(tijd) {
        if (begin === null) begin = tijd;
        var p = Math.min(1, (tijd - begin) / duur);
        var zacht = 1 - Math.pow(1 - p, 3);
        t.nu = Math.round(van + (doel - van) * zacht);
        elem.textContent = geld(t.nu);
        if (p < 1) t.id = requestAnimationFrame(stap);
        else clearTimeout(t.vangnet);
      }
      t.id = requestAnimationFrame(stap);
      // Een browser die niet tekent (tabblad op de achtergrond) slaat de
      // animatie over; het bedrag moet dan toch kloppen.
      t.vangnet = setTimeout(function () { cancelAnimationFrame(t.id); direct(); }, duur + 120);
    }

    function werkTotaalBij() {
      var r = reken();

      var sub = totaal.querySelector('[data-vb-subtotaal]');
      sub.innerHTML = (data.toonVanprijs && r.van > r.subtotaal ? '<s>' + veilig(geld(r.van)) + '</s>' : '') + veilig(geld(r.subtotaal));

      // Per behaalde stapelkorting één regel: "Stapelkorting inbraak −€10".
      var kortingen = totaal.querySelector('[data-vb-kortingen]');
      var behaald = r.stapels.filter(function (t) { return t.korting > 0; });
      var kortingTeken = behaald.map(function (t) { return t.stapel.id + ':' + t.korting; }).join('|');
      if (kortingen.getAttribute('data-teken') !== kortingTeken) {
        kortingen.setAttribute('data-teken', kortingTeken);
        kortingen.innerHTML = behaald.map(function (t) {
          return '<div class="neroo-vb2__som neroo-vb2__som--korting"><span>' + veilig(t.stapel.naam || T.discount) + '</span>' +
            '<span>−' + veilig(geld(t.korting)) + '</span></div>';
        }).join('');
      }
      werkStapelsBij(r.stapels);

      var serviceRegel = totaal.querySelector('[data-vb-serviceregel]');
      serviceRegel.hidden = r.servicePrijs <= 0;
      if (r.servicePrijs > 0) totaal.querySelector('[data-vb-servicebedrag]').textContent = geld(r.servicePrijs);

      telNaar(totaal.querySelector('[data-vb-totaal]'), r.totaal);
      telNaar(plak.querySelector('[data-vb-plakbedrag]'), r.totaal);

      var besparing = totaal.querySelector('[data-vb-besparing]');
      var bespaard = (data.toonVanprijs ? r.van : r.subtotaal) - (r.subtotaal - r.korting);
      besparing.hidden = bespaard <= 0;
      if (bespaard > 0) besparing.textContent = vul(T.you_save, { bedrag: geld(bespaard) });

      var leeg = r.stuks === 0;
      knop.disabled = leeg || bezig;
      plakKnop.disabled = leeg || bezig;

      // Zijpaneel: hoeveel artikelen uit de groepen erbij zitten, en het totaal.
      if (lade) {
        var erbij = rijen.filter(function (rij) { return (rij.tweede || rij.ladeKopie) && rij.aantal > 0; }).length;
        var teller = ladeKnop.querySelector('[data-vb-ladeteller]');
        teller.textContent = vul(T.drawer_added, { aantal: erbij });
        teller.hidden = erbij === 0;
        ladeKnop.classList.toggle('is-gevuld', erbij > 0);
        telNaar(lade.querySelector('[data-vb-ladetotaal]'), r.totaal);
      }

      var plekActief = -1;
      // Zijn alle kant-en-klare sets uitverkocht, dan is er geen gekozen set
      // en ook geen lege bestelling onder de kaarten.
      var kantGekozen = kantRijen.some(function (rij) { return rij.aantal > 0; });
      var actieveSleutel = setModus ? (kantGekozen ? 'k' + kantKeuze : '') : actief;
      if (setModus && lijstBlok) lijstBlok.hidden = !setLijst.children.length;
      setKnoppen.forEach(function (s, i) {
        if (s.sleutel === actieveSleutel) plekActief = i;
        s.knop.classList.toggle('is-actief', s.sleutel === actieveSleutel);
        s.knop.setAttribute('aria-pressed', s.sleutel === actieveSleutel ? 'true' : 'false');
        if (s.rij) werkKantkaartBij(s);
      });
      tekenOpties();
      tekenSetlijn();
      // Staat de gekozen badge aan de rand, dan heeft het vlak daar geen ronde
      // hoek: de rand van de badge loopt er recht in over.
      if (setKnoppen.length && !lijstBlok) {
        setLijst.classList.toggle('is-links', plekActief === 0);
        setLijst.classList.toggle('is-rechts', plekActief === setKnoppen.length - 1);
      }

      if (balk) {
        // Zelfde schaal als de bolletjes, zodat de vulling een bolletje
        // raakt op het moment dat de drempel gehaald is.
        var deel = plekOpBalk(r.telBedrag);
        balk.querySelector('[data-vb-vulling]').style.width =
          deel <= 0 ? '0%' : deel >= 1 ? '100%' : 'calc(8px + (100% - 16px) * ' + deel.toFixed(4) + ')';
        var volgende = null;
        tiers.forEach(function (t, i) {
          var behaald = r.telBedrag >= t.vanaf;
          balk.querySelector('[data-vb-punt="' + i + '"]').classList.toggle('is-behaald', behaald);
          balk.querySelector('[data-vb-label="' + i + '"]').classList.toggle('is-behaald', behaald);
          if (!behaald && !volgende) volgende = t;
        });
        var tekst;
        if (volgende) {
          tekst = vul(r.korting > 0 ? T.bar_next : T.bar_start, {
            bedrag: '<strong>' + veilig(geld(volgende.vanaf - r.telBedrag)) + '</strong>',
            korting: '<strong>' + veilig(geldKort(volgende.korting)) + '</strong>'
          });
        } else {
          tekst = vul(T.bar_reached, { korting: '<strong>' + veilig(geldKort(r.korting)) + '</strong>' });
        }
        balk.querySelector('[data-vb-balktekst]').innerHTML = tekst;
      }
    }

    /**
     * Staffel in de groep en het label op de groepskop. De bolletjes staan op
     * gelijke afstand; tussen twee drempels loopt de vulling mee per stuk.
     */
    function werkStapelsBij(tellingen) {
      groepen.forEach(function (item) {
        if (!item || !item.stapel) return;
        var t = tellingen[stapels.indexOf(item.stapel)];
        var treden = item.stapel.treden;
        var hoogste = treden.reduce(function (m, x) { return Math.max(m, x.korting); }, 0);

        if (item.kortingLabel) {
          item.kortingLabel.textContent = t.korting > 0
            ? vul(T.stack_badge_reached, { korting: geldKort(t.korting) })
            : vul(T.stack_badge, { korting: geldKort(hoogste) });
          item.kortingLabel.classList.toggle('is-behaald', t.korting > 0);
        }

        var vak = item.stapelVak;
        var deel = 1, vorige = 0;
        for (var i = 0; i < treden.length; i++) {
          if (t.stuks < treden[i].stuks) {
            var stuk = treden[i].stuks - vorige;
            deel = (i + (stuk > 0 ? Math.max(0, t.stuks - vorige) / stuk : 0)) / treden.length;
            break;
          }
          vorige = treden[i].stuks;
        }
        vak.querySelector('[data-vb-stapelvulling]').style.width = (deel * 100).toFixed(2) + '%';
        treden.forEach(function (trede, i) {
          var gehaald = t.stuks >= trede.stuks;
          vak.querySelector('[data-vb-stapelpunt="' + i + '"]').classList.toggle('is-behaald', gehaald);
          vak.querySelector('[data-vb-stapeltrede="' + i + '"]').classList.toggle('is-behaald', gehaald);
        });

        var tekst;
        var sterk = function (centen) { return '<strong>' + veilig(geldKort(centen)) + '</strong>'; };
        if (!t.volgende) {
          tekst = vul(T.stack_max, { korting: sterk(t.korting || hoogste) });
        } else {
          var nog = t.volgende.stuks - t.stuks;
          tekst = t.trede
            ? vul(nog === 1 ? T.stack_more_one : T.stack_more, { huidig: sterk(t.korting), aantal: nog, korting: sterk(t.volgende.korting) })
            : vul(nog === 1 ? T.stack_next_one : T.stack_next, { aantal: nog, korting: sterk(t.volgende.korting) });
        }
        vak.querySelector('[data-vb-stapeltekst]').innerHTML = tekst;
      });
    }

    // ── Soepel verschuiven ──
    function meet() {
      var posities = [];
      Array.prototype.forEach.call(kaart.querySelectorAll('[data-vb-schuif]'), function (node) {
        var r = node.getBoundingClientRect();
        if (r.width || r.height) posities.push({ node: node, top: r.top, left: r.left, breedte: r.width, hoogte: r.height });
      });
      return posities;
    }

    function zichtbaar(node) {
      var paneel = node.closest('.neroo-vb2__groep');
      return !paneel || paneel.classList.contains('is-open');
    }

    function schuif(voor, vlieger) {
      if (rustig || !kaart.animate) return;
      var vliegStart = null;

      voor.forEach(function (oud) {
        var node = oud.node;
        if (!node.isConnected) return;
        var nu = node.getBoundingClientRect();
        var dx = oud.left - nu.left, dy = oud.top - nu.top;
        if (vlieger && node === vlieger.el) { vliegStart = oud; return; }
        if (!zichtbaar(node) || (Math.abs(dx) < 1 && Math.abs(dy) < 1)) return;
        node.animate(
          [{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }],
          { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
      });

      // Nieuwe rijen (nog niet gemeten) komen rustig in beeld.
      var gemeten = voor.map(function (o) { return o.node; });
      rijen.forEach(function (rij) {
        if (rij.el.isConnected && gemeten.indexOf(rij.el) === -1 && zichtbaar(rij.el)) {
          rij.el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
            { duration: 280, easing: 'ease-out' });
        }
      });

      if (!vlieger || !vliegStart) return;

      // De rij die van lijst wisselt vliegt als kopie naar zijn nieuwe plek.
      var doelNode = vlieger.el.isConnected && zichtbaar(vlieger.el)
        ? vlieger.el
        : (groepen[vlieger.thuis] ? groepen[vlieger.thuis].kop : null);
      if (!doelNode) return;
      var doel = doelNode.getBoundingClientRect();
      var inBeeld = doelNode === vlieger.el;

      var geest = vlieger.el.cloneNode(true);
      geest.className = 'neroo-vb2__rij neroo-vb2__geest';
      geest.removeAttribute('data-vb-schuif');
      geest.style.left = vliegStart.left - 12 + 'px';
      geest.style.top = vliegStart.top + 'px';
      geest.style.width = vliegStart.breedte + 24 + 'px';
      document.body.appendChild(geest);

      if (inBeeld) vlieger.el.style.visibility = 'hidden';
      var vlucht = geest.animate(
        [
          { transform: 'none', opacity: 1 },
          {
            transform: 'translate(' + (doel.left - vliegStart.left) + 'px,' + (doel.top - vliegStart.top) + 'px)' + (inBeeld ? '' : ' scale(0.92)'),
            opacity: inBeeld ? 1 : 0
          }
        ],
        { duration: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      var klaar = function () {
        if (geest.parentNode) geest.parentNode.removeChild(geest);
        vlieger.el.style.visibility = '';
      };
      vlucht.onfinish = klaar;
      vlucht.oncancel = klaar;
    }

    // ── Configuratieservice: tekenen en bedienen ──
    var veldenTeken = '';

    function toonServiceFout(tekst) {
      if (!serviceEl) return;
      var fout = serviceEl.querySelector('[data-vb-servicefout]');
      fout.textContent = tekst || '';
      fout.hidden = !tekst;
    }

    function werkServiceBij() {
      if (!serviceEl) return;
      var lijst = sensoren();
      var variant = serviceVariant(lijst.length);

      // Zonder sensoren valt er niets te koppelen.
      serviceEl.hidden = !variant;
      if (!variant) { service.aan = false; service.modus = ''; }

      var vink = serviceEl.querySelector('[data-vb-service]');
      vink.checked = service.aan;
      serviceEl.classList.toggle('is-aan', service.aan);

      if (variant) {
        serviceEl.querySelector('[data-vb-serviceprijs]').textContent = (service.aan ? '' : '+ ') + geld(variant.prijs);
        serviceEl.querySelector('[data-vb-serviceaantal]').textContent =
          vul(lijst.length === 1 && T.service_count_one ? T.service_count_one : T.service_count, { aantal: lijst.length });
      }

      Array.prototype.forEach.call(serviceEl.querySelectorAll('[data-vb-modus]'), function (knopje) {
        var gekozen = knopje.getAttribute('data-vb-modus') === service.modus;
        knopje.classList.toggle('is-gekozen', gekozen);
        knopje.setAttribute('aria-pressed', gekozen ? 'true' : 'false');
      });

      var namen = serviceEl.querySelector('[data-vb-namen]');
      var toonNamen = service.aan && service.modus === 'namen';
      namen.hidden = !toonNamen;

      // Velden alleen opnieuw opbouwen als de lijst sensoren veranderd is;
      // wat al is ingevuld blijft staan.
      var teken = toonNamen ? lijst.map(function (s) { return s.sleutel; }).join('|') : '';
      if (teken === veldenTeken) return;
      veldenTeken = teken;

      var velden = serviceEl.querySelector('[data-vb-velden]');
      velden.innerHTML = '';
      if (!toonNamen) return;
      lijst.forEach(function (sensor, i) {
        var id = 'neroo-vb2-naam-' + nummer(data.blokId) + '-' + i;
        var veld = el('div', 'neroo-vb2__veld',
          '<label for="' + id + '">' + veilig(sensor.sleutel) + '</label>' +
          '<input type="text" id="' + id + '" maxlength="16" autocomplete="off"' +
          (sensor.voorbeeld ? ' placeholder="' + veilig(vul(T.names_example, { voorbeeld: sensor.voorbeeld })) + '"' : '') + '>');
        var invoer = veld.querySelector('input');
        invoer.value = service.namen[sensor.sleutel] || '';
        invoer.setAttribute('data-vb-sleutel', sensor.sleutel);
        invoer.addEventListener('input', function () {
          service.namen[sensor.sleutel] = invoer.value;
          toonServiceFout('');
        });
        velden.appendChild(veld);
      });
    }

    /**
     * Geeft false en toont waarom als de service nog niet compleet is
     * ingevuld. Alleen de keuze (namen of geen namen) is verplicht; een
     * naamveld leeg laten mag.
     */
    function serviceKlopt() {
      if (!service || !service.aan) return true;
      if (!service.modus) {
        toonServiceFout(T.names_choose_first);
        serviceEl.scrollIntoView({ behavior: rustig ? 'auto' : 'smooth', block: 'center' });
        return false;
      }
      toonServiceFout('');
      return true;
    }

    function serviceRegelVoorWinkelwagen() {
      var r = reken();
      if (!service || !service.aan || !r.serviceVariant) return null;
      var set = presets.filter(function (p) { return p.key === actief; })[0];
      var kantRij = kantRijen.filter(function (rij) { return rij.aantal > 0; })[0];
      var eigenschappen = {};
      eigenschappen[T.prop_service] = T.prop_yes;
      eigenschappen[T.prop_for] = kantRij
        ? kantRij.product.titel + (kantRij.variant.titel ? ' – ' + kantRij.variant.titel : '')
        : data.blokNaam + (set ? ' – ' + set.label : '');
      // Alleen ingevulde namen gaan mee. Is er niets ingevuld, dan is dat
      // hetzelfde als "geen namen"; is een deel ingevuld, dan staat erbij dat
      // de rest genummerd wordt.
      var lijst = sensoren();
      var ingevuld = service.modus === 'namen'
        ? lijst.filter(function (sensor) { return String(service.namen[sensor.sleutel] || '').trim(); })
        : [];
      if (!ingevuld.length) {
        eigenschappen[T.prop_labels] = T.prop_no_names;
      } else {
        if (ingevuld.length < lijst.length) eigenschappen[T.prop_labels] = T.prop_rest_numbered;
        ingevuld.forEach(function (sensor) {
          eigenschappen[sensor.sleutel] = String(service.namen[sensor.sleutel]).trim();
        });
      }
      return { id: r.serviceVariant.id, quantity: 1, properties: eigenschappen };
    }

    if (serviceEl) {
      serviceEl.querySelector('[data-vb-service]').addEventListener('change', function (event) {
        var aan = event.target.checked;
        wijzig(function () {
          service.aan = aan;
          if (!aan) service.modus = '';
          toonServiceFout('');
        });
      });
      Array.prototype.forEach.call(serviceEl.querySelectorAll('[data-vb-modus]'), function (knopje) {
        knopje.addEventListener('click', function () {
          wijzig(function () {
            service.modus = knopje.getAttribute('data-vb-modus');
            toonServiceFout('');
          });
        });
      });
    }

    /** Eén plek waar elke wijziging doorheen gaat: meten, wijzigen, tekenen, schuiven. */
    function wijzig(actie, mogelijkeVlieger) {
      var plekVoor = mogelijkeVlieger ? mogelijkeVlieger.plek : '';
      var voor = meet();
      actie();
      plaats();
      rijen.forEach(werkRijBij);
      werkServiceBij();
      werkTotaalBij();
      zetStatus('', '');
      var vlieger = mogelijkeVlieger && mogelijkeVlieger.plek !== plekVoor ? mogelijkeVlieger : null;
      schuif(voor, vlieger);
    }

    // ── Winkelwagen ──
    var bezig = false;

    function zetStatus(tekst, soort) {
      status.textContent = tekst;
      status.className = 'neroo-vb2__status' + (soort ? ' is-' + soort : '');
    }

    // Het pad bepaalt de taal, niet Shopify.routes.root: die staat op deze
    // winkel op "/en/" terwijl de pagina Nederlands is.
    var deel = (window.location.pathname.split('/')[1] || '').toLowerCase();
    var taalPad = (data.talen || []).indexOf(deel) !== -1 && deel !== '' ? '/' + deel : '';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root !== taalPad + '/') {
      window.Shopify.routes.root = taalPad + '/';
    }

    function openWinkelwagen() {
      return fetch(taalPad + '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          ['cart:updated', 'cart:refresh', 'cart-drawer:open'].forEach(function (naam) {
            try { document.dispatchEvent(new CustomEvent(naam, { bubbles: true, detail: { cart: cart } })); } catch (x) {}
            try { window.dispatchEvent(new CustomEvent(naam, { detail: { cart: cart } })); } catch (x) {}
          });
          var lade = document.querySelector('m-cart-drawer');
          var opener = document.querySelector(
            '.m-cart-drawer-button, [data-open-cart-drawer], .m-cart-icon-bubble, .m-header__icon--cart, a.m-header__icon[href*="/cart"]'
          );
          if (opener) setTimeout(function () { opener.click(); }, 150);
          else if (lade && typeof lade.open === 'function') lade.open();
        })
        .catch(function () {});
    }

    function voegToeAanWinkelwagen() {
      if (bezig) return;
      // De regels horen bij elkaar, net als op de productpagina: zelfde
      // samenstelling, de set of het paneel is de hoofdregel. Geen _setify_vb:
      // de drempelkorting van het verkoopblok geldt hier niet. Bijkoop uit een
      // groep met een stapelkorting krijgt het id van die regel; de korting
      // "Stapelkorting" telt hem in de checkout.
      // Zonder set of paneel (accessoirepagina) krijgen alle regels rol
      // "los": dan telt alles mee voor de stapelkorting.
      var hoofd = hoofdRij();
      var samenstelling = 'vb2-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var items = rijen
        .filter(function (rij) { return rij.aantal > 0 && leverbaar(rij); })
        .map(function (rij) {
          var eigenschappen = { _neroo_selection: samenstelling };
          if (hoofd) {
            eigenschappen._neroo_product = String(hoofd.product.id);
            eigenschappen._neroo_role = rij === hoofd ? 'main' : 'extra';
          } else {
            eigenschappen._neroo_role = 'los';
          }
          var stapel = stapelVan(rij, hoofd);
          if (stapel) eigenschappen._setify_stapel = stapel.id;
          return { id: rij.variant.id, quantity: rij.aantal, properties: eigenschappen };
        });
      if (!items.length) { zetStatus(T.empty, 'fout'); return; }

      if (!serviceKlopt()) return;
      var serviceRegel = serviceRegelVoorWinkelwagen();
      if (serviceRegel) items.push(serviceRegel);

      bezig = true;
      knop.disabled = true;
      plakKnop.disabled = true;
      knop.classList.add('is-bezig');
      knopTekst.textContent = T.adding;
      zetStatus('', '');

      fetch(taalPad + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (res.ok) return res.json();
          return res.json().then(function (fout) {
            throw new Error((fout && (fout.description || fout.message)) || T.error);
          });
        })
        .then(function () {
          if (data.naToevoegen === 'checkout') {
            window.location.href = taalPad + '/checkout';
            return;
          }
          zetStatus(T.added, 'succes');
          return openWinkelwagen();
        })
        .catch(function (fout) {
          zetStatus((fout && fout.message) || T.error, 'fout');
        })
        .then(function () {
          bezig = false;
          knop.classList.remove('is-bezig');
          knopTekst.textContent = T.add_to_cart;
          var leeg = reken().stuks === 0;
          knop.disabled = leeg;
          plakKnop.disabled = leeg;
        });
    }

    knop.addEventListener('click', voegToeAanWinkelwagen);
    plakKnop.addEventListener('click', voegToeAanWinkelwagen);

    // ── Vaste balk op mobiel: alleen als de kaart in beeld is en de knop niet ──
    if ('IntersectionObserver' in window) {
      var kaartInBeeld = false, knopInBeeld = false;
      var werkPlakBij = function () {
        var toon = kaartInBeeld && !knopInBeeld;
        plak.classList.toggle('is-zichtbaar', toon);
        plak.setAttribute('aria-hidden', toon ? 'false' : 'true');
      };
      var kaartKijker = new IntersectionObserver(function (e) { kaartInBeeld = e[0].isIntersecting; werkPlakBij(); });
      var knopKijker = new IntersectionObserver(function (e) { knopInBeeld = e[0].isIntersecting; werkPlakBij(); });
      kaartKijker.observe(kaart);
      knopKijker.observe(knop);
      waarnemers.push(kaartKijker, knopKijker);
    }

    // ── Zwevende kortingsbalk ──
    // De balk is sticky (zie CSS). Hier alleen: onder een zichtbare
    // menubalk blijven, een schaduw tonen als hij zweeft, en wegvagen zodra
    // de knop "In winkelwagen" in beeld is.
    var zweefAan = Boolean(balk && sectie.classList.contains('neroo-vb2--zwevend'));
    var zweefLus = 0;
    var zweefTot = 0;
    var zweefTop = -1;

    /** Onderkant van een vaste menubalk bovenin (of 0 als die er niet is). */
    function menubalkOnder() {
      if (!document.elementsFromPoint) return 0;
      var lijst = document.elementsFromPoint(window.innerWidth / 2, 2);
      for (var i = 0; i < lijst.length; i++) {
        for (var e = lijst[i]; e && e !== document.body && e !== document.documentElement; e = e.parentElement) {
          if (sectie.contains(e)) break;
          var positie = getComputedStyle(e).position;
          if (positie !== 'fixed' && positie !== 'sticky') continue;
          var vak = e.getBoundingClientRect();
          if (vak.top <= 2 && vak.height >= 30 && vak.height <= 200) return Math.max(0, Math.round(vak.bottom));
          break;
        }
      }
      return 0;
    }

    function zweefStap() {
      zweefLus = 0;
      var top = menubalkOnder() + 12;
      if (top !== zweefTop) {
        zweefTop = top;
        balk.style.setProperty('--vb-zweef-top', top + 'px');
      }
      var plakt = balk.getBoundingClientRect().top <= top + 1 && kaart.getBoundingClientRect().top < top - 1;
      balk.classList.toggle('is-zwevend', plakt);
      balk.classList.toggle('is-weg', plakt && Boolean(knopInBeeld));
      // Nog even doorgaan na de laatste scroll: een menubalk die in- of
      // uitschuift beweegt nog na.
      if (Date.now() < zweefTot) zweefLus = requestAnimationFrame(zweefStap);
    }

    function zweefBijScroll() {
      zweefTot = Date.now() + 450;
      if (!zweefLus) zweefLus = requestAnimationFrame(zweefStap);
    }

    if (zweefAan) {
      window.addEventListener('scroll', zweefBijScroll, { passive: true });
      window.addEventListener('resize', zweefBijScroll);
      zweefBijScroll();
    }

    // Liggen twee drempels dicht bij elkaar, dan passen hun bedragen niet
    // naast elkaar onder de balk. De rechter blijft, de linker verdwijnt.
    function schikLabels() {
      if (!balk) return;
      var labels = Array.prototype.slice.call(balk.querySelectorAll('.neroo-vb2__balk-label'));
      var rand = balk.getBoundingClientRect();
      var gemeten = rand.width >= 120;
      var grens = Infinity;
      for (var i = labels.length - 1; i >= 0; i--) {
        labels[i].classList.remove('is-verborgen');
        labels[i].classList.remove('is-rechts');
        // Zonder breedte (sectie nog niet in beeld) valt er niets te meten.
        if (!gemeten) continue;
        var vak = labels[i].getBoundingClientRect();
        // Een breed bedrag onder het laatste bolletje mag niet buiten de
        // balk steken.
        if (vak.right > rand.right - 4) {
          labels[i].classList.add('is-rechts');
          vak = labels[i].getBoundingClientRect();
        }
        if (vak.right + 6 > grens) labels[i].classList.add('is-verborgen');
        else grens = vak.left;
      }
    }

    // ── Stippellijn van de gekozen set naar "Je bestelling" ──
    // Loopt van achter de gekozen setkaart naar het midden van het groene
    // vlak. Bij de middelste set recht omlaag, anders met twee bochtjes in de
    // ruimte tussen de kaarten en de kop "Je bestelling". De streepjes lopen
    // richting de bestelling (CSS). Posities via offsetTop/offsetLeft: die
    // tellen de schuif-animaties niet mee.
    var setlijn = null, setlijnPad = null, setlijnVorige = '';
    if (setModus && lijstBlok && setKnoppen.length) {
      var SVG = 'http://www.w3.org/2000/svg';
      setlijn = document.createElementNS(SVG, 'svg');
      setlijn.setAttribute('class', 'neroo-vb2__setlijn');
      setlijn.setAttribute('aria-hidden', 'true');
      setlijn.setAttribute('focusable', 'false');
      setlijnPad = document.createElementNS(SVG, 'path');
      setlijnPad.setAttribute('fill', 'none');
      setlijn.appendChild(setlijnPad);
      kaart.appendChild(setlijn);
    }

    function plekInKaart(elem) {
      var x = 0, y = 0;
      for (var e = elem; e && e !== kaart; e = e.offsetParent) { x += e.offsetLeft; y += e.offsetTop; }
      return { x: x, y: y, w: elem.offsetWidth, h: elem.offsetHeight };
    }

    function tekenSetlijn() {
      if (!setlijn) return;
      var gekozen = setKnoppen.filter(function (s) { return s.knop.classList.contains('is-actief'); })[0];
      if (!gekozen || lijstBlok.hidden || kaart.offsetWidth < 50) { setlijnPad.setAttribute('d', ''); setlijnVorige = ''; return; }
      var rond = function (n) { return Math.round(n * 10) / 10; };
      var kaartje = plekInKaart(gekozen.knop);
      var vlak = plekInKaart(lijstBlok);
      // Begin en eind een paar pixels achter de kaart en het vlak.
      var x1 = kaartje.x + kaartje.w / 2, y1 = kaartje.y + kaartje.h - 6;
      var x2 = vlak.x + vlak.w / 2, y2 = vlak.y + 6;
      var midden = (kaartje.y + kaartje.h + vlak.y) / 2;
      var d = 'M' + rond(x1) + ' ' + rond(y1);
      var afstand = Math.abs(x2 - x1);
      // Middelste set: recht omlaag, zonder halve pixel scheef.
      if (afstand < 2) x2 = x1;
      if (afstand >= 2) {
        var kant = x2 > x1 ? 1 : -1;
        var r = Math.max(0, Math.min(12, midden - (kaartje.y + kaartje.h), afstand / 2));
        d += ' L' + rond(x1) + ' ' + rond(midden - r) +
          ' A' + rond(r) + ' ' + rond(r) + ' 0 0 ' + (kant > 0 ? 0 : 1) + ' ' + rond(x1 + kant * r) + ' ' + rond(midden) +
          ' L' + rond(x2 - kant * r) + ' ' + rond(midden) +
          ' A' + rond(r) + ' ' + rond(r) + ' 0 0 ' + (kant > 0 ? 1 : 0) + ' ' + rond(x2) + ' ' + rond(midden + r);
      }
      d += ' L' + rond(x2) + ' ' + rond(y2);
      setlijn.setAttribute('viewBox', '0 0 ' + kaart.offsetWidth + ' ' + kaart.offsetHeight);
      if (d === setlijnVorige) return;
      // Andere set gekozen: de lijn komt even opnieuw in beeld.
      var andereSet = setlijnVorige && setlijnVorige.split(' ')[0] !== d.split(' ')[0];
      setlijnVorige = d;
      setlijnPad.setAttribute('d', d);
      if (andereSet && !rustig) {
        setlijn.classList.remove('is-nieuw');
        void setlijn.getBoundingClientRect();
        setlijn.classList.add('is-nieuw');
      }
    }

    if (setlijn) {
      if ('ResizeObserver' in window) {
        var lijnKijker = new ResizeObserver(function () { tekenSetlijn(); });
        lijnKijker.observe(kaart);
        lijnKijker.observe(kantBlok);
        lijnKijker.observe(lijstBlok);
        waarnemers.push(lijnKijker);
      }
      window.addEventListener('resize', tekenSetlijn);
    }

    // ── Eerste keer tekenen ──
    if (actief) kiesSet(actief);
    plaats();
    rijen.forEach(werkRijBij);
    werkServiceBij();
    werkTotaalBij();
    schikLabels();

    // ── Tip bij de tweede regel: "Klik op de naam voor meer informatie" ──
    // Eén keer per bezoek. Verschijnt een halve seconde nadat de tweede
    // regel van de set helemaal in beeld is, en verdwijnt na 8 seconden,
    // met het kruisje of bij een klik ergens in de kaart. Het ballonnetje
    // staat in de ruimte van de eerste regel; daar past het binnen de rand.
    var TIP_SLEUTEL = 'neroo-vb2-tip-gezien';
    var tip = null;
    var tipRij = null;
    var tipTimer = 0;
    var tipKijker = null;

    function tipAlGezien() {
      try { return window.sessionStorage.getItem(TIP_SLEUTEL) === '1'; } catch (e) { return false; }
    }

    function stopTipKijker() {
      if (tipKijker) { tipKijker.disconnect(); tipKijker = null; }
    }

    function sluitTip(meteen) {
      clearTimeout(tipTimer);
      stopTipKijker();
      if (!tip) return;
      var weg = tip;
      var rij = tipRij;
      tip = null;
      tipRij = null;
      var haalWeg = function () {
        if (weg.parentNode) weg.parentNode.removeChild(weg);
        if (rij) rij.classList.remove('heeft-tip');
      };
      if (meteen) { haalWeg(); return; }
      weg.classList.remove('is-zichtbaar');
      setTimeout(haalWeg, 220);
    }

    function toonTip() {
      var rij = setLijst.children[1];
      var titel = rij && rij.querySelector('.neroo-vb2__rij-titel');
      if (!titel || tip) return;
      try { window.sessionStorage.setItem(TIP_SLEUTEL, '1'); } catch (e) { /* dan elke keer */ }

      tip = el('div', 'neroo-vb2__tip',
        '<span class="neroo-vb2__tip-tekst">' + ICOON.info + '<span>' + veilig(data.tip) + '</span></span>' +
        '<button type="button" class="neroo-vb2__tip-weg" aria-label="' + veilig(T.tip_close) + '">' + ICOON.kruis + '</button>');
      tip.setAttribute('role', 'status');
      tipRij = rij;
      rij.classList.add('heeft-tip');
      rij.appendChild(tip);

      // Het pijltje wijst naar het einde van de eerste regel van de naam.
      var vak = rij.getBoundingClientRect();
      var bereik = document.createRange();
      bereik.selectNodeContents(titel);
      var regels = bereik.getClientRects();
      var tekst = regels.length ? regels[0] : titel.getBoundingClientRect();
      var eind = tekst.right - vak.left;
      var breedte = tip.offsetWidth;
      var links = Math.max(0, Math.min(eind - breedte + 28, vak.width - breedte));
      var pijl = Math.max(16, Math.min(eind - links - 4, breedte - 16));
      tip.style.left = links + 'px';
      tip.style.top = (tekst.top - vak.top - 9) + 'px';
      tip.style.setProperty('--vb-pijl-x', pijl + 'px');

      tip.querySelector('.neroo-vb2__tip-weg').addEventListener('click', function (event) {
        event.stopPropagation();
        sluitTip();
      });
      requestAnimationFrame(function () { if (tip) tip.classList.add('is-zichtbaar'); });
      tipTimer = setTimeout(function () { sluitTip(); }, 8000);
    }

    // Meteen weg (vóór de klik zelf iets verandert), zodat een regel die
    // daarna verhuist het ballonnetje niet meeneemt.
    function sluitTipBijKlik(event) {
      if (tip && !tip.contains(event.target)) sluitTip(true);
    }

    // Alleen bij een andere breedte: op de telefoon verandert de hoogte al
    // tijdens het scrollen, als de adresbalk in- en uitschuift.
    var tipVensterBreedte = window.innerWidth;
    function sluitTipBijMaat() {
      if (window.innerWidth !== tipVensterBreedte) sluitTip(true);
    }

    if (data.tip && !tipAlGezien() && 'IntersectionObserver' in window && setLijst.children.length > 1) {
      tipKijker = new IntersectionObserver(function (items) {
        clearTimeout(tipTimer);
        if (!items[0].isIntersecting || items[0].intersectionRatio < 0.98) return;
        tipTimer = setTimeout(function () {
          stopTipKijker();
          if (!tipAlGezien()) toonTip();
        }, 500);
      // Marges: bovenin staat vaak een vaste menubalk (en het ballonnetje
      // zelf boven de regel), onderin op mobiel de vaste balk met het totaal.
      }, { threshold: [0, 1], rootMargin: '-130px 0px -90px 0px' });
      tipKijker.observe(setLijst.children[1]);
      kaart.addEventListener('click', sluitTipBijKlik, true);
      window.addEventListener('resize', sluitTipBijMaat);
    }

    // Opnieuw schikken zodra de balk van breedte verandert. Dat gebeurt niet
    // alleen bij het verkleinen van het venster, maar ook als de sectie eerst
    // onzichtbaar of zonder breedte is opgebouwd.
    var schikTimer = 0;
    var schikLater = function () {
      clearTimeout(schikTimer);
      schikTimer = setTimeout(schikLabels, 120);
    };
    if (balk) {
      if ('ResizeObserver' in window) {
        var balkKijker = new ResizeObserver(schikLater);
        balkKijker.observe(balk);
        waarnemers.push(balkKijker);
      } else {
        window.addEventListener('resize', schikLater);
      }
    }

    return function opruimen() {
      sluitTip(true);
      if (lade) {
        if (lade.open) lade.close();
        if (lade.parentNode) lade.parentNode.removeChild(lade);
      }
      kaart.removeEventListener('click', sluitTipBijKlik, true);
      window.removeEventListener('scroll', zweefBijScroll);
      window.removeEventListener('resize', zweefBijScroll);
      if (zweefLus) cancelAnimationFrame(zweefLus);
      window.removeEventListener('resize', sluitTipBijMaat);
      waarnemers.forEach(function (w) { w.disconnect(); });
      window.removeEventListener('resize', schikLater);
      window.removeEventListener('resize', tekenSetlijn);
      if (setlijn && setlijn.parentNode) setlijn.parentNode.removeChild(setlijn);
      clearTimeout(schikTimer);
      if (plak.parentNode) plak.parentNode.removeChild(plak);
    };
  }

  /**
   * Google-score in het linkerblok. Eén fetch per pagina, gedeeld met de
   * andere neroo-secties via window.__nerooReviewsCache.
   */
  function startReviews(sectie) {
    var blok = sectie.querySelector('[data-vb-reviews]:not([data-vb-klaar])');
    if (!blok) return;
    blok.setAttribute('data-vb-klaar', '1');

    var url = blok.getAttribute('data-proxy');
    if (!url || !window.fetch) return;

    window.__nerooReviewsCache = window.__nerooReviewsCache || {};
    if (!window.__nerooReviewsCache[url]) {
      window.__nerooReviewsCache[url] = fetch(url).then(function (r) { return r.json(); });
    }

    window.__nerooReviewsCache[url].then(function (data) {
      if (!data || typeof data.rating !== 'number') return;
      var score = data.rating.toFixed(1).replace('.', ',');
      blok.querySelector('[data-vb-reviews-score]').textContent = score;

      // Afronden op hele sterren, net als in de andere secties (4,8 = 5 vol).
      var vol = Math.round(data.rating), sterren = '';
      for (var i = 1; i <= 5; i++) {
        sterren += '<span' + (i <= vol ? '' : ' class="neroo-vb2__reviews-ster--leeg"') + '>★</span>';
      }
      blok.querySelector('[data-vb-reviews-sterren]').innerHTML = sterren;

      if (data.total) {
        blok.querySelector('[data-vb-reviews-tekst]').textContent =
          vul(blok.getAttribute('data-sjabloon'), { aantal: data.total });
      }
    }).catch(function () {});
  }

  /**
   * Slinger: de stippellijn die de punten om en om verbindt. Van elke cirkel
   * loopt hij omlaag, met een bocht door de ruimte tussen twee punten naar de
   * overkant, en met een bocht de volgende cirkel in.
   */
  function startSlinger(sectie) {
    var laag = sectie.querySelector('[data-vb-slinger]:not([data-vb-klaar])');
    if (!laag) return;
    laag.setAttribute('data-vb-klaar', '');

    var lijst = laag.parentNode;
    var svg = laag.querySelector('svg');
    var pad = laag.querySelector('path');
    var STRAAL = 44;

    function rond(getal) { return Math.round(getal * 10) / 10; }

    function teken() {
      var punten = Array.prototype.filter.call(lijst.children, function (li) {
        return li !== laag && li.querySelector('.neroo-vb2__cirkel');
      });
      var breedte = lijst.clientWidth, hoogte = lijst.clientHeight;
      // Zonder breedte (sectie nog niet in beeld) valt er niets te meten.
      if (breedte < 120 || punten.length < 2) { pad.setAttribute('d', ''); return; }
      svg.setAttribute('viewBox', '0 0 ' + breedte + ' ' + hoogte);

      // offsetTop en offsetLeft trekken zich niets aan van de verschuiving
      // waarmee de punten in beeld komen.
      var plekken = punten.map(function (li) {
        var cirkel = li.querySelector('.neroo-vb2__cirkel');
        return {
          x: li.offsetLeft + cirkel.offsetLeft + cirkel.offsetWidth / 2,
          y: li.offsetTop + cirkel.offsetTop + cirkel.offsetHeight / 2,
          boven: li.offsetTop,
          onder: li.offsetTop + li.offsetHeight
        };
      });

      var d = 'M' + rond(plekken[0].x) + ' ' + rond(plekken[0].y);
      for (var i = 1; i < plekken.length; i++) {
        var van = plekken[i - 1], naar = plekken[i];
        var afstand = Math.abs(naar.x - van.x);
        // Staan twee cirkels recht onder elkaar, dan is de lijn gewoon recht.
        if (afstand >= 2) {
          var kant = naar.x > van.x ? 1 : -1;
          var midden = (van.onder + naar.boven) / 2;
          var r1 = Math.max(0, Math.min(STRAAL, midden - van.y, afstand / 2));
          var r2 = Math.max(0, Math.min(STRAAL, naar.y - midden, afstand / 2));
          d += ' L' + rond(van.x) + ' ' + rond(midden - r1) +
            ' A' + rond(r1) + ' ' + rond(r1) + ' 0 0 ' + (kant > 0 ? 0 : 1) + ' ' + rond(van.x + kant * r1) + ' ' + rond(midden) +
            ' L' + rond(naar.x - kant * r2) + ' ' + rond(midden) +
            ' A' + rond(r2) + ' ' + rond(r2) + ' 0 0 ' + (kant > 0 ? 1 : 0) + ' ' + rond(naar.x) + ' ' + rond(midden + r2);
        }
        d += ' L' + rond(naar.x) + ' ' + rond(naar.y);
      }
      pad.setAttribute('d', d);
    }

    teken();
    if ('ResizeObserver' in window) new ResizeObserver(teken).observe(lijst);
    else window.addEventListener('resize', teken);
  }

  function startAlles(bereik) {
    Array.prototype.forEach.call((bereik || document).querySelectorAll('[data-neroo-vb2]'), function (sectie) {
      startSlinger(sectie);
      startReviews(sectie);
      start(sectie);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { startAlles(); });
  } else {
    startAlles();
  }

  document.addEventListener('shopify:section:load', function (event) { startAlles(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
